/**-----------------------------------------------------------------------------------------
* Copyright © 2023 Progress Software Corporation. All rights reserved.
* Licensed under commercial license. See LICENSE.md in the package root for more information
*-------------------------------------------------------------------------------------------*/
"use client";
import * as t from "react";
import Z from "prop-types";
import { ZonedDate as te, getDate as Ye, MS_PER_DAY as Ge, toLocalDate as Ir, timezoneNames as Io, cloneDate as To, Day as lt, addDays as gt, firstDayInWeek as En, firstDayOfMonth as xo, lastDayOfMonth as Mo, MS_PER_MINUTE as zo, addMonths as Ca } from "@progress/kendo-date-math";
import { getter as Te, setter as Ao, classNames as he, useWindow as Ka, useAsyncFocusBlur as No, noop as Ue, IconWrap as Me, COLLECTION_ACTION as yn, useCollection as ba, clone as ce, canUseDOM as Tr, Keys as He, useDir as en, useDraggable as Kt, useId as Fo, validatePackage as _o, shouldShowValidationUI as Lo, useRtl as Oo, WatermarkOverlay as Po } from "@progress/kendo-react-common";
import { orderBy as Ua, filterBy as po } from "@progress/kendo-data-query";
import { useInternationalization as $e, useLocalization as Fe } from "@progress/kendo-react-intl";
import { Toolbar as $a, ToolbarItem as xr, Button as Re, DropDownButton as Wo, ButtonGroup as Mr, ToolbarSpacer as Ho } from "@progress/kendo-react-buttons";
import { Calendar as Vo, DatePicker as Kn, DateTimePicker as Un } from "@progress/kendo-react-dateinputs";
import { Popup as Ko } from "@progress/kendo-react-popup";
import { calendarIcon as Uo, caretAltDownIcon as $o, saveIcon as Bo, cancelIcon as Go, xIcon as Ba, caretAltLeftIcon as Rt, caretAltRightIcon as It, arrowRotateCwIcon as zr, arrowsNoRepeatIcon as Ga, moreHorizontalIcon as Yo, clockIcon as qo, nonRecurrenceIcon as Zo } from "@progress/kendo-svg-icons";
import * as wn from "react-dom";
import { FieldWrapper as Ce, Field as ue, FormElement as Xo, Form as jo } from "@progress/kendo-react-form";
import { DialogActionsBar as Ar, Dialog as Nr } from "@progress/kendo-react-dialogs";
import { Label as ve, Error as Ft } from "@progress/kendo-react-labels";
import { NumericTextBox as hn, RadioGroup as Ln, Input as Qo, Checkbox as On, TextArea as Jo } from "@progress/kendo-react-inputs";
import { ComboBox as ec, DropDownList as bt, MultiSelect as tc } from "@progress/kendo-react-dropdowns";
import { parseRule as Ya, expand as nc, serializeRule as rc } from "@progress/kendo-recurrence";
const qa = (e, n = 0, r = 0, o = []) => {
  if (e.length <= n)
    return [o];
  let a = [];
  return e[n].data.map((c) => {
    a.push(
      ...qa(
        e,
        n + 1,
        r + 1,
        [...o, {
          ...c,
          field: e[n].field,
          valueField: e[n].valueField,
          colorField: e[n].colorField,
          multiple: e[n].multiple
        }]
      )
    );
  }), a;
};
function Fr(e, n) {
  const r = [];
  if (!n || !n.length)
    return r;
  if (e && e.resources && e.resources.length) {
    const o = e.resources;
    for (let a = 0; a < o.length; a++) {
      const c = n.find((l) => l.name === o[a]);
      r.push(c);
    }
  }
  return r;
}
const Za = (e, n = e.length - 1) => {
  const r = Math.max(0, n), o = [];
  e && e.length || (e = [{}]);
  const a = (e[r].data || []).map((s) => ({ ...s, text: s[e[r].textField] })) || [], c = a.length;
  let l = 1;
  for (let s = 0; s <= r; s++)
    l *= (e[s].data || []).length || 1;
  for (let s = 0; s < l; s++)
    a[s % c] && o.push(a[s % c]);
  return o;
}, Ke = (e) => {
  if (!e)
    return { top: 0, left: 0, width: 0, height: 0, right: 0 };
  const n = e.offsetTop, r = e.offsetLeft, o = e.offsetParent ? e.offsetParent.offsetWidth - (e.offsetLeft + e.offsetWidth) : 0, a = e.offsetWidth, c = e.offsetHeight;
  return {
    top: n,
    left: r,
    right: o,
    width: a,
    height: c
  };
}, _r = (e, n = !1) => parseFloat(window.getComputedStyle(e)[n ? "paddingLeft" : "paddingTop"] || "0") + parseFloat(window.getComputedStyle(e)[n ? "paddingRight" : "paddingBottom"] || "0"), ac = (e, n = !1) => parseFloat(window.getComputedStyle(e)[n ? "borderLeftWidth" : "borderTopWidth"] || "0") + parseFloat(window.getComputedStyle(e)[n ? "borderRightWidth" : "borderBottomWidth"] || "0"), _t = (e, n, r = !1) => {
  e && (n.top !== void 0 && (e.style.top = `${n.top}px`), n.left !== void 0 && (e.style.left = `${n.left}px`), n.width !== void 0 && (e.style.width = `${n.width}px`), n.height !== void 0 && !r && (e.style.height = typeof n.height == "number" ? `${n.height}px` : n.height), r && (e.style.minHeight = n.height !== void 0 && n.height > 0 ? `${n.height}px` : ""));
}, lc = 1e3, $n = 60 * lc, be = 1, tt = 7, oc = [{}], cc = {
  index: 0,
  resources: []
}, Ra = new Date(1900, 0, 1), Ia = new Date(2099, 11, 31);
te.fromLocalDate(Ra), te.fromLocalDate(Ia);
var ze = /* @__PURE__ */ ((e) => (e[e.create = 0] = "create", e[e.update = 1] = "update", e[e.remove = 2] = "remove", e))(ze || {});
const Et = (e) => e[0], Ut = (e) => e[e.length - 1], sc = (e) => {
  const n = /* @__PURE__ */ new Set();
  return e.forEach((r) => {
    n.add(r.field);
  }), n.size === e.length;
};
function ic(e, n, r, o) {
  const a = { skeleton: "yMMMMEEEEdhm" }, c = { skeleton: "yMMMMEEEEd" }, l = "t";
  return o ? `${e.formatDate(n, c)}` : `${e.formatDate(n, a)}–${e.formatDate(r, l)}`;
}
const dc = () => Ye(/* @__PURE__ */ new Date()), nt = (e, n, r, o = 0) => {
  if (o === r)
    return null;
  let a = null;
  const c = document.elementFromPoint(e, n);
  if (!c)
    return a;
  if (c.getAttribute("data-slot") === "true")
    return c;
  {
    const s = c.style.pointerEvents;
    c.style.pointerEvents = "none", a = nt(e, n, r, o + 1), c.style.pointerEvents = s;
  }
  return a;
}, q = (e, n) => Te(n)(e), j = (e, n, r) => {
  if (n)
    return Ao(n)(e, r);
}, ot = (e) => e != null;
function Ne(e) {
  return new Date(Date.UTC(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  ));
}
const ht = (e, n, r) => {
  const o = Lr(e, n) ? q(e, n.id) : q(e, n.recurrenceId);
  return r.find((a) => q(a, n.id) === o);
}, Lr = (e, n) => {
  const r = q(e, n.id), o = q(e, n.recurrenceId), a = q(e, n.recurrenceRule);
  return !!(r && a && o == null);
}, Ta = (e, n) => Math.max(e.getTime(), n.getTime()), xa = (e, n) => Math.min(e.getTime(), n.getTime()), Oe = (e, n, r, o, a = !1) => a ? Ta(n, o) - xa(e, r) <= n.getTime() - e.getTime() + (o.getTime() - r.getTime()) : Ta(n, o) - xa(e, r) < n.getTime() - e.getTime() + (o.getTime() - r.getTime()), Xa = {
  id: "id",
  start: "start",
  startTimezone: "startTimezone",
  originalStart: "originalStart",
  end: "end",
  endTimezone: "endTimezone",
  isAllDay: "isAllDay",
  title: "title",
  description: "description",
  recurrenceRule: "recurrenceRule",
  recurrenceId: "recurrenceId",
  recurrenceExceptions: "recurrenceExceptions"
}, uc = (e) => ({ fields: { ...Xa, ...e } }), Ve = (e, n, r) => (n.getHours() < e.getHours() || n.getHours() === e.getHours() && n.getMinutes() <= e.getMinutes()) && (e.getHours() < r.getHours() || r.getHours() === e.getHours() && e.getMinutes() < r.getMinutes()), ja = (e, n, r) => n < r ? n <= e && e <= r : e <= r || n <= e, mc = (e, n) => {
  const r = Fr(e, n), o = qa(r);
  return o.length === 1 ? [{
    index: 0,
    // resources: []
    resources: (n || []).reduce(
      (a, c) => [...a, ...c.data.map((l) => ({
        ...l,
        field: c.field,
        valueField: c.valueField,
        colorField: c.colorField,
        multiple: c.multiple
      }))],
      []
    )
  }] : o.map((a, c) => ({
    index: c,
    resources: a
  }));
}, hc = (e) => e == null, fc = (e) => hc(e) || e.trim && e.trim().length === 0, Qa = (e) => {
  let n = 0;
  const r = e.slice();
  return r.sort((o, a) => o - a).forEach((o, a) => {
    r[a] === a && (n = a + 1);
  }), n;
}, Ja = (e, n, r, o = !1) => {
  let a;
  return r.forEach((c) => {
    const l = [];
    n.sort((d, i) => d.props.start.getTime() - i.props.start.getTime()).forEach((d) => {
      if ((o || d.props.isAllDay === c.current.props.isAllDay) && d.props.range.index === c.current.props.range.index && d.props.group.index === c.current.props.group.index && Oe(d.props.start, d.props.end, c.current.props.start, c.current.props.end)) {
        const u = Qa(l);
        d === e && a === void 0 && (a = u), l.splice(u, 0, u);
      }
    });
  }), a;
}, $t = (e, n, r = !1) => {
  n.forEach((o) => o.items.splice(0, o.items.length)), n.forEach((o) => {
    const a = [];
    e.forEach((c) => {
      if ((r || c.isAllDay === o.isAllDay) && c.range.index === o.range.index && c.group.index === o.group.index && Oe(c.start, c.end, o.start, o.end)) {
        const s = Qa(a);
        (c.order === null || c.order === void 0 || c.order < s) && (c.order = s), a.splice(c.order, 0, c.order), o.items.push(c);
      }
    });
  });
}, Tt = (e, n, r = !1) => {
  e.forEach((o) => o.slots.splice(0, o.slots.length)), e.forEach((o) => {
    n.forEach((a) => {
      (r || o.isAllDay === a.isAllDay) && o.range.index === a.range.index && o.group.index === a.group.index && Oe(o.start, o.end, a.start, a.end) && o.slots.push(a);
    });
  });
}, st = (...e) => {
}, gc = (e) => {
  const n = e.props.items.find((r) => r.order === 0) || e.props.items[0];
  return n && n._ref.current;
}, vn = (e, n, r = !1, o = !1) => {
  const a = e.current;
  if (!a || !n)
    return null;
  const c = n.filter((i) => i.current !== null && i.current.element !== null), l = Ua(
    c,
    [
      { field: "current.props.group.index", dir: "asc" },
      { field: "current.props.range.index", dir: "asc" },
      r ? { field: "" } : { field: "current.props.isAllDay", dir: "desc" },
      { field: "current.props.start", dir: "asc" }
    ]
  ), s = l.findIndex((i) => i.current !== null && !!(i.current.props.uid === a.props.uid && (i.current.props.occurrenceId === void 0 || i.current.props.occurrenceId === a.props.occurrenceId) && i.current.props.group.index === a.props.group.index && i.current.props.range.index === a.props.range.index && (r || i.current.props.isAllDay === a.props.isAllDay)));
  return l[s + (o ? -1 : 1)];
}, el = (e, n) => (e.order || 0) - (n.order || 0), Or = t.createContext({ current: null }), tn = () => t.useContext(Or);
Or.displayName = "SchedulerElementContext";
const Cn = t.createContext({}), qe = () => t.useContext(Cn);
Cn.displayName = "SchedulerPropsContext";
const Pr = t.createContext([]), tl = () => t.useContext(Pr);
Pr.displayName = "SchedulerViewsContext";
const pr = t.createContext(Xa), Pe = () => t.useContext(pr);
pr.displayName = "SchedulerFieldsContext";
const Wr = t.createContext({ dateFormat: "{0:D}", shortDateFormat: "{0:d}" }), Ec = () => t.useContext(Wr);
Wr.displayName = "SchedulerDateFormatContext";
const Hr = t.createContext([cc]), Mt = () => t.useContext(Hr);
Hr.displayName = "SchedulerGroupsContext";
const Vr = t.createContext({ start: /* @__PURE__ */ new Date(), end: /* @__PURE__ */ new Date(), zonedStart: te.fromLocalDate(/* @__PURE__ */ new Date()), zonedEnd: te.fromLocalDate(/* @__PURE__ */ new Date()) }), vt = () => t.useContext(Vr);
Vr.displayName = "SchedulerDateRangeContext";
const Kr = t.createContext(null), Ur = () => t.useContext(Kr);
Kr.displayName = "SchedulerOrientationContext";
const $r = t.createContext([/* @__PURE__ */ new Date(), st]), nl = () => t.useContext($r);
$r.displayName = "SchedulerDateContext";
const Br = t.createContext([[], st]), Lt = () => t.useContext(Br);
Br.displayName = "SchedulerDataContext";
const Gr = t.createContext(["day", st]), Yr = () => t.useContext(Gr);
Gr.displayName = "SchedulerActiveViewContext";
const qr = t.createContext([null, () => {
}]);
qr.displayName = "SchedulerItemSelectionContext";
const yc = ({
  children: e,
  element: n,
  props: r,
  views: o,
  fields: a,
  groups: c,
  dateRange: l,
  dateFormat: s,
  orientation: d,
  date: i,
  data: u,
  activeView: m,
  selection: g
}) => /* @__PURE__ */ t.createElement(Or.Provider, { value: n }, /* @__PURE__ */ t.createElement(Cn.Provider, { value: r }, /* @__PURE__ */ t.createElement(Pr.Provider, { value: o }, /* @__PURE__ */ t.createElement(pr.Provider, { value: a }, /* @__PURE__ */ t.createElement(Wr.Provider, { value: s }, /* @__PURE__ */ t.createElement(Hr.Provider, { value: c }, /* @__PURE__ */ t.createElement(Vr.Provider, { value: l }, /* @__PURE__ */ t.createElement(Kr.Provider, { value: d }, /* @__PURE__ */ t.createElement($r.Provider, { value: i }, /* @__PURE__ */ t.createElement(Br.Provider, { value: u }, /* @__PURE__ */ t.createElement(Gr.Provider, { value: m }, /* @__PURE__ */ t.createElement(qr.Provider, { value: g }, e)))))))))))), Ae = (e, n, r) => {
  const [o, a] = t.useState(n || e), c = t.useCallback(
    (l, s) => {
      a(l), r && r.call(void 0, { ...s, value: l });
    },
    [r, a]
  );
  return [n !== void 0 ? n : o, c];
}, rl = t.forwardRef((e, n) => {
  const {
    className: r,
    ...o
  } = e, a = t.useRef(null), c = t.useRef(null);
  t.useImperativeHandle(c, () => ({ element: a.current, props: e })), t.useImperativeHandle(n, () => c.current);
  const l = t.useMemo(() => he("k-scheduler-toolbar", r), [r]);
  return /* @__PURE__ */ t.createElement(
    $a,
    {
      id: e.id,
      ref: (s) => {
        s && (a.current = s.element);
      },
      className: l,
      ...o
    },
    e.children
  );
});
rl.displayName = "KendoReactSchedulerHeader";
const Zr = t.forwardRef((e, n) => {
  const {
    className: r,
    ...o
  } = e, a = t.useRef(null);
  return t.useImperativeHandle(n, () => ({ element: a.current, props: e })), /* @__PURE__ */ t.createElement(
    xr,
    {
      ref: (c) => {
        c && (a.current = c.element);
      },
      className: he(r),
      ...o
    },
    e.children
  );
});
Zr.displayName = "KendoReactSchedulerSchedulerNavigation";
const al = t.forwardRef((e, n) => {
  const {
    className: r,
    ...o
  } = e, a = t.useRef(null);
  return t.useImperativeHandle(n, () => ({ element: a.current, props: e })), /* @__PURE__ */ t.createElement(
    xr,
    {
      ref: (c) => {
        c && (a.current = c.element);
      },
      className: he("k-scheduler-views", r),
      ...o
    },
    e.children
  );
});
al.displayName = "KendoReactSchedulerViewSelector";
const vc = t.forwardRef((e, n) => {
  const {
    className: r,
    style: o,
    ...a
  } = e, c = t.useRef(null), l = t.useRef(null);
  t.useImperativeHandle(c, () => ({ element: l.current, props: e })), t.useImperativeHandle(n, () => c.current);
  const s = t.useMemo(() => he("k-scheduler-footer", e.className), [e.className]);
  return /* @__PURE__ */ t.createElement(
    $a,
    {
      ref: (d) => {
        d && (l.current = d.element);
      },
      className: s,
      style: { boxShadow: "none", ...o },
      ...a
    },
    e.children
  );
}), Bn = "scheduler.allEvents", Bt = "scheduler.allDay", Gn = "scheduler.today", Yn = "scheduler.timelineViewTitle", qn = "scheduler.weekViewTitle", Zn = "scheduler.workWeekViewTitle", Xn = "scheduler.agendaViewTitle", jn = "scheduler.dayViewTitle", Qn = "scheduler.monthViewTitle", Gt = "scheduler.deleteTitle", Jn = "scheduler.previousTitle", er = "scheduler.nextTitle", tr = "scheduler.showFullDay", nr = "scheduler.showWorkDay", ll = "scheduler.editOccurrence", ol = "scheduler.editSeries", cl = "scheduler.editRecurringConfirmation", sl = "scheduler.editRecurringDialogTitle", rr = "scheduler.editSave", Yt = "scheduler.editCancel", ar = "scheduler.editorTitle", lr = "scheduler.editorEventTitle", or = "scheduler.editorEventStart", cr = "scheduler.editorEventStartTimeZone", sr = "scheduler.editorEventEnd", ir = "scheduler.editorEventEndTimeZone", dr = "scheduler.editorEventAllDay", ur = "scheduler.editorEventDescription", mr = "scheduler.editorEventSeparateTimeZones", hr = "scheduler.editorEventTimeZone", fr = "scheduler.recurrenceEditorRepeat", kc = "scheduler.recurrenceEditorDailyInterval", Dc = "scheduler.recurrenceEditorDailyRepeatEvery", Sc = "scheduler.recurrenceEditorWeeklyInterval", wc = "scheduler.recurrenceEditorWeeklyRepeatEvery", il = "scheduler.recurrenceEditorWeeklyRepeatOn", dl = "scheduler.recurrenceEditorMonthlyDay", Cc = "scheduler.recurrenceEditorMonthlyInterval", bc = "scheduler.recurrenceEditorMonthlyRepeatEvery", ul = "scheduler.recurrenceEditorMonthlyRepeatOn", ml = "scheduler.recurrenceEditorYearlyOf", Rc = "scheduler.recurrenceEditorYearlyRepeatEvery", hl = "scheduler.recurrenceEditorYearlyRepeatOn", Ic = "scheduler.recurrenceEditorYearlyInterval", Tc = "scheduler.recurrenceEditorFrequenciesDaily", xc = "scheduler.recurrenceEditorFrequenciesMonthly", Mc = "scheduler.recurrenceEditorFrequenciesNever", zc = "scheduler.recurrenceEditorFrequenciesWeekly", Ac = "scheduler.recurrenceEditorFrequenciesYearly", Nc = "scheduler.recurrenceEditorOffsetPositionsFirst", Fc = "scheduler.recurrenceEditorOffsetPositionsSecond", _c = "scheduler.recurrenceEditorOffsetPositionsThird", Lc = "scheduler.recurrenceEditorOffsetPositionsFourth", Oc = "scheduler.recurrenceEditorOffsetPositionsLast", Pc = "scheduler.recurrenceEditorWeekdaysDay", pc = "scheduler.recurrenceEditorWeekdaysWeekday", Wc = "scheduler.recurrenceEditorWeekdaysWeekendday", fl = "scheduler.recurrenceEditorEndAfter", gl = "scheduler.recurrenceEditorEndOccurrence", El = "scheduler.recurrenceEditorEndLabel", yl = "scheduler.recurrenceEditorEndNever", vl = "scheduler.recurrenceEditorEndOn", gr = "scheduler.editorDelete", Er = "scheduler.deleteConfirmation", kl = "scheduler.deleteRecurringConfirmation", Dl = "scheduler.deleteOccurrence", Sl = "scheduler.deleteSeries", yr = "scheduler.deleteDialogTitle", wl = "scheduler.deleteRecurringDialogTitle", vr = "scheduler.dateTitle", kr = "scheduler.timeTitle", Dr = "scheduler.eventTitle", qt = "scheduler.editorValidationRequired", Sr = "scheduler.editorValidationStart", wr = "scheduler.editorValidationEnd", Cr = "scheduler.noEvents", br = "scheduler.moreEvents", Q = {
  [qt]: "Field is required.",
  [Sr]: "Start time must be before End time.",
  [wr]: "End time must be after Start time.",
  [Bn]: "All events",
  [Bt]: "all day",
  [Gn]: "Today",
  [jn]: "Day",
  [Qn]: "Month",
  [qn]: "Week",
  [Zn]: "Work Week",
  [Yn]: "Timeline",
  [Xn]: "Agenda",
  [Gt]: "Delete",
  [Jn]: "Previous",
  [er]: "Next",
  [tr]: "Show full day",
  [nr]: "Show business hours",
  [ll]: "Edit current occurrence",
  [ol]: "Edit the series",
  [cl]: "Do you want to edit only this event occurrence or the whole series?",
  [sl]: "Edit Recurring Item",
  [rr]: "Save",
  [Yt]: "Cancel",
  [gr]: "Delete",
  [ar]: "Event",
  [lr]: "Title",
  [or]: "Start",
  [cr]: "Start Time Zone",
  [sr]: "End",
  [ir]: "End Time Zone",
  [dr]: "All Day Event",
  [ur]: "Description",
  [mr]: "End in different Time Zone",
  [hr]: "Specify Time Zone",
  [fr]: "Repeat",
  [kc]: "day(s)",
  [Dc]: "Repeat every",
  [Sc]: "week(s)",
  [wc]: "Repeat every",
  [il]: "Repeat on",
  [dl]: "Day",
  [Cc]: "month(s)",
  [bc]: "Repeat every",
  [ul]: "Repeat on",
  [ml]: "of",
  [Rc]: "Repeat every",
  [hl]: "Repeat on",
  [Ic]: "year(s)",
  [Tc]: "Daily",
  [xc]: "Monthly",
  [Mc]: "Never",
  [zc]: "Weekly",
  [Ac]: "Yearly",
  [Nc]: "First",
  [Fc]: "Second",
  [_c]: "Third",
  [Lc]: "Fourth",
  [Oc]: "Last",
  [Pc]: "Day",
  [pc]: "Weekday",
  [Wc]: "Weekend Day",
  [fl]: "After",
  [gl]: "occurrence(s)",
  [El]: "End",
  [yl]: "Never",
  [vl]: "On",
  [Er]: "Are you sure you want to delete this event?",
  [kl]: "Do you want to delete only this event occurrence or the whole series?",
  [Dl]: "Delete current occurrence",
  [Sl]: "Delete the series",
  [yr]: "Delete Event",
  [wl]: "Delete Recurring Item",
  [vr]: "Date",
  [kr]: "Time",
  [Dr]: "Event",
  [Cr]: "no events",
  [br]: "More events"
}, Cl = t.forwardRef((e, n) => {
  var V;
  const r = t.useRef(null), o = t.useRef(null);
  t.useImperativeHandle(
    n,
    () => r.current
  );
  const { timezone: a } = qe(), c = te.fromLocalDate(e.value, a), l = Ye(c), s = tn(), d = Ka(s), [i, u] = t.useState("desktop"), [m, g] = t.useState(!1), [h, y] = t.useState(!1), D = $e(), { dateFormat: C, shortDateFormat: z } = Ec(), x = vt(), [R] = nl(), L = x.end.getTime() - x.start.getTime() > Ge * 27, _ = D.format(
    C,
    L ? R : x.zonedStart,
    L ? R : x.zonedEnd.addDays(-1)
  ), O = D.format(
    z,
    L ? R : x.zonedStart,
    L ? R : x.zonedEnd.addDays(-1)
  ), f = t.useCallback(
    () => {
      g(!m);
    },
    [m]
  ), I = t.useCallback(
    () => {
      y(!0);
    },
    []
  ), b = t.useCallback(
    () => {
      g(!1), y(!1);
    },
    []
  ), A = t.useCallback(
    (p) => {
      if (e.onChange) {
        const P = te.fromUTCDate(Ne(p.value), a);
        e.onChange.call(void 0, {
          ...p,
          value: P
        });
      }
      g(!1);
    },
    [e.onChange, a]
  ), N = t.useCallback(() => {
    d().matchMedia && u(d().matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile");
  }, [d]);
  t.useEffect(() => {
    N();
    const p = d().ResizeObserver, P = p && new p(N);
    return P && P.observe(s.current), () => {
      p && P.disconnect();
    };
  }, [N, s, d]), t.useEffect(
    () => {
      m && h && o.current && o.current.focus();
    },
    [h, m]
  );
  const { onFocus: X, onBlur: F } = No({ onFocus: I, onBlur: b });
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    Re,
    {
      ref: r,
      onFocus: X,
      onBlur: F,
      fillMode: "flat",
      className: "k-nav-current",
      icon: "calendar",
      svgIcon: Uo,
      "aria-live": "polite",
      tabIndex: -1,
      onClick: f
    },
    i === "desktop" ? _ : O
  ), /* @__PURE__ */ t.createElement(
    Ko,
    {
      anchor: (V = r.current) == null ? void 0 : V.element,
      show: m
    },
    /* @__PURE__ */ t.createElement(
      Vo,
      {
        ref: o,
        onFocus: X,
        onBlur: F,
        onChange: A,
        value: l
      }
    )
  ));
});
Cl.displayName = "KendoReactSchedulerNavigationDatePicker";
const Xr = t.createContext([null]), ld = () => t.useContext(Xr);
Xr.displayName = "SchedulerEditItemPropsContext";
const jr = t.createContext([null, Ue, Ue]), od = () => t.useContext(jr);
jr.displayName = "SchedulerEditItemFormItemContext";
const Qr = t.createContext([null, Ue, Ue]), cd = () => t.useContext(Qr);
Qr.displayName = "SchedulerEditItemDragItemContext";
const Jr = t.createContext([null, Ue, Ue]), sd = () => t.useContext(Jr);
Jr.displayName = "SchedulerEditItemResizeItemContext";
const ea = t.createContext([null, Ue, Ue]), id = () => t.useContext(ea);
ea.displayName = "SchedulerEditItemRemoveItemContext";
const ta = t.createContext([!1, Ue, Ue]), dd = () => t.useContext(ta);
ta.displayName = "SchedulerEditItemShowRemoveDialogContext";
const na = t.createContext([!1, Ue, Ue]), ud = () => t.useContext(na);
na.displayName = "SchedulerEditItemShowOccurrenceDialogContext";
const Hc = ({
  props: e,
  form: n,
  drag: r,
  resize: o,
  remove: a,
  showRemoveDialog: c,
  showOccurrenceDialog: l,
  children: s
}) => /* @__PURE__ */ t.createElement(Xr.Provider, { value: e }, /* @__PURE__ */ t.createElement(jr.Provider, { value: n }, /* @__PURE__ */ t.createElement(Qr.Provider, { value: r }, /* @__PURE__ */ t.createElement(Jr.Provider, { value: o }, /* @__PURE__ */ t.createElement(ea.Provider, { value: a }, /* @__PURE__ */ t.createElement(ta.Provider, { value: c }, /* @__PURE__ */ t.createElement(na.Provider, { value: l }, s))))))), ra = t.createContext([null]), md = () => t.useContext(ra);
ra.displayName = "SchedulerEditSlotPropsContext";
const aa = t.createContext([null]), hd = () => t.useContext(aa);
aa.displayName = "SchedulerEditSlotFormItemContext";
const Vc = ({
  props: e,
  form: n,
  children: r
}) => /* @__PURE__ */ t.createElement(ra.Provider, { value: e }, /* @__PURE__ */ t.createElement(aa.Provider, { value: n }, r)), Kc = t.createContext([null]), Uc = t.createContext([!1]), $c = t.createContext([!1]), Bc = (e) => /* @__PURE__ */ t.createElement(Kc.Provider, { value: e.remove }, /* @__PURE__ */ t.createElement(Uc.Provider, { value: e.showRemoveDialog }, /* @__PURE__ */ t.createElement($c.Provider, { value: e.showOccurrenceDialog }, e.children))), bl = t.createContext({});
bl.displayName = "SchedulerViewPropsContext";
const la = t.createContext([]), Rl = () => t.useContext(la);
la.displayName = "SchedulerViewRangesContext";
const oa = t.createContext([[], st]), zt = () => t.useContext(oa);
oa.displayName = "SchedulerViewSlotsContext";
const ca = t.createContext([[], st]), nn = () => t.useContext(ca);
ca.displayName = "SchedulerViewItemsContext";
const sa = t.createContext([[], st]), Gc = () => t.useContext(sa);
sa.displayName = "SchedulerViewSelectedSlotsContext";
const ia = t.createContext([[], st]), da = () => t.useContext(ia);
ia.displayName = "SchedulerViewSelectedItemsContext";
const ua = t.createContext([[], st]), Yc = () => t.useContext(ua);
ua.displayName = "SchedulerViewFocusedItemsContext";
const ma = t.createContext([[], st]), Il = () => t.useContext(ma);
ma.displayName = "SchedulerViewFocusedSlotsContext";
const qc = ({
  children: e,
  // Static
  props: n,
  ranges: r,
  // Ref
  slots: o,
  items: a,
  // State
  // State.Selection
  selectedSlots: c,
  selectedItems: l,
  // State.Focus
  focusedItems: s,
  focusedSlots: d
}) => /* @__PURE__ */ t.createElement(bl.Provider, { value: n }, /* @__PURE__ */ t.createElement(la.Provider, { value: r }, /* @__PURE__ */ t.createElement(oa.Provider, { value: o }, /* @__PURE__ */ t.createElement(ca.Provider, { value: a }, /* @__PURE__ */ t.createElement(sa.Provider, { value: c }, /* @__PURE__ */ t.createElement(ia.Provider, { value: l }, /* @__PURE__ */ t.createElement(ua.Provider, { value: s }, /* @__PURE__ */ t.createElement(ma.Provider, { value: d }, e)))))))), Zc = (e) => {
  const [n, r] = Yr(), o = Fe(), a = t.useMemo(
    () => typeof e.view.title == "function" ? e.view.title.call(void 0, o) : e.view.title,
    [e.view.title, o]
  ), c = t.useCallback(
    () => {
      e.view.name && r(e.view.name);
    },
    [r, e.view.name]
  );
  return /* @__PURE__ */ t.createElement(
    Re,
    {
      className: "k-toolbar-button",
      role: "button",
      type: "button",
      tabIndex: -1,
      togglable: !0,
      selected: e.view.name === n,
      onClick: c
    },
    a
  );
}, Tl = t.forwardRef(() => {
  const e = t.useRef(null), [n, r] = t.useState("desktop"), o = tl(), a = Ka(e), [c, l] = Yr(), s = o.find((m) => m.props.name === c), d = Fe(), i = t.useCallback(
    (m) => {
      l && (m.syntheticEvent.preventDefault(), l(m.item.name));
    },
    [l]
  ), u = () => {
    a().matchMedia && r(a().matchMedia("(min-width: 1024px)").matches ? "desktop" : "mobile");
  };
  return t.useEffect(() => {
    u();
    const m = a().ResizeObserver, g = m && new m(u);
    return g && g.observe(e.current), () => {
      g && g.disconnect();
    };
  }, []), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: he(
        "k-toolbar-button-group k-button-group k-button-group-solid",
        {
          "k-scheduler-views": n === "desktop",
          "k-scheduler-tools": n === "mobile"
        }
      ),
      role: "group",
      ref: e
    },
    s && n === "mobile" && /* @__PURE__ */ t.createElement(
      Wo,
      {
        className: "k-views-dropdown",
        onItemClick: i,
        popupSettings: { popupClass: "k-scheduler-toolbar" },
        textField: "title",
        items: o.map((m) => ({
          ...m.props,
          selected: m.props.name === c,
          title: typeof m.props.title == "function" ? m.props.title.call(void 0, d) : m.props.title
        })),
        text: /* @__PURE__ */ t.createElement(t.Fragment, null, typeof s.props.title == "function" ? s.props.title.call(void 0, d) : s.props.title, /* @__PURE__ */ t.createElement(Me, { name: "caret-alt-down", icon: $o }))
      }
    ),
    n === "desktop" && /* @__PURE__ */ t.createElement(t.Fragment, null, o.map((m) => /* @__PURE__ */ t.createElement(Zc, { key: m.props.name, view: m.props })))
  );
});
Tl.displayName = "KendoReactSchedulerViewSelectorList";
const Xc = t.forwardRef((e, n) => {
  const {
    className: r,
    ...o
  } = e, a = t.useRef(null);
  return t.useImperativeHandle(n, () => ({ element: a.current, props: e })), /* @__PURE__ */ t.createElement(
    xr,
    {
      ref: (c) => {
        c && (a.current = c.element);
      },
      className: he("k-scheduler-navigation", r),
      ...o
    },
    e.children
  );
}), Zt = (e, n) => {
  const { element: r } = e, o = () => {
    if (!r || !r.current)
      return;
    let a = [], c = [], l = [];
    const s = r.current.querySelectorAll(e.selector);
    s.forEach((d) => {
      const i = d.getBoundingClientRect().width, u = e.explicitDepth && e.attribute !== void 0 ? d.getAttribute(e.attribute) : 0, m = _r(d, !0), g = ac(d, !0);
      u !== null && ((!l[u] || g > l[u]) && (l[u] = g), (!c[u] || m > c[u]) && (c[u] = m), (!a[u] || i > a[u]) && (a[u] = i));
    }), s.forEach((d) => {
      const i = e.explicitDepth ? d.getAttribute(e.attribute) : 0;
      i !== null && (d.style.minWidth = `${a[i] - c[i] - l[i]}px`);
    });
  };
  t.useLayoutEffect(o, n);
}, jc = (e) => e.slice(1, e.length), xl = (e, n) => {
  const { element: r } = e, o = () => {
    if (!r || !e.syncHeight)
      return;
    let a = [[]];
    Array.from(r.querySelectorAll(e.selector)).filter((s) => !s.classList.contains(jc(e.applyTo))).forEach((s) => {
      const d = s.clientHeight, i = s.getAttribute(e.horizontalAttribute), u = s.getAttribute(e.verticalAttribute);
      i === null || u === null || (a[i] || (a[i] = []), (!a[i][u] || d > a[i][u]) && (a[i][u] = d - be));
    }), Array.from(r.querySelectorAll(e.applyTo)).forEach((s) => {
      const d = s.getAttribute(e.horizontalAttribute), i = s.getAttribute(e.verticalAttribute);
      if (d === null || i === null)
        return;
      const u = _r(s), m = a[d][i] - u;
      _t(s, { height: m }, !0);
    });
  };
  t.useEffect(o, n);
}, Ot = (e) => {
  const n = t.useContext(Cn), r = e !== void 0 ? e : n.editable || !1, o = r === !0 || r !== void 0 && r !== !1 && r.edit === !0, a = r === !0 || r !== void 0 && r !== !1 && r.resize === !0, c = r === !0 || r !== void 0 && r !== !1 && r.remove === !0, l = r === !0 || r !== void 0 && r !== !1 && r.drag === !0, s = r === !0 || r !== void 0 && r !== !1 && r.add === !0, d = r === !0 || r !== void 0 && r !== !1 && r.select === !0;
  return {
    add: s,
    edit: o,
    drag: l,
    remove: c,
    resize: a,
    select: d
  };
}, Qc = (e, n) => {
  const r = t.useRef(), o = t.useRef(0), a = tn(), c = () => {
    if (!e.current)
      return;
    const d = e.current.element;
    d && (o.current = d.clientHeight);
  }, l = t.useCallback(() => {
    if (!n || !e.current)
      return;
    const d = e.current.element, i = e.current.props;
    if (!d)
      return;
    const u = _r(d);
    let m = 0;
    const g = i.items.filter((y) => y._ref.current);
    g.forEach((y) => {
      if (!y._ref.current)
        return;
      const { height: D } = Ke(y._ref.current.element);
      m += D;
    });
    const h = g.length * be * 2 + m - (u || 0) + (typeof n == "object" && n.offsetTop ? n.offsetTop : 0) + (typeof n == "object" && n.offsetBottom ? n.offsetBottom : 0);
    g.length ? h > o.current - u && _t(
      d,
      { height: h },
      !0
    ) : d && (d.style.minHeight = "");
  }, [n, e]), s = t.useCallback(() => {
    r.current !== void 0 && window.cancelAnimationFrame(r.current), r.current = window.requestAnimationFrame(() => {
      l();
    });
  }, [l]);
  t.useLayoutEffect(c, []), t.useEffect(l, [e, e.current && e.current.props, n]), t.useEffect(
    () => {
      if (!e.current)
        return;
      const u = e.current.props.items.filter((m) => m._ref.current).map((m) => {
        if (!m._ref.current || !m._ref.current.element || !a.current)
          return;
        const g = window.ResizeObserver, h = g && new g(s);
        return h && h.observe(m._ref.current.element), () => {
          h && h.disconnect();
        };
      });
      return () => {
        u.forEach((m) => m && m());
      };
    },
    [s, a, e]
  );
}, Jc = (e, n) => {
  const { _ref: r, itemRef: o } = e, a = t.useRef(null), c = t.useRef(null), [, l] = nn();
  return t.useImperativeHandle(a, () => ({ element: c.current, props: e })), t.useImperativeHandle(n, () => a.current), t.useImperativeHandle(r, () => a.current), t.useImperativeHandle(o, () => a.current), t.useLayoutEffect(
    () => (l({
      type: yn.add,
      item: a
    }), () => {
      l({
        type: yn.remove,
        item: a
      });
    })
  ), {
    item: a,
    element: c
  };
};
var Xt = /* @__PURE__ */ ((e) => (e.next = "ITEMS_FOCUS_NEXT", e.prev = "ITEMS_FOCUS_PREV", e))(Xt || {});
const es = (e) => [[], (r, o) => {
  switch (r.type) {
    case "ITEMS_FOCUS_NEXT": {
      if (!r.item || !r.item.current || !e)
        return;
      const a = vn(
        r.item,
        e,
        r.ignoreIsAllDay,
        !1
      );
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
    case "ITEMS_FOCUS_PREV": {
      if (!r.item || !r.item.current || !e)
        return;
      const a = vn(
        r.item,
        e,
        r.ignoreIsAllDay,
        !0
      );
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
  }
}];
var Le = /* @__PURE__ */ ((e) => (e.up = "SLOT_FOCUS_UP", e.down = "SLOT_FOCUS_DOWN", e.left = "SLOT_FOCUS_LEFT", e.right = "SLOT_FOCUS_RIGHT", e))(Le || {});
const ts = (e) => [[], (r, o) => {
  switch (r.type) {
    case "SLOT_FOCUS_UP": {
      if (!r.slot.current || !e)
        return;
      const a = ns(r.slot, e);
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_DOWN": {
      if (!r.slot || !e)
        return;
      const a = ls(r.slot, e);
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_LEFT": {
      if (!r.slot || !e)
        return;
      const a = rs(r.slot, e);
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
    case "SLOT_FOCUS_RIGHT": {
      if (!r.slot || !e)
        return;
      const a = as(r.slot, e);
      a && a.current && a.current.element && (o.preventDefault(), a.current.element.focus());
      break;
    }
  }
}], ns = (e, n) => n.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row - 1 && r.current.props.col === e.current.props.col), rs = (e, n) => n.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row && r.current.props.col === e.current.props.col - 1), as = (e, n) => n.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row && r.current.props.col === e.current.props.col + 1), ls = (e, n) => n.find((r) => r.current !== null && e.current !== null && r.current.props.row === e.current.props.row + 1 && r.current.props.col === e.current.props.col);
var _e = /* @__PURE__ */ ((e) => (e.select = "ITEMS_SELECT_SELECT", e.selectNext = "ITEMS_SELECT_SELECT_NEXT", e.selectPrev = "ITEMS_SELECT_SELECT_PREV", e.reset = "ITEMS_SELECT_RESET", e.add = "ITEMS_SELECT_ADD", e.remove = "ITEMS_SELECT_REMOVE", e))(_e || {});
const os = (e) => {
  const [n, r] = t.useState([]), o = t.useCallback(
    (a, c) => {
      switch (a.type) {
        case "ITEMS_SELECT_SELECT":
          if (!a.item)
            return;
          r([a.item]);
          break;
        case "ITEMS_SELECT_SELECT_NEXT": {
          if (!a.item || !a.item.current || !e)
            return;
          const l = vn(
            a.item,
            e,
            a.ignoreIsAllDay,
            !1
          );
          l && (c.preventDefault(), r([l]));
          break;
        }
        case "ITEMS_SELECT_SELECT_PREV": {
          if (!a.item || !a.item.current || !e)
            return;
          const l = vn(
            a.item,
            e,
            a.ignoreIsAllDay,
            !0
          );
          l && (c.preventDefault(), r([l]));
          break;
        }
        case "ITEMS_SELECT_RESET":
          r([]);
          break;
        case "ITEMS_SELECT_ADD":
          if (!a.item)
            return;
          n.some((l) => l === a.item) || r([...n, a.item]);
          break;
        case "ITEMS_SELECT_REMOVE":
          if (!a.item)
            return;
          r([...n.filter((l) => l !== a.item)]);
          break;
      }
    },
    [e, n]
  );
  return [n, o];
};
var ha = /* @__PURE__ */ ((e) => (e.select = "SLOTS_SELECT_SELECT", e.reset = "SLOTS_SELECT_RESET", e.add = "SLOTS_SELECT_ADD", e))(ha || {});
const cs = (e) => {
  const [n, r] = t.useState([]), o = t.useCallback(
    (a) => {
      switch (a.type) {
        case "SLOTS_SELECT_SELECT":
          if (!a.slot)
            return;
          r([a.slot]);
          break;
        case "SLOTS_SELECT_RESET":
          r([]);
          break;
        case "SLOTS_SELECT_ADD":
          if (!a.slot)
            return;
          n.some((c) => c === a.slot) || r([...n, a.slot]);
          break;
      }
    },
    [n]
  );
  return [n, o];
}, rn = t.forwardRef((e, n) => {
  const r = t.useRef(null);
  t.useImperativeHandle(n, () => r.current);
  const [o, a] = ba([]), [c, l] = ba([]), [s, d] = es(o), [i, u] = ts(c), [m, g] = os(o), [h, y] = cs(), D = t.useCallback(
    (x, R) => {
      y({ type: ha.reset }), g(x, R);
    },
    [g, y]
  ), C = t.useCallback(
    (x, R) => {
      g({ type: _e.reset }, R), y(x);
    },
    [g, y]
  ), z = t.useMemo(
    () => he("k-scheduler-layout k-scheduler-layout-flex", e.className),
    [e.className]
  );
  return Zt({ element: r, selector: ".k-group-cell", attribute: "data-depth-index", explicitDepth: !0 }), Zt({ element: r, selector: ".k-side-cell", attribute: "data-depth-index", explicitDepth: !1 }), /* @__PURE__ */ t.createElement(
    qc,
    {
      props: e.props,
      ranges: e.ranges,
      items: [o, a],
      slots: [c, l],
      selectedItems: [m, D],
      selectedSlots: [h, C],
      focusedItems: [s, d],
      focusedSlots: [i, u]
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: r,
        style: e.style,
        className: z,
        role: "presentation"
      },
      e.children
    )
  );
});
rn.displayName = "KendoReactSchedulerBaseView";
const xe = t.createContext({
  resource: {},
  groupIndex: 0
}), ft = (e) => {
  const { nested: n, children: r, rowContentProps: o } = e, a = e.rowContent || ss, c = e.childRowContent || a, l = Fr(e.group, e.resources), s = 0;
  return /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-group k-group-horizontal" }, n ? Ml({ resources: l, children: r, nested: n, groupIndex: s, rowContent: a, rowContentProps: o, childRowContent: c }) : zl({ resources: l, children: r, rowContent: a, nested: !!n, groupIndex: s, rowContentProps: o, childRowContent: c }));
}, Ml = (e) => {
  const { resources: n, rowContent: r, nested: o, children: a, groupIndex: c, rowContentProps: l, childRowContent: s } = e;
  if (c === n.length)
    return zl({ resources: n, rowContent: r, children: a, nested: o, groupIndex: c, rowContentProps: l, childRowContent: s });
  const d = Za(n, c), i = r;
  return /* @__PURE__ */ t.createElement(t.Fragment, null, o ? /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement(i, { resources: n, groupIndex: c, ...l }, d.map((u, m) => /* @__PURE__ */ t.createElement("div", { key: m, className: "k-scheduler-cell k-heading-cell" }, u.text)))) : /* @__PURE__ */ t.createElement(i, { resources: n, groupIndex: c, ...l }, d.map((u, m) => /* @__PURE__ */ t.createElement("div", { key: m, className: "k-scheduler-cell k-heading-cell" }, u.text))), Ml({
    resources: n,
    children: a,
    nested: o,
    rowContent: r,
    childRowContent: s,
    groupIndex: c + 1
  }));
}, zl = (e) => {
  const { resources: n, childRowContent: r, children: o, rowContentProps: a } = e, c = Za(n, n.length - 1), l = r, s = n.length > 0;
  return /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement(l, { resources: n, ...a }, (c.length ? c : oc).map((d, i) => /* @__PURE__ */ t.createElement("div", { key: i, className: "k-scheduler-cell k-group-cell" }, /* @__PURE__ */ t.createElement(xe.Provider, { value: { resource: d, groupIndex: s ? i : 0 } }, o)))));
};
ft.displayName = "KendoReactSchedulerHorizontalResourceIterator";
const ss = (e) => e.children, Ma = (e) => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-side-cell", "data-range-index": e.rangeIndex }), e.children), ct = (e) => {
  const { nested: n, wrapGroup: r, children: o } = e, a = e.cellContent || hs, c = Fr(e.group, e.resources), l = 0, s = 0;
  return /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-group" }, n ? r ? /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement("div", { className: "k-sticky-cell" }, Al({ resources: c, children: o, cellContent: a, depth: l, groupIndex: s })), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-group-content" }, Rr({ resources: c, children: o, cellContent: a, depth: l, groupIndex: s }, !1))) : Rr({ resources: c, children: o, cellContent: a, depth: l, groupIndex: s }, !0) : r ? /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement("div", { className: "k-sticky-cell" }, is({ resources: c, children: o, cellContent: a, depth: l, groupIndex: s })), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-group-content" }, o)) : ds({ resources: c, children: o, cellContent: a, depth: l, groupIndex: s }));
}, is = (e) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, e.resources.map((n, r) => /* @__PURE__ */ t.createElement("div", { key: r, className: "k-scheduler-cell k-resource-cell k-heading-cell", "data-depth-index": r })))), Rr = (e, n = !0) => {
  const { resources: r, children: o, cellContent: a, groupIndex: c, depth: l } = e, s = r.length > 0;
  if (l === r.length || !s)
    return /* @__PURE__ */ t.createElement(
      xe.Provider,
      {
        value: { resource: r[l], groupIndex: s ? c : 0 }
      },
      o
    );
  const d = r[l].data.length;
  return r[l].data.map((i, u) => /* @__PURE__ */ t.createElement("div", { key: u, className: "k-scheduler-row" }, n && /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-group-cell k-heading-cell", "data-depth-index": l }, i.text), /* @__PURE__ */ t.createElement(
    "div",
    {
      className: "k-scheduler-cell k-group-content k-resource-row",
      "data-depth-index": l,
      "data-resource-index": d * c + u
    },
    Rr(
      {
        resources: r,
        children: o,
        cellContent: a,
        groupIndex: d * c + u,
        depth: l + 1
      },
      n
    )
  )));
}, Al = (e) => {
  const { resources: n, children: r, cellContent: o, groupIndex: a, depth: c } = e, l = n.length ? n[c].data.length : 0;
  return n[c] ? n[c].data.map((s, d) => /* @__PURE__ */ t.createElement("div", { key: d, className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: "k-scheduler-cell k-resource-cell k-resource-row k-heading-cell",
      "data-depth-index": c,
      "data-resource-index": l * a + d
    },
    s.text
  ), c + 1 !== n.length && /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-resource-content" }, Al({
    resources: n,
    children: r,
    cellContent: o,
    groupIndex: l * a + d,
    depth: c + 1
  })))) : null;
}, ds = (e) => {
  const { resources: n, children: r, groupIndex: o, cellContent: a } = e;
  return /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, ms(n), a, us(r, n, o));
}, us = (e, n, r) => {
  const o = n.length > 0;
  return /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-group-content" }, /* @__PURE__ */ t.createElement(
    xe.Provider,
    {
      value: { resource: n[r], groupIndex: o ? r : void 0 }
    },
    e
  ));
}, ms = (e) => e.map((n, r) => /* @__PURE__ */ t.createElement("div", { key: r, className: "k-scheduler-cell k-group-cell k-heading-cell", "data-depth-index": r }));
ct.displayName = "KendoReactSchedulerVerticalResourceIterator";
const hs = null, Pn = (e) => {
  const n = Fe();
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day" }, n.toLanguageString(Bt, Q[Bt])), e.children);
}, fa = t.forwardRef((e, n) => {
  const {
    as: r = pn.as,
    ...o
  } = e, a = t.useRef(null), c = t.useRef(null), l = $e(), s = t.useMemo(
    () => he("k-scheduler-cell k-heading-cell", e.className),
    [e.className]
  );
  return t.useImperativeHandle(c, () => ({
    element: a.current && a.current.element ? a.current.element : a.current,
    props: e
  })), t.useImperativeHandle(n, () => c.current), /* @__PURE__ */ t.createElement(
    r,
    {
      ref: r !== pn.as ? void 0 : a,
      ...o,
      className: s
    },
    l.formatDate(
      e.date,
      e.format ? e.format : pn.format
    )
  );
}), pn = {
  as: t.forwardRef(({ as: e, format: n, start: r, end: o, ...a }, c) => /* @__PURE__ */ t.createElement("div", { ...a, ref: c })),
  format: "t"
};
fa.displayName = "KendoReactSchedulerTimeHeaderCell";
const za = (e) => {
  const { slot: n, children: r } = e;
  return /* @__PURE__ */ t.createElement(t.Fragment, null, e.isMaster ? /* @__PURE__ */ t.createElement(
    fa,
    {
      as: e.timeHeaderCell,
      date: n.zonedStart,
      start: n.zonedStart,
      end: n.zonedEnd,
      className: he(
        "k-side-cell",
        {
          "k-major-cell": !e.isLast
        }
      )
    }
  ) : /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell" }), r);
}, xt = (e, { timezone: n }, { groups: r, ranges: o }) => {
  const a = [];
  return Ua(
    e,
    [
      { field: "start", dir: "asc" },
      { field: "end", dir: "desc" },
      { field: "isAllDay", dir: "desc" }
    ]
  ).forEach((l) => {
    r.forEach((s) => {
      const d = r.length === 1 ? fs(l, s) : s;
      Es(l, d) && o.forEach((i) => {
        if (ys(l, i)) {
          const u = t.createRef(), m = t.createRef(), g = i.end < l.end, h = l.start < i.start, y = te.fromLocalDate(l.start, n), D = te.fromLocalDate(l.end, n), C = {
            ...l,
            _ref: m,
            itemRef: u,
            head: g,
            tail: h,
            order: null,
            zonedStart: y,
            zonedEnd: D,
            group: d,
            range: i,
            slots: [],
            isRecurring: !!l.recurrenceRule,
            isException: !l.recurrenceRule && l.recurrenceId !== null && l.recurrenceId !== void 0,
            isAllDay: !!l.isAllDay
          };
          a.push(C);
        }
      });
    });
  }), a;
}, fs = (e, n) => ({
  index: 0,
  resources: n.resources.filter((r) => gs(e, r))
}), gs = (e, n) => n.multiple ? (e.dataItem[n.field] || []).some((r) => n[n.valueField] === r) : e.dataItem[n.field] === n[n.valueField], Es = (e, n) => !n.resources.some((r) => r.multiple ? !e.dataItem[r.field].some((o) => r[r.valueField] === o) : e.dataItem[r.field] !== r[r.valueField]), ys = (e, n) => Oe(n.start, n.end, e.start, e.end) && (n.isAllDay === void 0 || e.isAllDay === void 0 || e.isAllDay === n.isAllDay), jt = (e, { step: n }, { groups: r, ranges: o }) => {
  const a = [];
  return r.forEach((c) => {
    o.forEach((l) => {
      const s = l.zonedStart, d = l.zonedEnd, i = d.timezoneOffset - s.timezoneOffset;
      for (let u = s.clone(), m = 0, g = i < 0 ? i * $n * -1 : 0; u.getTime() < d.getTime(); m++, u = u.addTime(n)) {
        const h = t.createRef(), y = u.clone(), D = u.addTime(n), C = (D.timezoneOffset - y.timezoneOffset) * $n, z = n <= Math.abs(C);
        g && z && (g -= n, u = u.addTime(-n));
        const x = new Date(y.getTime()), R = new Date(D.getTime()), L = {
          _ref: h,
          index: m,
          end: R,
          start: x,
          zonedStart: y,
          zonedEnd: D,
          range: l,
          group: c,
          items: [],
          isAllDay: Ge <= n
        };
        a.push(L);
      }
    });
  }), a;
}, Pt = (e, { dateRange: n, fields: r, timezone: o }) => e.map(vs(r)).reduce(ks(n, o, r), []).filter((c) => !Lr(c.dataItem, r)), vs = (e) => (n) => ({
  uid: Te(e.id || "id")(n),
  start: Te(e.start || "start")(n),
  startTimezone: Te(e.startTimezone || "startTimezone")(n),
  originalStart: Te(e.originalStart || "originalStart")(n),
  end: Te(e.end || "end")(n),
  endTimezone: Te(e.endTimezone || "endTimezone")(n),
  isAllDay: Te(e.isAllDay || "isAllDay")(n),
  title: Te(e.title || "title")(n),
  description: Te(e.description || "description")(n),
  occurrenceId: Te("occurrenceId")(n),
  recurrenceRule: Te(e.recurrenceRule || "recurrenceRule")(n),
  recurrenceExceptions: Te(e.recurrenceExceptions || "recurrenceExceptions")(n),
  recurrenceId: Te(e.recurrenceId || "recurrenceId")(n),
  dataItem: ce(n)
}), ks = (e, n, r) => (o, a) => [
  ...o,
  ...a.recurrenceRule && (a.recurrenceId === null || a.recurrenceId === void 0) && Lr(a.dataItem, r) ? [...Ds(a, { dateRange: e, timezone: n, fields: r })] : [a]
], Ds = (e, { dateRange: n, timezone: r, fields: o }) => {
  const a = e.recurrenceRule, c = Ya({ recurrenceRule: a });
  c.start || (c.start = te.fromLocalDate(e.start, r)), c.end || (c.end = te.fromLocalDate(e.end, r));
  const l = e.recurrenceExceptions;
  l && (c.exceptionDates = l.map(
    (m) => te.fromLocalDate(m, r)
  ));
  const s = n.zonedStart, d = n.zonedEnd, i = nc(c, {
    rangeStart: s,
    rangeEnd: d
  });
  return i.events.length ? i.events.map((m, g) => {
    const h = ce(e), y = ce(e.dataItem);
    return h.recurrenceId = h.uid, j(y, o.recurrenceId, e.uid), h.originalStart = m.start.toLocalDate(), j(y, o.originalStart, m.start.toLocalDate()), h.start = m.start.toLocalDate(), j(y, o.start, m.start.toLocalDate()), h.end = m.end.toLocalDate(), j(y, o.end, m.end.toLocalDate()), h.occurrenceId = String(g), j(y, "occurrenceId", String(g)), h.dataItem = y, h;
  }) : [];
}, Qt = (e, { step: n, timezone: r }) => {
  const o = [], a = te.fromLocalDate(e.start, r), c = te.fromLocalDate(e.end, r);
  for (let l = a.clone(), s = 0; l.getTime() < c.getTime(); s++, l = l.addTime(n)) {
    const d = l.clone(), i = d.clone().addTime(n), u = new Date(d.getTime()), m = new Date(i.getTime()), g = {
      index: s,
      end: m,
      start: u,
      zonedStart: d,
      zonedEnd: i
    };
    o.push(g);
  }
  return o;
}, Aa = (e) => {
  const { onChange: n, data: r, validationMessage: o, visited: a, touched: c, modified: l, ...s } = e, [d, i] = t.useState(r), u = t.useCallback(
    (g) => n(g),
    [n]
  ), m = t.useCallback(
    (g) => {
      const h = po(r || [], g.filter);
      i(h);
    },
    []
  );
  return /* @__PURE__ */ t.createElement(
    ec,
    {
      style: { width: "100%" },
      data: d,
      filterable: !0,
      onFilterChange: m,
      onChange: u,
      ...s
    }
  );
}, Ss = (e) => {
  const { value: n, data: r, onChange: o, ...a } = e, c = t.useCallback(
    (l) => {
      o && o.call(void 0, l.currentTarget.dataset.value);
    },
    [o]
  );
  return /* @__PURE__ */ t.createElement(
    Mr,
    {
      className: "k-scheduler-recurrence-repeat",
      width: "100%",
      ...a
    },
    r.map((l) => /* @__PURE__ */ t.createElement(
      Re,
      {
        type: "button",
        key: l.value,
        selected: l.value === n,
        onClick: c,
        "data-value": l.value,
        togglable: !0
      },
      l.text
    ))
  );
}, Jt = (e) => e.charAt(0).toUpperCase() + e.slice(1), ws = ["first", "second", "third", "fourth", "last"], Cs = ["never", "daily", "weekly", "monthly", "yearly"], bs = [
  { day: 0, offset: 0 },
  { day: 1, offset: 0 },
  { day: 2, offset: 0 },
  { day: 3, offset: 0 },
  { day: 4, offset: 0 },
  { day: 5, offset: 0 },
  { day: 6, offset: 0 }
], Rs = [
  { day: 1, offset: 0 },
  { day: 2, offset: 0 },
  { day: 3, offset: 0 },
  { day: 4, offset: 0 },
  { day: 5, offset: 0 }
], Is = [
  { day: 0, offset: 0 },
  { day: 6, offset: 0 }
], Na = (e) => {
  switch (e) {
    case "day":
      return bs;
    case "weekday":
      return Rs;
    case "weekend":
      return Is;
  }
}, Ts = (e) => Ya({ recurrenceRule: e }) || {}, xs = (e) => Cs.map((n) => ({
  value: n,
  text: e("Frequencies" + Jt(n))
})), Ms = (e) => ot(e) && !fc(e.freq) ? e.freq : "never", zs = (e) => ot(e.until) ? Ir(e.until) : null, As = (e) => e.dateFormatNames({
  type: "months",
  nameType: "wide",
  standAlone: !0
}).map((n, r) => ({
  text: n,
  value: r + 1
})), Ns = (e) => {
  const n = e.firstDay(), r = e.dateFormatNames({
    type: "days",
    nameType: "abbreviated"
  }).map((o, a) => ({
    text: o,
    value: a
  }));
  return r.slice(n).concat(r.slice(0, n));
}, Fs = (e, n, r) => e.find((o) => {
  let a;
  if (ot(n.byWeekDay))
    switch (n.byWeekDay.length) {
      case 7:
        a = "day";
        break;
      case 5:
        a = "weekday";
        break;
      case 2:
        a = "weekend";
        break;
      case 1:
        a = n.byWeekDay[0].day;
        break;
      default:
        a = r.getDay();
        break;
    }
  return a === o.value;
}) || e[0], _s = (e, n) => {
  const r = e.firstDay();
  let o = e.dateFormatNames({
    type: "days",
    nameType: "wide"
  }).map((l, s) => ({
    text: l,
    value: s
  }));
  const a = o.slice(r).concat(o.slice(0, r));
  return [
    { text: n("WeekdaysDay"), value: "day" },
    { text: n("WeekdaysWeekday"), value: "weekday" },
    { text: n("WeekdaysWeekendday"), value: "weekend" }
  ].concat(a);
}, Ls = (e, n) => e.find((r) => r.value === (n.bySetPosition ? n.bySetPosition[0] : n.byWeekDay && n.byWeekDay[0] ? n.byWeekDay[0].offset : 1)) || e[0], Os = (e) => {
  const n = [1, 2, 3, 4, -1];
  return ws.map((r, o) => ({
    text: e("OffsetPositions" + Jt(r)),
    value: n[o]
  }));
}, Ps = (e) => ot(e.count) ? "count" : ot(e.until) ? "until" : "never", ps = (e) => {
  if (ot(e.byWeekDay))
    return "weekday";
  if (ot(e.byMonthDay))
    return "monthday";
}, Ws = (e, n) => e.find((r) => (n.byMonth ? n.byMonth[0] : null) === r.value) || e[0], Hs = (e, n) => ot(e.byMonthDay) && e.byMonthDay.length > 0 ? e.byMonthDay[0] : n.getDate(), Vs = (e) => {
  const { value: n, data: r, onChange: o, ...a } = { ...Fa, ...e }, c = (l) => {
    const s = Number(l.currentTarget.dataset.key);
    e.onChange && e.onChange.call(void 0, n.some((d) => d === s) ? n.filter((d) => d !== s) : [...n, s]);
  };
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(Mr, { width: "auto", ...a }, (e.data || Fa.data).map((l) => /* @__PURE__ */ t.createElement(
    Re,
    {
      type: "button",
      key: l.value,
      "data-key": l.value,
      selected: n.some((s) => s === l.value),
      togglable: !0,
      onClick: c
    },
    Jt(l.text)
  ))));
}, Fa = {
  data: [],
  value: []
}, Nl = (e) => {
  const n = $e(), r = Fe(), { timezone: o } = qe(), [a, c] = t.useState(1), [l, s] = t.useState(te.fromUTCDate(e.start)), d = t.useCallback(
    (k, E) => {
      const M = E ? k : "scheduler.recurrenceEditor" + k;
      return r.toLanguageString(M, Q[M]);
    },
    [r]
  ), i = t.useMemo(
    () => Ts(e.value ?? Ks.value),
    [e.value]
  ), u = t.useMemo(
    () => xs(d),
    [d]
  ), m = t.useMemo(
    () => Ms(i),
    [i]
  ), g = t.useMemo(
    () => _s(n, d),
    [n, d]
  ), h = t.useMemo(
    () => Fs(g, i, e.start),
    [g, i, e.start]
  ), y = t.useMemo(
    () => As(n),
    [n]
  ), D = t.useMemo(
    () => Ws(y, i),
    [y, i]
  ), C = t.useMemo(
    () => Os(d),
    [d]
  ), z = t.useMemo(
    () => Ls(C, i),
    [C, i]
  ), x = t.useMemo(
    () => Ps(i),
    [i]
  ), R = t.useMemo(
    () => Hs(i, e.start),
    [i, e.start]
  ), L = t.useMemo(
    () => zs(i),
    [i.until]
  ), _ = t.useMemo(
    () => Ns(n),
    [n]
  ), O = t.useMemo(
    () => ps(i),
    [i.byWeekDay, i.byMonthDay]
  ), f = t.useCallback(
    (k) => {
      k.freq === "never" ? e.onChange({ value: null }) : (k.weekStart === void 0 && (k.weekStart = n.firstDay()), e.onChange({ value: rc(k, e.timezone) }));
    },
    [e.onChange, e.timezone]
  ), I = t.useCallback(
    (k) => {
      const E = {};
      E.freq = k, E.interval = 1, k === "weekly" && (E.byWeekDay = [{
        day: te.fromLocalDate(e.start, o).getDay(),
        offset: 0
      }]), (k === "monthly" || k === "yearly") && (E.byMonthDay = [e.start.getDate()]), k === "yearly" && (E.byMonth = [e.start.getMonth() + 1]), f(E);
    },
    [f, e.start, o]
  ), b = t.useCallback(
    (k) => {
      const E = k.value;
      f(Object.assign({}, i, {
        interval: E
      }));
    },
    [f, i]
  ), A = t.useCallback(
    (k) => {
      const E = k.value;
      f(Object.assign({}, i, {
        count: E
      })), E !== null && c(E);
    },
    [f, i]
  ), N = t.useCallback(
    (k) => {
      const E = k.value;
      if (!E)
        return;
      const M = te.fromLocalDate(E, e.timezone);
      f(Object.assign({}, i, {
        until: M
      })), s(M);
    },
    [f, i, e.timezone]
  ), X = t.useCallback(
    (k) => {
      f(Object.assign({}, i, {
        byWeekDay: _.filter((E) => k.some((M) => M === E.value)).map((E) => ({ offset: 0, day: E.value }))
      }));
    },
    [f, i, _]
  ), F = t.useCallback(
    (k) => {
      const E = Object.assign({}, i), M = k.target.value;
      typeof M.value == "string" ? (E.byWeekDay = Na(M.value), E.bySetPosition = [z.value]) : E.byWeekDay = [{
        day: M.value,
        offset: z.value
      }], f(E);
    },
    [f, i]
  ), V = t.useCallback(
    (k) => {
      f(Object.assign({}, i, {
        byMonthDay: [k.value]
      }));
    },
    [f, i]
  ), p = t.useCallback(
    (k) => {
      const E = k.value;
      f(Object.assign({}, i, {
        byMonth: [E.value]
      }));
    },
    [f, i]
  ), P = t.useCallback(
    (k) => {
      const E = k.value, M = Object.assign({}, i);
      switch (E) {
        case "never":
          M.until = void 0, M.count = void 0;
          break;
        case "count":
          M.until = void 0, M.count = a;
          break;
        case "until":
          M.until = l, M.count = void 0;
          break;
      }
      f(M);
    },
    [f, i, e.timezone]
  ), S = t.useCallback(
    (k) => {
      const E = Object.assign({}, i);
      k.value === "monthday" ? (E.byWeekDay = void 0, E.bySetPosition = void 0, E.byMonthDay = [R]) : k.value === "weekday" && (E.byMonthDay = void 0, typeof h.value == "string" ? (E.bySetPosition = [z.value], E.byWeekDay = Na(h.value)) : E.byWeekDay = [{
        day: h.value,
        offset: z.value
      }]), f(E);
    },
    [f, i, R, h]
  ), U = t.useCallback(
    (k) => {
      const E = Object.assign({}, i), M = k.value;
      if (E.byWeekDay)
        switch (E.byWeekDay.length) {
          case 7:
          case 5:
          case 2:
            E.bySetPosition = [M.value];
            break;
          case 1:
            E.byWeekDay[0].offset = M.value;
            break;
        }
      f(E);
    },
    [f, i]
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, { className: "k-form-label" }, r.toLanguageString(fr, Q[fr])), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    Ss,
    {
      value: m,
      data: u,
      onChange: I
    }
  ))), m !== "never" && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, { editorId: "interval-editor", className: "k-form-label" }, d(Jt(m) + "RepeatEvery")), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    hn,
    {
      min: 1,
      step: 1,
      defaultValue: 1,
      value: i.interval,
      onChange: b,
      id: "interval-editor",
      className: "k-recur-interval"
    }
  ), /* @__PURE__ */ t.createElement(t.Fragment, null, " "), /* @__PURE__ */ t.createElement(ve, { editorId: "interval-editor", className: "k-form-label" }, d(Jt(m) + "Interval")))), m === "weekly" && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, { className: "k-form-label" }, d(il, !0)), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    Vs,
    {
      data: _,
      value: (i.byWeekDay || []).map(({ day: k }) => k),
      onChange: X
    }
  ))), m === "monthly" && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, { key: "recurrence-repeat-on-monthly-label", className: "k-form-label" }, d(ul, !0)), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    Ln,
    {
      value: O,
      onChange: S,
      item: Wn,
      className: "k-reset",
      data: [
        {
          value: "monthday",
          label: d(dl, !0),
          children: [
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ t.createElement(
              hn,
              {
                key: "weekday-day",
                min: 1,
                max: 31,
                disabled: O !== "monthday",
                value: i && i.byMonthDay && i.byMonthDay[0],
                onChange: V,
                width: "auto"
              }
            )
          ]
        },
        {
          value: "weekday",
          label: " ",
          children: [
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "weekday-offset",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                data: C,
                value: z,
                onChange: U,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "weekday-value",
                disabled: O !== "weekday",
                value: h,
                data: g,
                onChange: F,
                textField: "text",
                dataItemKey: "value",
                style: { width: "auto" }
              }
            )
          ]
        }
      ]
    }
  ))), m === "yearly" && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, null, d(hl, !0)), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    Ln,
    {
      value: O,
      item: Wn,
      onChange: S,
      className: "k-reset",
      data: [
        {
          value: "monthday",
          label: " ",
          children: [
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "monthday-month",
                disabled: O !== "monthday",
                value: D,
                data: y,
                textField: "text",
                dataItemKey: "value",
                onChange: p,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ t.createElement(
              hn,
              {
                key: "monthday-day",
                min: 1,
                max: 31,
                disabled: O !== "monthday",
                value: R,
                onChange: V,
                width: "auto"
              }
            )
          ]
        },
        {
          value: "weekday",
          label: " ",
          children: [
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "yearly-weekday-offset",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                data: C,
                value: z,
                onChange: U,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "yearly-separator-1" }, " "),
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "yearly-weekday-day",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                value: h,
                data: g,
                onChange: F,
                style: { width: "auto" }
              }
            ),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "yearly-separator-2" }, " "),
            /* @__PURE__ */ t.createElement("span", { key: "yearly-weekday-of-label" }, d(ml, !0)),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "yearly-separator-3" }, " "),
            /* @__PURE__ */ t.createElement(
              bt,
              {
                key: "yearly-weekday-month",
                textField: "text",
                dataItemKey: "value",
                disabled: O !== "weekday",
                value: D,
                data: y,
                onChange: p,
                style: { width: "auto" }
              }
            )
          ]
        }
      ]
    }
  ))), m !== "never" && /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-recurrence-end-rule-editor" }, /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(ve, { className: "k-form-label" }, d(El, !0)), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
    Ln,
    {
      item: Wn,
      value: x,
      onChange: P,
      data: [
        {
          value: "never",
          label: d(yl, !0)
        },
        {
          value: "count",
          label: d(fl, !0),
          children: [
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator-1" }, " "),
            /* @__PURE__ */ t.createElement(
              hn,
              {
                key: "endrule-after-editor",
                id: "k-endrule-after",
                className: "k-recur-count",
                min: 1,
                width: "70px",
                value: x === "count" ? i.count : a,
                onChange: A,
                disabled: x !== "count"
              }
            ),
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator-2" }, " "),
            /* @__PURE__ */ t.createElement(
              ve,
              {
                key: "endrule-after-label",
                className: "k-radio-label",
                editorId: "k-endrule-after"
              },
              d(gl, !0)
            )
          ]
        },
        {
          value: "until",
          label: d(vl, !0),
          children: [
            /* @__PURE__ */ t.createElement(t.Fragment, { key: "separator" }, " "),
            /* @__PURE__ */ t.createElement(
              Kn,
              {
                key: "k-endrule-until-editor",
                id: "k-endrule-until",
                disabled: x !== "until",
                min: e.start,
                value: x === "until" ? L : Ir(l),
                onChange: N,
                width: "auto"
              }
            )
          ]
        }
      ]
    }
  )))));
}, Wn = (e) => /* @__PURE__ */ t.createElement("li", { ...e }, e.children), Ks = {
  value: ""
};
Nl.displayName = "KendoReactSchedulerRepeatEditor";
const Us = (e) => {
  const n = e.multiple ? tc : bt, r = t.useCallback(
    (l) => {
      const s = l.target.props.dataItemKey, d = e.multiple ? (l.target.value || []).map((i) => i[s]) : l.target.value[s];
      e.onChange.call(void 0, { value: d });
    },
    [e.multiple, e.onChange]
  ), o = t.useCallback(
    (l, s) => {
      const d = /* @__PURE__ */ t.createElement(t.Fragment, null, e.colorField && /* @__PURE__ */ t.createElement(
        "span",
        {
          key: 1,
          className: "k-scheduler-mark",
          style: {
            backgroundColor: s.dataItem[e.colorField],
            marginRight: ot(s.dataItem[e.valueField]) ? "8px" : "4px"
          }
        },
        " "
      ), /* @__PURE__ */ t.createElement("span", { key: 2 }, "  ", l.props.children));
      return t.cloneElement(l, { ...l.props }, d);
    },
    [e.colorField, e.valueField]
  ), a = t.useCallback(
    (l, s) => {
      const d = /* @__PURE__ */ t.createElement(t.Fragment, null, e.colorField && s && /* @__PURE__ */ t.createElement(
        "span",
        {
          key: 1,
          className: "k-scheduler-mark",
          style: {
            backgroundColor: s[e.colorField],
            marginRight: s[e.valueField] ? "8px" : "4px"
          }
        },
        " "
      ), l.props.children);
      return t.cloneElement(l, {}, d);
    },
    [e.colorField, e.valueField]
  ), c = Array.isArray(e.value) ? e.data.filter((l) => e.value.some((s) => l[e.valueField] === s)) : e.data.find((l) => l[e.valueField] === e.value);
  return /* @__PURE__ */ t.createElement(
    n,
    {
      value: c,
      onChange: r,
      data: e.data,
      textField: e.textField,
      dataItemKey: e.valueField,
      valid: e.valid,
      validationMessage: e.validationMessage,
      itemRender: o,
      valueRender: a
    }
  );
}, _a = (e) => {
  const {
    as: n = Gs.as,
    ...r
  } = e, { timezone: o } = qe(), a = (c) => {
    r.onChange && r.onChange({ value: Bs(c.target.value, o) });
  };
  return /* @__PURE__ */ t.createElement(
    n,
    {
      ...r,
      value: $s(r.value, o),
      onChange: a
    }
  );
}, $s = (e, n) => e && Ir(te.fromLocalDate(e, n).toUTCDate()), Bs = (e, n) => e && te.fromUTCDate(
  new Date(Date.UTC(
    e.getFullYear(),
    e.getMonth(),
    e.getDate(),
    e.getHours(),
    e.getMinutes(),
    e.getSeconds(),
    e.getMilliseconds()
  )),
  n
).toLocalDate(), Gs = {
  as: Un
}, Fl = t.forwardRef((e, n) => {
  const r = t.useRef(null), o = t.useRef(null), a = Io(), c = Fe(), l = Pe(), { resources: s, timezone: d } = qe();
  t.useImperativeHandle(o, () => ({
    element: r.current && r.current.element ? r.current.element : r.current,
    props: e
  })), t.useImperativeHandle(n, () => o.current);
  const {
    as: i = oe.as,
    ...u
  } = e, {
    titleLabel: m = oe.titleLabel,
    titleError: g = oe.titleError,
    titleEditor: h = oe.titleEditor,
    startLabel: y = oe.startLabel,
    startError: D = oe.startError,
    startEditor: C = oe.startEditor,
    startTimezoneLabel: z = oe.startTimezoneLabel,
    startTimezoneError: x = oe.startTimezoneError,
    startTimezoneEditor: R = oe.startTimezoneEditor,
    startTimezoneCheckedLabel: L = oe.startTimezoneCheckedLabel,
    startTimezoneCheckedEditor: _ = oe.startTimezoneCheckedEditor,
    endLabel: O = oe.endLabel,
    endError: f = oe.endError,
    endEditor: I = oe.endEditor,
    endTimezoneLabel: b = oe.endTimezoneLabel,
    endTimezoneError: A = oe.endTimezoneError,
    endTimezoneEditor: N = oe.endTimezoneEditor,
    endTimezoneCheckedLabel: X = oe.endTimezoneCheckedLabel,
    endTimezoneCheckedEditor: F = oe.endTimezoneCheckedEditor,
    allDayLabel: V = oe.allDayLabel,
    allDayEditor: p = oe.allDayEditor,
    recurrenceEditor: P = oe.recurrenceEditor,
    descriptionLabel: S = oe.descriptionLabel,
    descriptionEditor: U = oe.descriptionEditor,
    descriptionError: k = oe.descriptionError,
    resourceLabel: E = oe.resourceLabel,
    resourceEditor: M = oe.resourceEditor
  } = e, W = e.valueGetter(l.start) || /* @__PURE__ */ new Date(), J = e.valueGetter(l.startTimezone) || d || "", ne = e.valueGetter(l.endTimezone) || d || "", B = t.useMemo(() => c.toLanguageString(qt, Q[qt]), [c]), [re, de] = t.useState(!!e.valueGetter(l.startTimezone)), [fe, ae] = t.useState(!!e.valueGetter(l.endTimezone)), Ie = t.useCallback(
    ($) => {
      $.value || (e.onChange(l.startTimezone, { value: null }), e.onChange(l.endTimezone, { value: null }), ae($.value)), de($.value);
    },
    [e.onChange, l.startTimezone, l.endTimezone]
  ), ge = t.useCallback(
    ($) => {
      $.value || e.onChange(l.endTimezone, { value: null }), ae($.value);
    },
    [e.onChange]
  ), De = t.useCallback(
    ($) => $ ? void 0 : B,
    [B]
  ), Ee = t.useCallback(
    ($, ie) => re ? De(ie(l.startTimezone)) : void 0,
    [De, re, l.startTimezone]
  ), pe = t.useCallback(
    ($, ie) => re && fe ? De(ie(l.endTimezone)) || De(ie(l.startTimezone)) : void 0,
    [De, re, fe, l.startTimezone, l.endTimezone]
  ), H = t.useMemo(
    () => he("k-scheduler-edit-form", e.className),
    [e.className]
  );
  return /* @__PURE__ */ t.createElement(
    i,
    {
      ref: i === oe.as ? r : void 0,
      ...u,
      className: H
    },
    /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.title,
        component: m,
        editorId: "k-scheduler-editor-title",
        className: "k-form-label"
      },
      c.toLanguageString(lr, Q[lr])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        id: "k-scheduler-editor-title",
        name: l.title,
        field: l.title,
        component: h
      }
    ), e.errors[l.title] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.title,
        component: g
      },
      e.errors[l.title]
    ))), /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.start,
        component: y,
        editorId: "k-scheduler-editor-start",
        className: "k-form-label"
      },
      c.toLanguageString(or, Q[or])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        id: "k-scheduler-editor-start",
        name: l.start,
        width: "auto",
        component: C,
        as: e.valueGetter(l.isAllDay) ? Kn : Un,
        timezone: d
      }
    ), e.errors[l.start] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.start,
        component: D
      },
      e.errors[l.start]
    ))), /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      L,
      {
        className: "k-form-label"
      }
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      _,
      {
        id: "k-scheduler-editor-set-start-timezone",
        onChange: Ie,
        value: re
      }
    ), /* @__PURE__ */ t.createElement(
      L,
      {
        className: "k-checkbox-label",
        editorId: "k-scheduler-editor-set-start-timezone"
      },
      c.toLanguageString(hr, Q[hr])
    ))), re && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.start,
        component: z,
        className: "k-form-label"
      },
      c.toLanguageString(cr, Q[cr])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        component: R,
        value: J,
        validator: Ee,
        data: a,
        name: l.startTimezone
      }
    ), e.errors[l.startTimezone] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.startTimezone,
        component: x
      },
      e.errors[l.startTimezone]
    ))), /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.end,
        component: O,
        editorId: "k-scheduler-editor-end",
        className: "k-form-label"
      },
      c.toLanguageString(sr, Q[sr])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        id: "k-scheduler-editor-end",
        name: l.end,
        width: "auto",
        component: I,
        as: e.valueGetter(l.isAllDay) ? Kn : Un,
        timezone: d
      }
    ), e.errors[l.end] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.end,
        component: f
      },
      e.errors[l.end]
    ))), re && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      F,
      {
        id: "k-scheduler-editor-set-end-timezone",
        onChange: ge,
        value: fe
      }
    )), /* @__PURE__ */ t.createElement(
      X,
      {
        editorId: "k-scheduler-editor-set-end-timezone",
        className: "k-form-label"
      },
      c.toLanguageString(mr, Q[mr])
    )), fe && /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.endTimezone,
        component: b,
        className: "k-form-label"
      },
      c.toLanguageString(ir, Q[ir])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        value: ne,
        data: a,
        validator: pe,
        component: N,
        name: l.endTimezone
      }
    ), e.errors[l.endTimezone] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.endTimezone,
        component: A
      },
      e.errors[l.endTimezone]
    ))), /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.isAllDay,
        component: ve,
        className: "k-form-label"
      }
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        id: "k-is-allday-checkbox",
        name: l.isAllDay,
        component: p
      }
    ), /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.isAllDay,
        field: l.isAllDay,
        editorId: "k-is-allday-checkbox",
        className: "k-checkbox-label",
        component: V
      },
      c.toLanguageString(dr, Q[dr])
    ))), /* @__PURE__ */ t.createElement("div", { className: "k-recurrence-editor" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        component: P,
        field: l.recurrenceRule,
        name: l.recurrenceRule,
        start: W
      }
    )), /* @__PURE__ */ t.createElement(Ce, null, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.description,
        component: S,
        className: "k-form-label"
      },
      c.toLanguageString(ur, Q[ur])
    ), /* @__PURE__ */ t.createElement("div", { className: "k-form-field-wrap" }, /* @__PURE__ */ t.createElement(
      ue,
      {
        component: U,
        name: l.description,
        rows: 1,
        id: "k-event-description"
      }
    ), e.errors[l.description] && /* @__PURE__ */ t.createElement(
      ue,
      {
        name: l.description,
        component: k
      },
      e.errors[l.description]
    ))), (s || []).map(($) => /* @__PURE__ */ t.createElement(Ce, { key: $.field }, /* @__PURE__ */ t.createElement(
      ue,
      {
        name: $.field,
        component: E,
        className: "k-form-label"
      }
    ), /* @__PURE__ */ t.createElement(ve, { className: "k-form-label" }, $.name), /* @__PURE__ */ t.createElement(
      ue,
      {
        name: $.field,
        component: M,
        resource: $,
        multiple: $.multiple,
        data: $.data,
        textField: $.textField,
        valueField: $.valueField,
        colorField: $.colorField
      }
    ))))
  );
}), oe = {
  as: t.forwardRef((e, n) => /* @__PURE__ */ t.createElement(
    Xo,
    {
      ref: n,
      id: e.id,
      style: e.style,
      tabIndex: e.tabIndex,
      className: e.className,
      horizontal: e.horizontal,
      children: e.children
    }
  )),
  titleLabel: ve,
  titleError: Ft,
  titleEditor: Qo,
  startLabel: ve,
  startError: Ft,
  startEditor: _a,
  startTimezoneLabel: ve,
  startTimezoneError: Ft,
  startTimezoneEditor: Aa,
  startTimezoneCheckedLabel: ve,
  startTimezoneCheckedEditor: On,
  endLabel: ve,
  endError: Ft,
  endEditor: _a,
  endTimezoneLabel: ve,
  endTimezoneError: Ft,
  endTimezoneEditor: Aa,
  endTimezoneCheckedLabel: ve,
  endTimezoneCheckedEditor: On,
  allDayLabel: ve,
  allDayEditor: On,
  recurrenceEditor: Nl,
  descriptionLabel: ve,
  descriptionEditor: Jo,
  descriptionError: Ft,
  resourceLabel: ve,
  resourceEditor: Us
};
Fl.displayName = "KendoReactSchedulerFormEditor";
const ga = t.forwardRef((e, n) => {
  const {
    onCancel: r,
    onClose: o,
    onSubmit: a,
    editor: c,
    dialog: l = La.dialog,
    validator: s = La.validator,
    ...d
  } = e, i = t.useRef(null);
  t.useImperativeHandle(i, () => ({ props: e })), t.useImperativeHandle(n, () => i.current);
  const u = Fe(), m = Pe(), g = t.useMemo(() => u.toLanguageString(qt, Q[qt]), [u]), h = t.useMemo(() => u.toLanguageString(wr, Q[wr]), [u]), y = t.useMemo(() => u.toLanguageString(rr, Q[rr]), [u]), D = t.useMemo(() => u.toLanguageString(Yt, Q[Yt]), [u]), C = t.useMemo(() => u.toLanguageString(ar, Q[ar]), [u]), z = t.useMemo(() => u.toLanguageString(Sr, Q[Sr]), [u]), x = t.useCallback(
    (b) => {
      r && r.call(void 0, { value: null, syntheticEvent: b, target: i.current });
    },
    [r]
  ), R = t.useCallback(
    ({ syntheticEvent: b }) => {
      o && o.call(void 0, { value: null, syntheticEvent: b, target: i.current });
    },
    [o]
  ), L = t.useCallback(
    (b, A) => {
      a && a.call(void 0, { value: b, syntheticEvent: A, target: i.current });
    },
    [a]
  ), _ = t.useCallback(
    (b, A) => b && A(m.end) && b.getTime() > A(m.end).getTime() ? z : void 0,
    [m, z]
  ), O = t.useCallback(
    (b, A) => b && A(m.start) && b.getTime() < A(m.start).getTime() ? h : void 0,
    [m, h]
  ), f = t.useCallback(
    (b) => b ? void 0 : g,
    [g]
  ), I = t.useCallback(
    (b, A) => {
      let N = {};
      N[m.start] = [
        f(A(m.start)),
        _(A(m.start), A)
      ].filter(Boolean).reduce((F, V) => F || V, ""), N[m.end] = [
        f(A(m.start)),
        O(A(m.start), A)
      ].filter(Boolean).reduce((F, V) => F || V, "");
      const X = s(b, A);
      return { ...N, ...X };
    },
    [O, m.end, m.start, f, _, s]
  );
  return Tr ? wn.createPortal(
    /* @__PURE__ */ t.createElement(
      jo,
      {
        initialValues: e.dataItem,
        onSubmit: L,
        validator: I,
        render: (b) => /* @__PURE__ */ t.createElement(
          l,
          {
            title: C,
            minWidth: 400,
            onClose: R,
            className: "k-scheduler-edit-dialog"
          },
          /* @__PURE__ */ t.createElement(Fl, { ...b, as: c }),
          /* @__PURE__ */ t.createElement(Ar, { layout: "start" }, /* @__PURE__ */ t.createElement(
            Re,
            {
              themeColor: "primary",
              disabled: !b.allowSubmit,
              onClick: b.onSubmit,
              icon: "save",
              svgIcon: Bo
            },
            y
          ), /* @__PURE__ */ t.createElement(
            Re,
            {
              onClick: x,
              icon: "cancel",
              svgIcon: Go
            },
            D
          ))
        ),
        ...d
      }
    ),
    document && document.body
  ) : null;
}), La = {
  dialog: Nr,
  validator: () => ({})
};
ga.displayName = "KendoReactSchedulerForm";
const Ys = (e, n) => {
  const { _ref: r } = e, o = t.useRef(null), a = t.useRef(null), [, c] = zt();
  return t.useImperativeHandle(o, () => ({ element: a.current, props: e })), t.useImperativeHandle(n, () => o.current), t.useImperativeHandle(r, () => o.current), t.useEffect(
    () => (c({
      type: yn.add,
      item: o
    }), () => {
      c({
        type: yn.remove,
        item: o
      });
    })
  ), {
    slot: o,
    element: a
  };
}, _l = t.forwardRef((e, n) => {
  const {
    // Focus
    onFocus: r,
    onBlur: o,
    // Mouse
    onClick: a,
    onMouseEnter: c,
    onMouseLeave: l,
    onMouseOut: s,
    onMouseOver: d,
    onDoubleClick: i,
    // Keyboard
    onKeyDown: u,
    onKeyPress: m,
    onKeyUp: g
  } = e, { slot: h, element: y } = Ys(e, n), D = e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : e.selected ? 0 : -1, C = t.useMemo(
    () => {
      const F = e.isWorkHour ?? Oa.isWorkHour, V = e.isWorkDay ?? Oa.isWorkDay;
      return he(
        e.className,
        "k-scheduler-cell k-slot-cell",
        {
          "k-nonwork-hour": !F || !V,
          "k-selected": e.selected
        }
      );
    },
    [e.className, e.selected, e.isWorkHour, e.isWorkDay]
  ), z = t.useMemo(
    () => ({
      userSelect: "none",
      ...e.style
    }),
    [e.style]
  ), x = t.useCallback(
    (F) => {
      r && r.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [r, h]
  ), R = t.useCallback(
    (F) => {
      o && o.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [o, h]
  ), L = t.useCallback(
    (F) => {
      a && a.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [a, h]
  ), _ = t.useCallback(
    (F) => {
      d && d.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [d, h]
  ), O = t.useCallback(
    (F) => {
      s && s.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [s, h]
  ), f = t.useCallback(
    (F) => {
      c && c.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [c, h]
  ), I = t.useCallback(
    (F) => {
      l && l.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [l, h]
  ), b = t.useCallback(
    (F) => {
      i && i.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [i, h]
  ), A = t.useCallback(
    (F) => {
      u && u.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [u, h]
  ), N = t.useCallback(
    (F) => {
      m && m.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [m, h]
  ), X = t.useCallback(
    (F) => {
      g && g.call(void 0, {
        syntheticEvent: F,
        target: h.current
      });
    },
    [g, h]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: y,
      id: e.id,
      style: z,
      className: C,
      tabIndex: D,
      "aria-selected": e.selected || void 0,
      onFocus: x,
      onBlur: R,
      onClick: L,
      onMouseEnter: f,
      onMouseLeave: I,
      onMouseOver: _,
      onMouseOut: O,
      onDoubleClick: b,
      onKeyDown: A,
      onKeyPress: N,
      onKeyUp: X,
      "data-slot": !0,
      "data-slot-allday": e.isAllDay,
      "data-slot-start": e.start.getTime(),
      "data-slot-end": e.end.getTime(),
      "data-slot-group": e.group.index,
      "data-slot-range": e.range.index,
      "data-slot-index": e.index
    },
    e.children
  );
}), Oa = {
  isWorkHour: !0,
  isWorkDay: !0
};
_l.displayName = "KendoReactSchedulerSlot";
const Ll = t.forwardRef((e, n) => {
  const { slot: r, _ref: o, ...a } = e, c = r || Pa.slot, l = t.useRef(null), s = t.useRef(null);
  return t.useImperativeHandle(l, () => ({ props: e })), t.useImperativeHandle(o, () => s.current), t.useImperativeHandle(n, () => l.current), Qc(s, e.expandable ?? Pa.expandable), /* @__PURE__ */ t.createElement(c, { ...a, _ref: s });
}), Pa = {
  slot: _l,
  expandable: !1
};
Ll.displayName = "KendoReactSchedulerViewSlot";
const an = t.forwardRef((e, n) => {
  const {
    _ref: r,
    onDataAction: o,
    viewSlot: a,
    form: c,
    formItem: l,
    onFormItemChange: s,
    ...d
  } = e, [i, u] = t.useState(e.tabIndex), m = t.useRef(null), g = t.useRef(null);
  t.useImperativeHandle(g, () => ({ props: e })), t.useImperativeHandle(n, () => g.current), t.useImperativeHandle(r, () => m.current);
  const h = Ot(e.editable), y = Pe(), [D] = zt(), [C] = nn(), [z, x] = Gc(), [, R] = Il(), L = c || pa.form, _ = a || pa.viewSlot, [O, f] = Ae(null, l, e.onFormItemChange), I = z.some((S) => !!(S.current && S.current.props.start.getTime() === e.start.getTime() && S.current.props.end.getTime() === e.end.getTime() && S.current.props.index === e.index && S.current.props.group.index === e.group.index && S.current.props.range.index === e.range.index && S.current.props.isAllDay === e.isAllDay)), b = t.useCallback(
    () => {
      const S = {};
      if (j(S, y.start, new Date(e.start.getTime())), j(S, y.end, new Date(e.end.getTime())), j(S, y.isAllDay, e.isAllDay), e.group.resources.length)
        for (let U = 0; U < e.group.resources.length; U++) {
          const k = e.group.resources[U];
          if (sc(e.group.resources)) {
            const E = q(e.group.resources[U], k.valueField);
            j(S, k.field, k.multiple ? [E] : E);
          } else
            j(S, k.field, k.multiple ? [] : void 0);
        }
      return S;
    },
    [
      y.start,
      y.end,
      y.isAllDay,
      e.start,
      e.end,
      e.isAllDay,
      e.group.resources
    ]
  ), A = t.useCallback(
    (S) => {
      h.select && x({
        type: ha.select,
        slot: m
      }, S.syntheticEvent), e.onFocus && e.onFocus.call(void 0, S);
    },
    [
      x,
      h.select,
      e.onFocus
    ]
  ), N = t.useCallback(
    (S) => {
      if (h.add) {
        const U = b();
        f(U, S);
      }
      e.onDoubleClick && e.onDoubleClick.call(void 0, S);
    },
    [
      b,
      h.add,
      e.onDoubleClick,
      f
    ]
  ), X = t.useCallback(
    (S) => {
      let U;
      switch (S.syntheticEvent.keyCode) {
        case He.left:
          if (!D)
            return;
          S.syntheticEvent.preventDefault(), R({ type: Le.left, slot: m }, S.syntheticEvent);
          break;
        case He.right:
          if (!D)
            return;
          S.syntheticEvent.preventDefault(), R({ type: Le.right, slot: m }, S.syntheticEvent);
          break;
        case He.up:
          if (!D)
            return;
          S.syntheticEvent.preventDefault(), R({ type: Le.up, slot: m }, S.syntheticEvent);
          break;
        case He.down:
          if (!D)
            return;
          S.syntheticEvent.preventDefault(), R({ type: Le.down, slot: m }, S.syntheticEvent);
          break;
        case He.enter: {
          if (!D || !h.add)
            return;
          const k = b();
          f(k);
          break;
        }
        case He.tab:
          U = gc(S.target);
          break;
      }
      U && (S.syntheticEvent.preventDefault(), U.element && U.element.focus());
    },
    [b, R, h.add, f, D]
  ), F = t.useCallback(
    (S) => {
      o && o.call(
        void 0,
        {
          type: ze.create,
          series: !1,
          dataItem: S.value
        },
        S
      ), f(null, S.syntheticEvent);
    },
    [
      o,
      f
    ]
  ), V = t.useCallback(
    (S) => {
      f(null, S.syntheticEvent);
    },
    [f]
  ), p = t.useCallback(
    (S) => {
      f(null, S);
    },
    [f]
  ), P = t.useCallback(
    (S, U) => {
      f && f(S, U);
    },
    [f]
  );
  return t.useEffect(() => {
    const S = D.length && D[0].current === m.current;
    u(e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : z.length === 0 && S && C.length === 0 ? 0 : void 0);
  }, [C, e.tabIndex, z.length, D]), /* @__PURE__ */ t.createElement(
    Vc,
    {
      props: e,
      form: [O, P]
    },
    /* @__PURE__ */ t.createElement(
      _,
      {
        ...d,
        _ref: m,
        selected: I,
        tabIndex: i,
        onFocus: A,
        onDoubleClick: N,
        onKeyDown: X
      }
    ),
    O && /* @__PURE__ */ t.createElement(
      L,
      {
        dataItem: O,
        onSubmit: F,
        onClose: p,
        onCancel: V
      }
    )
  );
}), pa = {
  viewSlot: Ll,
  form: ga
};
an.displayName = "KendoReactSchedulerEditSlot";
const Ea = t.forwardRef((e, n) => {
  const {
    isRemove: r,
    onClose: o,
    onSeriesClick: a,
    onOccurrenceClick: c
  } = e, l = t.useRef(null);
  t.useImperativeHandle(l, () => ({ props: e })), t.useImperativeHandle(n, () => l.current);
  const s = Fe(), d = (I) => s.toLanguageString(I, Q[I]), i = d(ll), u = d(ol), m = d(cl), g = d(sl), h = d(Dl), y = d(Sl), D = d(wl), C = d(kl), z = r ? D : g, x = r ? C : m, R = r ? h : i, L = r ? y : u, _ = t.useCallback(
    ({ syntheticEvent: I }) => {
      o && o.call(void 0, { syntheticEvent: I, value: null, target: l.current });
    },
    [o]
  ), O = t.useCallback(
    (I) => {
      a && a.call(void 0, { syntheticEvent: I, value: null, target: l.current });
    },
    [a]
  ), f = t.useCallback(
    (I) => {
      c && c.call(void 0, { syntheticEvent: I, value: null, target: l.current });
    },
    [c]
  );
  return Tr ? wn.createPortal(
    /* @__PURE__ */ t.createElement(Nr, { title: z, onClose: _ }, x, /* @__PURE__ */ t.createElement(Ar, null, /* @__PURE__ */ t.createElement(Re, { onClick: f }, R), /* @__PURE__ */ t.createElement(Re, { onClick: O }, L))),
    document && document.body
  ) : null;
});
Ea.displayName = "KendoReactSchedulerSchedulerOccurrenceDialog";
const ya = t.forwardRef((e, n) => {
  const { onClose: r, onCancel: o, onConfirm: a } = e, c = t.useRef(null);
  t.useImperativeHandle(c, () => ({ props: e })), t.useImperativeHandle(n, () => c.current);
  const l = Fe(), s = l.toLanguageString(Yt, Q[Yt]), d = l.toLanguageString(gr, Q[gr]), i = l.toLanguageString(Er, Q[Er]), u = l.toLanguageString(yr, Q[yr]), m = t.useCallback(
    ({ syntheticEvent: y }) => {
      if (!r)
        return;
      const D = {
        syntheticEvent: y,
        value: null,
        target: c.current
      };
      r.call(void 0, D);
    },
    [r]
  ), g = t.useCallback(
    (y) => {
      o && o.call(void 0, { syntheticEvent: y, value: null });
    },
    [o]
  ), h = t.useCallback(
    (y) => {
      a && a.call(void 0, { syntheticEvent: y, value: null });
    },
    [a]
  );
  return Tr ? wn.createPortal(
    /* @__PURE__ */ t.createElement(Nr, { title: u, onClose: m }, i, /* @__PURE__ */ t.createElement(Ar, null, /* @__PURE__ */ t.createElement(Re, { onClick: g }, s), /* @__PURE__ */ t.createElement(Re, { onClick: h }, d))),
    document && document.body
  ) : null;
});
ya.displayName = "KendoReactSchedulerRemoveDialog";
const ln = t.forwardRef((e, n) => {
  const {
    // Focus
    onFocus: r,
    onBlur: o,
    // Mouse
    onMouseDown: a,
    onClick: c,
    onMouseUp: l,
    onMouseOut: s,
    onMouseOver: d,
    onMouseEnter: i,
    onMouseLeave: u,
    onDoubleClick: m,
    onRemoveClick: g,
    // Keyboard
    onKeyUp: h,
    onKeyDown: y,
    onKeyPress: D,
    // Drag
    onPress: C,
    onDrag: z,
    onRelease: x,
    // Resize
    onResizePress: R,
    onResizeEndDrag: L,
    onResizeRelease: _,
    onResizeStartDrag: O
  } = e, { item: f, element: I } = Jc(e, n), b = en(I), A = t.useRef(null), N = t.useRef(null), X = t.useRef(null), F = t.useRef(null), V = Ot(e.editable), p = $e(), S = Fe().toLanguageString(Gt, Q[Gt]), U = e.group.resources.find((G) => !!(G.colorField && G[G.colorField] !== "" && G[G.colorField] !== void 0)), k = U && U.colorField && U[U.colorField], E = e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : e.selected ? 0 : -1, M = t.useMemo(
    () => he(
      {
        "k-event": !e.resizeHint,
        "k-selected": e.selected && V.select,
        "k-event-drag-hint": e.dragHint,
        "k-scheduler-marquee": e.resizeHint,
        "k-marquee": e.resizeHint,
        "k-first": e.resizeHint && !e.tail,
        "k-last": e.resizeHint && !e.head
      },
      e.className
    ),
    [
      e.resizeHint,
      e.selected,
      e.dragHint,
      e.tail,
      e.head,
      e.className,
      V.select
    ]
  ), W = t.useMemo(
    () => `${ic(p, e.zonedStart, e.zonedEnd, e.isAllDay)}, ${e.title}`,
    [p, e.isAllDay, e.title, e.zonedEnd, e.zonedStart]
  ), J = t.useMemo(
    () => ({
      cursor: "pointer",
      userSelect: "none",
      borderColor: e.resizeHint ? void 0 : k,
      backgroundColor: e.resizeHint ? void 0 : k,
      touchAction: "none",
      ...e.style
    }),
    [k, e.style, e.resizeHint]
  ), ne = t.useCallback(
    (G) => {
      r && r.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [r, f]
  ), B = t.useCallback(
    (G) => {
      o && o.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [o, f]
  ), re = t.useCallback(
    (G) => {
      a && a.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [a, f]
  ), de = t.useCallback(
    (G) => {
      c && c.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [c, f]
  ), fe = t.useCallback(
    (G) => {
      l && l.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [l, f]
  ), ae = t.useCallback(
    (G) => {
      d && d.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [d, f]
  ), Ie = t.useCallback(
    (G) => {
      s && s.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [s, f]
  ), ge = t.useCallback(
    (G) => {
      i && i.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [i, f]
  ), De = t.useCallback(
    (G) => {
      u && u.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [u, f]
  ), Ee = t.useCallback(
    (G) => {
      m && m.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [m, f]
  ), pe = t.useCallback(
    (G) => {
      g && g.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [g, f]
  ), H = t.useCallback(
    (G) => {
      y && y.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [y, f]
  ), $ = t.useCallback(
    (G) => {
      D && D.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [D, f]
  ), ie = t.useCallback(
    (G) => {
      h && h.call(void 0, {
        syntheticEvent: G,
        target: f.current
      });
    },
    [h, f]
  ), le = t.useCallback(
    (G) => {
      C && C.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [C, f]
  ), se = t.useCallback(
    (G) => {
      z && z.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [z, f]
  ), Se = t.useCallback(
    (G) => {
      x && x.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [x, f]
  ), we = t.useCallback(
    (G) => {
      R && R.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [R, f]
  ), Ze = t.useCallback(
    (G) => {
      O && O.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [O, f]
  ), it = t.useCallback(
    (G) => {
      L && L.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [L, f]
  ), dt = t.useCallback(
    (G) => {
      _ && _.call(void 0, {
        dragEvent: G,
        target: f.current
      });
    },
    [_, f]
  );
  return Kt(I, {
    onPress: le,
    onDrag: se,
    onRelease: Se
  }), Kt(A, {
    onPress: we,
    onDrag: it,
    onRelease: dt
  }), Kt(N, {
    onPress: we,
    onDrag: Ze,
    onRelease: dt
  }), Kt(X, {
    onPress: we,
    onDrag: Ze,
    onRelease: dt
  }), Kt(F, {
    onPress: we,
    onDrag: it,
    onRelease: dt
  }), /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: I,
      id: e.id,
      style: J,
      tabIndex: E,
      className: M,
      role: "button",
      "aria-label": W,
      onFocus: ne,
      onBlur: B,
      onMouseUp: fe,
      onMouseDown: re,
      onClick: de,
      onMouseOver: ae,
      onMouseOut: Ie,
      onMouseEnter: ge,
      onMouseLeave: De,
      onDoubleClick: Ee,
      onKeyDown: H,
      onKeyPress: $,
      onKeyUp: ie,
      "data-group-index": e.group.index,
      "data-range-index": e.range.index
    },
    e.children,
    !e.resizeHint && /* @__PURE__ */ t.createElement("span", { className: "k-event-actions" }, V.remove && /* @__PURE__ */ t.createElement(
      "a",
      {
        tabIndex: -1,
        "aria-hidden": "true",
        className: "k-link k-event-delete",
        title: S,
        "aria-label": S,
        onClick: pe
      },
      /* @__PURE__ */ t.createElement(Me, { name: "x", icon: Ba })
    ), e.head && /* @__PURE__ */ t.createElement(
      Me,
      {
        name: b === "rtl" ? "caret-alt-left" : "caret-alt-right",
        icon: b === "rtl" ? Rt : It
      }
    )),
    V.resize && e.vertical && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: "k-resize-handle k-resize-n", ref: X }), /* @__PURE__ */ t.createElement("span", { className: "k-resize-handle k-resize-s", ref: F })),
    V.resize && !e.vertical && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("span", { className: "k-resize-handle k-resize-w", ref: N }), /* @__PURE__ */ t.createElement("span", { className: "k-resize-handle k-resize-e", ref: A })),
    e.resizeHint && /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      "div",
      {
        className: "k-marquee-color",
        style: { borderColor: k, backgroundColor: k }
      }
    ), /* @__PURE__ */ t.createElement("div", { className: "k-marquee-text" }, !e.tail && /* @__PURE__ */ t.createElement("div", { className: "k-label-top" }, p.formatDate(e.zonedStart, e.format)), !e.head && /* @__PURE__ */ t.createElement("div", { className: "k-label-bottom" }, p.formatDate(e.zonedEnd, e.format))))
  );
});
ln.displayName = "KendoReactSchedulerItem";
const kn = t.forwardRef((e, n) => {
  const r = t.useMemo(
    () => he(
      "k-event-template",
      e.className
    ),
    [e.className]
  );
  return /* @__PURE__ */ t.createElement("div", { ref: n, ...e, className: r });
}), qs = 1, bn = t.forwardRef((e, n) => {
  const { item: r, _ref: o, itemRef: a, ...c } = e, l = t.useRef(), s = t.useRef(null), d = t.useRef(null), i = t.useRef(null), u = Ot(e.editable);
  t.useImperativeHandle(d, () => ({ props: e, element: s.current && s.current.element })), t.useImperativeHandle(n, () => d.current), t.useImperativeHandle(o, () => s.current), t.useImperativeHandle(a, () => s.current);
  const m = r || Zs.item, g = $e(), [h] = nn(), [y] = zt(), D = tn(), [C, z] = t.useState(!0), [x, R] = t.useState(!1), [L, _] = t.useState(0), O = en(D), f = t.useMemo(
    () => e.isAllDay ? g.toString(e.zonedStart, "t") : g.format("{0:t} - {1:t}", e.zonedStart, e.zonedEnd),
    [g, e.isAllDay, e.zonedEnd, e.zonedStart]
  ), I = t.useMemo(() => `(${f}): ${e.title}`, [f, e.title]), b = (P, S) => {
    let U = 1;
    return P.forEach((k) => {
      const E = S.filter((M) => N(k.current.props, M.props));
      E.length > U && (U = E.length);
    }), U;
  }, A = (P, S) => P.map((k) => S.filter((E) => N(k.current.props, E.props))), N = (P, S) => Oe(P.start, P.end, S.start, S.end) && P.group.index === S.group.index && P.range.index === S.range.index && (e.ignoreIsAllDay || P.isAllDay === S.isAllDay), X = () => {
    const P = (y || []).filter((k) => k.current && N(k.current.props, e));
    if (P.length === 0) {
      z(!1);
      return;
    }
    const S = Et(P);
    if (!S.current || !s.current)
      return;
    const U = Ke(S.current.element);
    _t(s.current.element, U);
  }, F = () => {
    const P = s.current && s.current.element;
    if (!P)
      return;
    const S = (y || []).filter((de) => de.current && N(de.current.props, e)), U = [], k = [], E = [];
    (h || []).forEach((de) => {
      de.current && (de.current.props.dragHint ? k.push(de.current) : de.current.props.resizeHint ? E.push(de.current) : U.push(de.current));
    });
    const M = e.dragHint || e.resizeHint ? Ja(s.current, e.dragHint ? k : E, S, e.ignoreIsAllDay) : e.order || 0;
    let W = e.dragHint || e.resizeHint ? b(S, e.dragHint ? k : E) : b(S, U);
    const J = A(S, U);
    let ne = 0;
    const B = Ke(P);
    if (J.forEach((de) => {
      let fe = 0;
      de.forEach((ae) => {
        Oe(ae.props.start, ae.props.end, e.start, e.end) && !(e.dragHint || e.resizeHint) && ae.props._maxSiblingsPerSlot && ae.props._maxSiblingsPerSlot > W && ae.element !== P && (W = ae.props._maxSiblingsPerSlot);
        const Ie = Ke(ae.element);
        ae.props.order !== null && ae.props.order < M && (fe = Ie.top + Ie.height - B.top - be * M + qs);
      }), fe > ne && (ne = fe);
    }), S.length === 0) {
      z(!1);
      return;
    }
    const re = u.add ? 20 : 0;
    B.width = e.vertical ? B.width / W - be - re / W : B.width * S.length - be, B.height = e.vertical ? B.height * S.length - be : (e.resizeHint || e.dragHint) && W <= 1 ? B.height : e.style && e.style.height ? e.style.height : 25, B.left = e.vertical ? B.left + M * B.width + be * M : B.left, B.top = e.vertical ? B.top : B.top + ne + be * M, _(W), _t(P, B), R(!0), z(!0);
  }, V = t.useCallback(
    (P) => {
      const S = P && P[0], U = i.current;
      l.current !== void 0 && window.cancelAnimationFrame(l.current), U && S && (U.width !== S.contentRect.width || U.height !== S.contentRect.height) && (l.current = window.requestAnimationFrame(() => {
        X(), F();
      })), i.current = { width: S.contentRect.width, height: S.contentRect.height };
    },
    [X, F]
  );
  t.useEffect(X), t.useEffect(F);
  const p = s.current && s.current.element ? s.current.element.closest(".k-scheduler-layout") : null;
  return xl({
    element: p,
    selector: ".k-resource-row",
    horizontalAttribute: "data-depth-index",
    verticalAttribute: "data-resource-index",
    applyTo: ".k-resource-cell",
    syncHeight: e.isLast
  }), t.useEffect(
    () => {
      if (!D.current)
        return;
      const P = window.ResizeObserver, S = P && new P(V);
      return S && S.observe(D.current), () => {
        S && S.disconnect();
      };
    },
    [V, D]
  ), /* @__PURE__ */ t.createElement(
    m,
    {
      ...c,
      _ref: s,
      _maxSiblingsPerSlot: L,
      itemRef: s,
      style: {
        visibility: x ? void 0 : "hidden",
        display: C ? void 0 : "none",
        ...e.style
      }
    },
    !e.resizeHint && /* @__PURE__ */ t.createElement("span", { className: "k-event-actions" }, e.tail && /* @__PURE__ */ t.createElement(
      Me,
      {
        name: O === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: O === "rtl" ? It : Rt
      }
    ), e.isRecurring && !e.isException && /* @__PURE__ */ t.createElement(Me, { name: "arrow-rotate-cw", icon: zr }), !e.isRecurring && e.isException && /* @__PURE__ */ t.createElement(Me, { name: "arrows-no-repeat", icon: Ga })),
    !e.resizeHint && /* @__PURE__ */ t.createElement("div", { title: I }, !e.isAllDay && /* @__PURE__ */ t.createElement(kn, { className: "k-event-template k-event-time " }, I), /* @__PURE__ */ t.createElement(kn, { className: "k-event-template" }, e.title))
  );
}), Zs = {
  item: ln
};
bn.displayName = "KendoReactSchedulerViewItem";
const Ol = (e) => {
  const n = Rl(), { timezone: r } = qe(), o = Mt(), a = Pe(), c = vt(), [l] = zt(), s = e.viewItem || Xs.viewItem, d = t.useMemo(
    () => Pt([e.dataItem], { dateRange: c, fields: a, timezone: r }),
    [e.dataItem, c, a, r]
  ), i = t.useMemo(
    () => xt(d, { timezone: r }, { groups: o, ranges: n }),
    [d, r, o, n]
  ), u = (l || []).map((m) => m.current.props);
  return Tt(i, u), /* @__PURE__ */ t.createElement(t.Fragment, null, i.map((m, g) => /* @__PURE__ */ t.createElement(
    s,
    {
      key: g,
      ...m,
      item: e.item,
      dragHint: !0,
      vertical: e.vertical,
      ignoreIsAllDay: e.ignoreIsAllDay
    }
  )));
}, Xs = {
  viewItem: bn,
  item: ln
};
Ol.displayName = "KendoReactSchedulerDrag";
const Pl = (e) => {
  const n = Rl(), { timezone: r } = qe(), o = Mt(), a = Pe(), c = vt(), [l] = zt(), s = e.viewItem || Wa.viewItem, d = t.useMemo(
    () => Pt([e.dataItem], { dateRange: c, fields: a, timezone: r }),
    [e.dataItem, c.start.getTime(), c.end.getTime(), a, r]
  ), i = t.useMemo(
    () => xt(d, { timezone: r }, { groups: o, ranges: n }),
    [d, r, o, n]
  ), u = (l || []).map((m) => m.current.props);
  return Tt(i, u), /* @__PURE__ */ t.createElement(t.Fragment, null, i.map((m, g) => /* @__PURE__ */ t.createElement(
    s,
    {
      key: g,
      ...m,
      format: e.format,
      item: e.item ?? Wa.item,
      resizeHint: !0,
      vertical: e.vertical,
      ignoreIsAllDay: e.ignoreIsAllDay
    }
  )));
}, Wa = {
  viewItem: bn,
  item: ln
};
Pl.displayName = "KendoReactSchedulerResize";
var Be = /* @__PURE__ */ ((e) => (e.set = "FORM_ITEM_SET", e.setMaster = "FORM_ITEM_SET_MASTER", e.reset = "FORM_ITEM_RESET", e.complete = "FORM_ITEM_COMPLETE", e))(Be || {});
const js = (e, n) => {
  const [r, o] = Ae(...n), a = Pe(), [c] = Lt();
  return [r, o, (s, d) => {
    let i;
    switch (s.type) {
      case "FORM_ITEM_SET":
        i = s.payload;
        break;
      case "FORM_ITEM_RESET":
        i = null;
        break;
      case "FORM_ITEM_SET_MASTER":
        i = ce(ht(s.payload, a, c));
        break;
      case "FORM_ITEM_COMPLETE":
        e.onDataAction && r && (e.onDataAction.call(void 0, {
          type: ze.update,
          series: e.series,
          dataItem: s.payload
        }), i = null);
        break;
      default:
        i = r;
        break;
    }
    o(i, d);
  }];
};
var ye = /* @__PURE__ */ ((e) => (e.set = "SHOW_OCCURRENCE_DIALOG_SET", e.open = "SHOW_OCCURRENCE_DIALOG_OPEN", e.close = "SHOW_OCCURRENCE_DIALOG_CLOSE", e.reset = "SHOW_OCCURRENCE_DIALOG_RESET", e.toggle = "SHOW_OCCURRENCE_DIALOG_TOGGLE", e))(ye || {});
const Qs = (e, n) => {
  switch (n.type) {
    case "SHOW_OCCURRENCE_DIALOG_RESET":
      return !1;
    case "SHOW_OCCURRENCE_DIALOG_SET":
      return n.payload;
    case "SHOW_OCCURRENCE_DIALOG_OPEN":
      return !0;
    case "SHOW_OCCURRENCE_DIALOG_CLOSE":
      return !1;
    case "SHOW_OCCURRENCE_DIALOG_TOGGLE":
      return !e;
    default:
      return e;
  }
}, Js = (e, n, r) => {
  const [o, a] = Ae(e, n, r);
  return [o, a, (l) => {
    const s = Qs(o, l);
    a(s);
  }];
};
var rt = /* @__PURE__ */ ((e) => (e.set = "REMOVE_ITEM_SET", e.reset = "REMOVE_ITEM_RESET", e.complete = "REMOVE_ITEM_COMPLETE", e))(rt || {});
const ei = (e, n) => {
  const [r, o] = Ae(...n);
  return [r, o, (c) => {
    let l;
    switch (c.type) {
      case "REMOVE_ITEM_SET":
        l = c.payload;
        break;
      case "REMOVE_ITEM_RESET":
        l = null;
        break;
      case "REMOVE_ITEM_COMPLETE":
        e.onDataAction && r && e.onDataAction.call(void 0, {
          type: ze.remove,
          series: e.series,
          dataItem: r
        }), l = null;
        break;
      default:
        l = r;
        break;
    }
    o(l);
  }];
};
var et = /* @__PURE__ */ ((e) => (e.set = "SHOW_REMOVE_DIALOG_SET", e.open = "SHOW_REMOVE_DIALOG_OPEN", e.close = "SHOW_REMOVE_DIALOG_CLOSE", e.reset = "SHOW_REMOVE_DIALOG_RESET", e.toggle = "SHOW_REMOVE_DIALOG_TOGGLE", e))(et || {});
const ti = (e, n) => {
  switch (n.type) {
    case "SHOW_REMOVE_DIALOG_RESET":
      return !1;
    case "SHOW_REMOVE_DIALOG_SET":
      return n.payload;
    case "SHOW_REMOVE_DIALOG_OPEN":
      return !0;
    case "SHOW_REMOVE_DIALOG_CLOSE":
      return !1;
    case "SHOW_REMOVE_DIALOG_TOGGLE":
      return !e;
    default:
      return e;
  }
}, ni = (e, n, r) => {
  const [o, a] = Ae(e, n, r);
  return [o, a, (l) => {
    const s = ti(o, l);
    a(s);
  }];
};
var ke = /* @__PURE__ */ ((e) => (e.set = "DRAG_ITEM_SET", e.start = "DRAG_ITEM_START", e.drag = "DRAG_ITEM_DRAG", e.complete = "DRAG_ITEM_COMPLETE", e.completeOccurrence = "DRAG_ITEM_COMPLETE_OCCURRENCE", e.completeSeries = "DRAG_ITEM_COMPLETE_SERIES", e.reset = "DRAG_ITEM_RESET", e.dragSelected = "DRAG_ITEM_DRAG_SELECTED", e))(ke || {});
const ri = (e, n) => {
  const r = t.useRef(0), o = t.useRef(0), a = t.useRef(0), c = t.useRef(null), [l, s] = Ae(...n), [d] = da(), i = Pe(), u = Mt();
  return [l, s, (g) => {
    switch (g.type) {
      case "DRAG_ITEM_SET": {
        s(g.payload);
        break;
      }
      case "DRAG_ITEM_RESET": {
        s(null);
        break;
      }
      case "DRAG_ITEM_DRAG_SELECTED": {
        if (Math.abs(o.current - g.payload.x) < 10 && Math.abs(a.current - g.payload.y) < 10)
          return;
        const h = nt(g.payload.x, g.payload.y, 7);
        if (!h || h === c.current)
          return;
        const y = ce(e.dataItem), D = h.getAttribute("data-slot-start"), C = h.getAttribute("data-slot-allday") === "true";
        if (!e.ignoreIsAllDay && C !== e.isAllDay)
          return;
        const z = new Date(q(y, i.start)), x = Number(D) - z.getTime(), R = d.map((L) => {
          if (!L.current)
            return null;
          const _ = ce(L.current.props.dataItem), O = new Date(L.current.props.start.getTime() + x), f = new Date(L.current.props.end.getTime() + x);
          return j(_, i.start, O), j(_, i.end, f), _;
        }).filter(Boolean);
        c.current = h, s([...R]);
        break;
      }
      case "DRAG_ITEM_START": {
        const h = g.payload.x, y = g.payload.y;
        o.current = h, a.current = y;
        const D = nt(h, y, 7);
        if (!D)
          return;
        const C = ce(e.dataItem), z = D.getAttribute("data-slot-start"), x = q(C, i.start);
        if (z === null)
          return;
        r.current = Number(z) - new Date(x).getTime();
        break;
      }
      case "DRAG_ITEM_DRAG": {
        if (Math.abs(o.current - g.payload.x) < 10 && Math.abs(a.current - g.payload.y) < 10)
          return;
        const h = nt(g.payload.x, g.payload.y, 7);
        if (!h || h === c.current)
          return;
        const y = ce(e.dataItem), D = h.getAttribute("data-slot-start"), C = h.getAttribute("data-slot-group"), z = h.getAttribute("data-slot-allday") === "true";
        if (!e.ignoreIsAllDay && z !== e.isAllDay)
          return;
        const x = new Date(q(y, i.start)), L = new Date(q(y, i.end)).getTime() - x.getTime(), _ = new Date(Number(D) - Number(r.current)), O = new Date(Number(D) - Number(r.current) + L), f = u.find((I) => I.index === Number(C));
        j(y, i.start, _), j(y, i.end, O), f && u.length > 1 && f.resources.forEach((I) => {
          I.multiple || j(y, I.field, I[I.valueField]);
        }), c.current = h, y && s(y);
        break;
      }
      case "DRAG_ITEM_COMPLETE": {
        s(null), e.onDataAction && l && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !1,
          dataItem: l
        });
        break;
      }
      case "DRAG_ITEM_COMPLETE_OCCURRENCE": {
        const h = Array.isArray(l) ? l.slice() : ce(l);
        s(null), e.onDataAction && l && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !1,
          dataItem: h
        });
        break;
      }
      case "DRAG_ITEM_COMPLETE_SERIES": {
        let h;
        if (Array.isArray(l))
          h = l.map((y) => {
            const D = ce(y);
            return j(D, i.start, q(y, i.start)), j(D, i.end, q(y, i.end)), D;
          });
        else {
          const y = ce(l);
          j(y, i.start, q(l, i.start)), j(y, i.end, q(l, i.end)), h = y;
        }
        s(null), e.onDataAction && h && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !0,
          dataItem: h
        });
        break;
      }
      default:
        s(l);
        break;
    }
  }];
};
var me = /* @__PURE__ */ ((e) => (e.set = "RESIZE_ITEM_SET", e.start = "RESIZE_ITEM_START", e.startDrag = "RESIZE_ITEM_START_DRAG", e.startDragSelected = "RESIZE_ITEM_START_DRAG_SELECTED", e.endDrag = "RESIZE_ITEM_END_DRAG", e.endDragSelected = "RESIZE_ITEM_END_DRAG_SELECTED", e.complete = "RESIZE_ITEM_COMPLETE", e.completeOccurrence = "RESIZE_ITEM_COMPLETE_OCCURRENCE", e.completeSeries = "RESIZE_ITEM_COMPLETE_SERIES", e.reset = "RESIZE_ITEM_RESET", e))(me || {});
const ai = (e, n) => {
  const r = t.useRef(null), [o, a] = Ae(...n), [c] = da(), l = Pe();
  return [o, a, (d, i) => {
    let u = o;
    switch (d.type) {
      case "RESIZE_ITEM_SET":
        u = d.payload;
        break;
      case "RESIZE_ITEM_RESET":
        u = null;
        break;
      case "RESIZE_ITEM_START": {
        i.stopPropagation();
        const m = d.payload.x, g = d.payload.y, h = nt(m, g, 7);
        if (!h || h === r.current)
          return;
        const y = h.getAttribute("data-slot-start"), D = new Date(Number(y)), C = ce(e.dataItem);
        if (D >= q(C, l.end))
          return;
        j(C, l.start, D), r.current = h, u = C;
        break;
      }
      case "RESIZE_ITEM_START_DRAG_SELECTED": {
        i.stopPropagation();
        const m = d.payload.x, g = d.payload.y, h = ce(e.dataItem), y = nt(m, g, 7);
        if (!y || y === r.current)
          return;
        const D = y.getAttribute("data-slot-start"), C = new Date(q(h, l.start)), x = new Date(Number(D)).getTime() - C.getTime();
        let R = !1;
        const L = c.map((_) => {
          if (!_.current)
            return null;
          const O = ce(_.current.props.dataItem), f = new Date(_.current.props.start.getTime() + x);
          if (f >= q(O, l.end)) {
            R = !0;
            return;
          }
          return j(O, l.start, f), O;
        }).filter(Boolean);
        R || (u = [...L]);
        break;
      }
      case "RESIZE_ITEM_START_DRAG": {
        const m = d.payload.x, g = d.payload.y, h = nt(m, g, 7);
        if (!h || h === r.current)
          return;
        const y = h.getAttribute("data-slot-start"), D = new Date(Number(y)), C = ce(e.dataItem);
        if (D >= C.end)
          return;
        j(C, l.start, D), r.current = h, u = C;
        break;
      }
      case "RESIZE_ITEM_END_DRAG": {
        const m = d.payload.x, g = d.payload.y, h = nt(m, g, 7);
        if (!h || h === r.current)
          return;
        const y = h.getAttribute("data-slot-end"), D = new Date(Number(y)), C = ce(e.dataItem);
        if (D <= C.start)
          return;
        j(C, l.end, D), r.current = h, u = C;
        break;
      }
      case "RESIZE_ITEM_END_DRAG_SELECTED": {
        i.stopPropagation();
        const m = d.payload.x, g = d.payload.y, h = ce(e.dataItem), y = nt(m, g, 7);
        if (!y || y === r.current)
          return;
        const D = y.getAttribute("data-slot-start"), C = new Date(q(h, l.end)), x = new Date(Number(D)).getTime() - C.getTime();
        let R;
        const L = c.map((_) => {
          if (!_.current)
            return null;
          const O = ce(_.current.props.dataItem), f = new Date(_.current.props.end.getTime() + x);
          if (f <= q(O, l.start)) {
            R = !0;
            return;
          }
          return j(O, l.end, f), O;
        }).filter(Boolean);
        R || (u = [...L]);
        break;
      }
      case "RESIZE_ITEM_COMPLETE": {
        u = null, e.onDataAction && o && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !1,
          dataItem: o
        });
        break;
      }
      case "RESIZE_ITEM_COMPLETE_OCCURRENCE": {
        u = null, e.onDataAction && o && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !1,
          dataItem: o
        });
        break;
      }
      case "RESIZE_ITEM_COMPLETE_SERIES": {
        u = null;
        let m;
        if (Array.isArray(o))
          m = o.map((g) => {
            const h = ce(g);
            return j(h, l.start, q(g, l.start)), j(h, l.end, q(g, l.end)), h;
          });
        else {
          const g = ce(o);
          j(g, l.start, q(o, l.start)), j(g, l.end, q(o, l.end)), m = g;
        }
        e.onDataAction && m && e.onDataAction.call(void 0, {
          type: ze.update,
          series: !0,
          dataItem: m
        });
        break;
      }
      default:
        u = null;
        break;
    }
    a(u);
  }];
};
var at = /* @__PURE__ */ ((e) => (e.reset = "SERIES_RESET", e.set = "SERIES_SET", e.toggle = "SERIES_TOGGLE", e))(at || {});
const li = (e, n) => {
  switch (n.type) {
    case "SERIES_RESET":
      return null;
    case "SERIES_SET":
      return n.payload;
    case "SERIES_TOGGLE":
      return !e;
    default:
      return e;
  }
}, oi = (e, n, r) => {
  const [o, a] = Ae(e, n, r);
  return [o, a, (l) => {
    const s = li(o, l);
    a(s);
  }];
}, Rn = t.forwardRef((e, n) => {
  const {
    _ref: r,
    itemRef: o,
    onDataAction: a,
    ignoreIsAllDay: c,
    viewItem: l,
    series: s,
    onSeriesChange: d,
    form: i,
    formItem: u,
    onFormItemChange: m,
    drag: g,
    dragItem: h,
    onDragItemChange: y,
    resize: D,
    resizeItem: C,
    onResizeItemChange: z,
    removeDialog: x,
    removeItem: R,
    onRemoveItemChange: L,
    occurrenceDialog: _,
    showOccurrenceDialog: O,
    onShowOccurrenceDialogChange: f,
    showRemoveDialog: I,
    onShowRemoveDialogChange: b,
    onFocus: A,
    onFocusAction: N,
    onMouseDown: X,
    onMouseDownAction: F,
    onMouseUp: V,
    onMouseUpAction: p,
    onClick: P,
    onClickAction: S,
    onDoubleClick: U,
    onDoubleClickAction: k,
    onRemoveClick: E,
    onRemoveClickAction: M,
    onPress: W,
    onPressAction: J,
    onDrag: ne,
    onDragAction: B,
    onRelease: re,
    onReleaseAction: de,
    onResizePress: fe,
    onResizePressAction: ae,
    onResizeStartDrag: Ie,
    onResizeStartDragAction: ge,
    onResizeEndDrag: De,
    onResizeEndDragAction: Ee,
    onResizeRelease: pe,
    onResizeReleaseAction: H,
    onOccurrenceClick: $,
    onOccurrenceClickAction: ie,
    onSeriesClick: le,
    onSeriesClickAction: se,
    onKeyDown: Se,
    onKeyDownAction: we,
    onKeyUp: Ze,
    onKeyUpAction: it,
    onRemoveConfirm: dt,
    onRemoveConfirmAction: G,
    onFormSubmit: Tn,
    onFormSubmitAction: xn,
    onCancel: Mn,
    onCancelAction: zn
  } = { ...Ct, ...e }, [Yl, ql] = t.useState(e.tabIndex), Da = t.useRef(null), Y = t.useRef(null), Zl = Fo();
  t.useImperativeHandle(Da, () => ({ props: e, element: Y.current && Y.current.element })), t.useImperativeHandle(n, () => Da.current), t.useImperativeHandle(r, () => Y.current), t.useImperativeHandle(o, () => Y.current);
  const An = l || Ct.viewItem, Sa = g || Ct.drag, wa = D || Ct.resize, Xl = i || Ct.form, jl = _ || Ct.occurrenceDialog, Ql = x || Ct.removeDialog, cn = Ot(e.editable), [sn, kt] = da(), [dn, , un] = oi(null, s, d), [At, Jl, Nt] = js(
    { series: dn, onDataAction: a },
    [null, u, m]
  ), [ut, eo, Xe] = ri(
    { dataItem: e.dataItem, ignoreIsAllDay: e.ignoreIsAllDay, isAllDay: e.isAllDay, onDataAction: a },
    [null, h, y]
  ), [mt, to, We] = ai(
    { dataItem: e.dataItem, onDataAction: a },
    [null, C, z]
  ), [Dt, no, pt] = ei(
    { series: dn, onDataAction: a },
    [null, R, L]
  ), [mn, ro, St] = ni(!1, I, b), [Wt, ao, wt] = Js(!1, O, f), [Nn] = nn(), [, Fn] = Yc(), [, Ht] = Il(), _n = !!(Y.current && sn && sn.some((w) => w.current === Y.current)), ee = t.useMemo(
    () => ({
      selected: _n,
      series: dn,
      formItem: At,
      dragItem: ut,
      resizeItem: mt,
      removeItem: Dt,
      showRemoveDialog: mn,
      showOccurrenceDialog: Wt
    }),
    [ut, At, Dt, mt, _n, dn, Wt, mn]
  ), K = t.useMemo(
    () => ({
      [at.set]: un,
      [at.toggle]: un,
      [at.reset]: un,
      [_e.select]: kt,
      [_e.add]: kt,
      [_e.remove]: kt,
      [_e.reset]: kt,
      [_e.selectNext]: kt,
      [_e.selectPrev]: kt,
      [Be.set]: Nt,
      [Be.setMaster]: Nt,
      [Be.reset]: Nt,
      [Be.complete]: Nt,
      [rt.set]: pt,
      [rt.reset]: pt,
      [rt.complete]: pt,
      [ye.close]: wt,
      [ye.open]: wt,
      [ye.set]: wt,
      [ye.toggle]: wt,
      [ye.reset]: wt,
      [et.close]: St,
      [et.open]: St,
      [et.set]: St,
      [et.toggle]: St,
      [et.reset]: St,
      [ke.start]: Xe,
      [ke.drag]: Xe,
      [ke.complete]: Xe,
      [ke.completeOccurrence]: Xe,
      [ke.completeSeries]: Xe,
      [ke.set]: Xe,
      [ke.reset]: Xe,
      [ke.dragSelected]: Xe,
      [me.start]: We,
      [me.startDrag]: We,
      [me.startDragSelected]: We,
      [me.endDrag]: We,
      [me.endDragSelected]: We,
      [me.complete]: We,
      [me.completeOccurrence]: We,
      [me.completeSeries]: We,
      [me.set]: We,
      [me.reset]: We,
      [Xt.next]: Fn,
      [Xt.prev]: Fn,
      [Le.left]: Ht,
      [Le.right]: Ht,
      [Le.up]: Ht,
      [Le.down]: Ht,
      null: () => {
      }
    }),
    [
      Xe,
      Nt,
      kt,
      pt,
      We,
      un,
      wt,
      St,
      Fn,
      Ht
    ]
  ), lo = t.useCallback(
    (w) => {
      if (N) {
        const v = N(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      A && A.call(void 0, w);
    },
    [K, A, N, e, ee]
  ), oo = t.useCallback(
    (w) => {
      if (F) {
        const v = F(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      X && X.call(void 0, w);
    },
    [K, X, F, e, ee]
  ), co = t.useCallback(
    (w) => {
      if (p) {
        const v = p(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      V && V.call(void 0, w);
    },
    [K, V, p, e, ee]
  ), [, so] = t.useContext(qr), io = t.useCallback(
    (w) => {
      if (S) {
        so(Y.current);
        const v = S(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      P && P.call(void 0, w);
    },
    [K, P, S, e, ee]
  ), uo = t.useCallback(
    (w) => {
      if (k) {
        const v = k(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      U && U.call(void 0, w);
    },
    [k, U, e, K, ee]
  ), mo = t.useCallback(
    (w) => {
      if (M) {
        const v = M(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }));
      }
      E && E.call(void 0, w);
    },
    [M, E, e, K, ee]
  ), ho = t.useCallback(
    (w) => {
      if (J) {
        const v = J(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }, w));
      }
      W && W.call(void 0, w);
    },
    [J, W, e, K, ee]
  ), fo = t.useCallback(
    (w) => {
      if (B) {
        const v = B(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      ne && ne.call(void 0, w);
    },
    [B, ne, e, K, ee]
  ), go = t.useCallback(
    (w) => {
      if (de) {
        const v = de(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      re && re.call(void 0, w);
    },
    [de, re, e, K, ee]
  ), Eo = t.useCallback(
    (w) => {
      if (ae) {
        const v = ae(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      fe && fe.call(void 0, w);
    },
    [ae, fe, e, ee, K]
  ), yo = t.useCallback(
    (w) => {
      if (ge) {
        const v = ge(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      Ie && Ie.call(void 0, w);
    },
    [Ie, ge, e, K, ee]
  ), vo = t.useCallback(
    (w) => {
      if (Ee) {
        const v = Ee(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      De && De.call(void 0, w);
    },
    [De, Ee, e, K, ee]
  ), ko = t.useCallback(
    (w) => {
      if (H) {
        const v = H(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.dragEvent.originalEvent)) : K[v.type]({ ...v, item: Y }, w.dragEvent.originalEvent));
      }
      pe && pe.call(void 0, w);
    },
    [H, pe, e, K, ee]
  ), Do = t.useCallback(
    (w) => {
      if (xn) {
        const v = xn(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }, w));
      }
      Tn && Tn.call(void 0, w);
    },
    [xn, Tn, e, ee, K]
  ), Vt = t.useCallback(
    (w) => {
      if (zn) {
        const v = zn(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }, w));
      }
      Mn && Mn.call(void 0, w);
    },
    [zn, Mn, e, ee, K]
  ), So = t.useCallback(
    (w) => {
      if (ie) {
        const v = ie(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }, w));
      }
      $ && $.call(void 0, w);
    },
    [ie, $, e, ee, K]
  ), wo = t.useCallback(
    (w) => {
      if (se) {
        const v = se(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w)) : K[v.type]({ ...v, item: Y }, w));
      }
      le && le.call(void 0, w);
    },
    [se, le, e, ee, K]
  ), Co = t.useCallback(
    (w) => {
      if (we) {
        const v = we(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.syntheticEvent)) : K[v.type]({ ...v, item: Y }, w.syntheticEvent));
      }
      Se && Se.call(void 0, w);
    },
    [we, Se, e, ee, K]
  ), bo = t.useCallback(
    (w) => {
      if (it) {
        const v = it(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.syntheticEvent)) : K[v.type]({ ...v, item: Y }, w.syntheticEvent));
      }
      Ze && Ze.call(void 0, w);
    },
    [it, Ze, e, ee, K]
  ), Ro = t.useCallback(
    (w) => {
      if (G) {
        const v = G(w, e, ee);
        v && (Array.isArray(v) ? v.filter(Boolean).map((T) => T && K[T.type]({ ...T, item: Y }, w.syntheticEvent)) : K[v.type]({ ...v, item: Y }, w.syntheticEvent));
      }
      dt && dt.call(void 0, w);
    },
    [G, dt, e, ee, K]
  );
  return t.useEffect(() => {
    const w = Nn.length && Nn[0].current === Y.current;
    ql(e.tabIndex !== void 0 ? e.tabIndex === null ? void 0 : e.tabIndex : sn.length === 0 && w ? 0 : void 0);
  }, [Nn, e.tabIndex, sn.length]), /* @__PURE__ */ t.createElement(
    Hc,
    {
      props: e,
      form: [At, Jl, Nt],
      drag: [ut, eo, Xe],
      resize: [mt, to, We],
      remove: [Dt, no, pt],
      showRemoveDialog: [mn, ro, St],
      showOccurrenceDialog: [Wt, ao, wt]
    },
    /* @__PURE__ */ t.createElement(
      An,
      {
        ...e,
        _ref: Y,
        itemRef: Y,
        selected: _n,
        tabIndex: Yl,
        id: Zl,
        onKeyDown: Co,
        onKeyUp: bo,
        onFocus: lo,
        onMouseUp: co,
        onMouseDown: oo,
        onClick: io,
        onDoubleClick: uo,
        onRemoveClick: mo,
        onPress: ho,
        onDrag: fo,
        onRelease: go,
        onResizePress: Eo,
        onResizeEndDrag: vo,
        onResizeStartDrag: yo,
        onResizeRelease: ko
      }
    ),
    ut && cn.drag && (Array.isArray(ut) ? ut.map((w, v) => /* @__PURE__ */ t.createElement(
      Sa,
      {
        key: v,
        ignoreIsAllDay: c,
        dataItem: w,
        vertical: e.vertical,
        viewItem: An,
        item: e.item
      }
    )) : /* @__PURE__ */ t.createElement(
      Sa,
      {
        ignoreIsAllDay: c,
        dataItem: ut,
        vertical: e.vertical,
        viewItem: An,
        item: e.item
      }
    )),
    mt && cn.resize && (Array.isArray(mt) ? mt.map((w, v) => /* @__PURE__ */ t.createElement(
      wa,
      {
        key: v,
        format: e.format,
        ignoreIsAllDay: c,
        dataItem: w,
        viewItem: e.viewItem,
        item: e.item,
        vertical: e.vertical
      }
    )) : /* @__PURE__ */ t.createElement(
      wa,
      {
        format: e.format,
        ignoreIsAllDay: c,
        dataItem: mt,
        viewItem: e.viewItem,
        item: e.item,
        vertical: e.vertical
      }
    )),
    At && !Wt && cn.edit && /* @__PURE__ */ t.createElement(
      Xl,
      {
        dataItem: At,
        onSubmit: Do,
        onClose: Vt,
        onCancel: Vt
      }
    ),
    Wt && /* @__PURE__ */ t.createElement(
      jl,
      {
        dataItem: At || ut || mt || Dt,
        isRemove: Dt !== null,
        onClose: Vt,
        onOccurrenceClick: So,
        onSeriesClick: wo
      }
    ),
    mn && Dt && cn.remove && /* @__PURE__ */ t.createElement(
      Ql,
      {
        dataItem: Dt,
        onClose: Vt,
        onCancel: Vt,
        onConfirm: Ro
      }
    )
  );
}), Ct = {
  viewItem: bn,
  drag: Ol,
  resize: Pl,
  form: ga,
  occurrenceDialog: Ea,
  removeDialog: ya,
  onClickAction: (e, n, r) => [
    {
      type: e.syntheticEvent.metaKey || e.syntheticEvent.ctrlKey ? r.selected && !r.dragItem && !r.resizeItem ? _e.remove : _e.add : _e.select
    }
  ],
  onDoubleClickAction: (e, n) => n.editable ? [
    { type: Be.set, payload: n.dataItem },
    n.isRecurring && { type: ye.open }
  ].filter(Boolean) : [],
  onRemoveClickAction: (e, n) => n.editable ? [
    { type: rt.set, payload: n.dataItem },
    n.isRecurring ? { type: ye.open } : { type: et.open }
  ] : [],
  onPressAction: (e, n) => n.editable ? { type: ke.start, payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY } } : [],
  onDragAction: (e, n) => n.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? ke.dragSelected : ke.drag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onReleaseAction: (e, n, r) => n.editable && r.dragItem ? n.isRecurring && !n.isException && r.series === null ? { type: ye.open } : {
    type: n.isRecurring ? r.series ? ke.completeSeries : ke.completeOccurrence : ke.complete,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizePressAction: (e, n) => n.editable ? { type: me.start, payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY } } : [],
  onResizeStartDragAction: (e, n) => n.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? me.startDragSelected : me.startDrag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizeEndDragAction: (e, n) => n.editable ? {
    type: e.dragEvent.originalEvent.metaKey || e.dragEvent.originalEvent.ctrlKey ? me.endDragSelected : me.endDrag,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onResizeReleaseAction: (e, n, r) => n.editable && r.resizeItem ? n.isRecurring && !n.isException && r.series === null ? { type: ye.open } : {
    type: n.isRecurring ? r.series ? me.completeSeries : me.completeOccurrence : me.complete,
    payload: { x: e.dragEvent.clientX, y: e.dragEvent.clientY }
  } : [],
  onOccurrenceClickAction: (e, n, r) => r.dragItem ? [
    { type: ke.completeOccurrence },
    { type: ye.close }
  ] : r.resizeItem ? [
    { type: me.completeOccurrence },
    { type: ye.close }
  ] : r.formItem ? [
    { type: at.set, payload: !1 },
    { type: Be.set, payload: n.dataItem },
    { type: ye.close }
  ] : r.removeItem ? [
    { type: at.set, payload: !1 },
    { type: rt.set, payload: n.dataItem },
    { type: et.open },
    { type: ye.close }
  ] : [],
  onSeriesClickAction: (e, n, r) => r.dragItem ? [
    { type: ke.completeSeries },
    { type: ye.close }
  ] : r.resizeItem ? [
    { type: me.completeSeries },
    { type: ye.close }
  ] : r.formItem ? [
    { type: at.set, payload: !0 },
    { type: Be.setMaster, payload: n.dataItem },
    { type: ye.close }
  ] : r.removeItem ? [
    { type: at.set, payload: !0 },
    { type: rt.set, payload: n.dataItem },
    { type: et.open },
    { type: ye.close }
  ] : [],
  onKeyDownAction: (e, n) => {
    switch (e.syntheticEvent.keyCode) {
      case He.enter:
        return [
          { type: Be.set, payload: n.dataItem },
          n.isRecurring && { type: ye.open }
        ];
      case He.tab:
        return [
          { type: e.syntheticEvent.shiftKey ? Xt.prev : Xt.next, ignoreIsAllDay: n.ignoreIsAllDay },
          { type: e.syntheticEvent.shiftKey ? _e.selectPrev : _e.selectNext, ignoreIsAllDay: n.ignoreIsAllDay }
        ];
      case He.up:
        return [
          !!(n.slots.length && n.slots[0]._ref.current) && { type: Le.up, slot: n.slots[0]._ref }
        ];
      case He.right:
        return [
          !!(n.slots.length && n.slots[0]._ref.current) && { type: Le.right, slot: n.slots[0]._ref }
        ];
      case He.down:
        return [
          !!(n.slots.length && n.slots[n.slots.length - 1]._ref.current) && { type: Le.down, slot: n.slots[n.slots.length - 1]._ref }
        ];
      case He.left:
        return [
          !!(n.slots.length && n.slots[0]._ref.current) && { type: Le.left, slot: n.slots[0]._ref }
        ];
      default:
        return;
    }
  },
  onFormSubmitAction: (e) => [
    { type: Be.complete, payload: e.value }
  ],
  onRemoveConfirmAction: () => [
    { type: rt.complete },
    { type: ye.close }
  ],
  onCancelAction: () => [
    { type: at.reset },
    { type: rt.reset },
    { type: Be.reset },
    { type: ke.reset },
    { type: me.reset },
    { type: et.reset },
    { type: ye.reset }
  ]
};
Rn.displayName = "KendoReactSchedulerEditItem";
const ci = (e) => {
  let n = 0;
  return e.forEach((r) => {
    if (r.current) {
      const o = Ke(r.current.element);
      n += o.width;
    }
  }), n;
}, si = (e) => {
  let n = 0;
  return e.forEach((r) => {
    if (r.current) {
      const o = Ke(r.current.element);
      n += o.height;
    }
  }), n;
}, ii = (e, n) => {
  const r = To(e);
  return r.setHours(
    n.getHours(),
    n.getMinutes(),
    n.getSeconds(),
    n.getMilliseconds()
  ), r;
}, Dn = (e) => {
  const [n, r] = t.useState(!1), o = tn(), a = qe(), c = t.useRef(void 0), l = t.useRef(null), s = t.useRef(null), d = e.updateInterval || di.updateInterval, [, i] = t.useState(!1), u = en(s, a.rtl === !0 ? "rtl" : void 0), [m] = zt(), g = t.useCallback(
    () => {
      if (!m)
        return;
      const D = m.filter((C) => C.current && (e.groupIndex === void 0 || e.groupIndex === null || C.current.props.group.index === e.groupIndex) && (e.vertical ? Oe(/* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), C.current.props.start, C.current.props.end, !0) : Ve(/* @__PURE__ */ new Date(), C.current.props.start, C.current.props.end)) && !C.current.props.isAllDay);
      if (D && D.length && l.current && s.current) {
        const C = Et(D);
        if (!C.current)
          return;
        const z = e.vertical ? si(D) : ci(D), x = Ke(C.current.element), R = Ke(l.current), L = (e.vertical ? x.width : x.height) / (C.current.props.end.getTime() - C.current.props.start.getTime()), _ = (Date.now() - ii(/* @__PURE__ */ new Date(), C.current.props.start).getTime()) * L, O = u === "rtl", f = e.vertical ? x.top : x.top + _ - R.height / 2, I = O ? "right" : "left", b = e.vertical ? x[I] + _ - R.width / 2 : x[I];
        e.vertical ? l.current.style[I] = `${b}px` : l.current.style.top = `${f}px`, s.current.style[I] = `${b}px`, s.current.style.top = `${f}px`, s.current.style[e.vertical ? "height" : "width"] = `${z - 1}px`, r(!0);
      } else
        r(!1);
    },
    [m, e.groupIndex, e.vertical, u]
  ), h = t.useCallback(
    () => {
      g(), i((D) => !D);
    },
    [g]
  );
  t.useEffect(
    () => {
      if (!o.current || !window)
        return;
      clearInterval(c.current), c.current = window.setInterval(h, d);
      const D = window.ResizeObserver, C = D && new D(h);
      return C && C.observe(o.current), () => {
        clearInterval(c.current), C && C.disconnect();
      };
    },
    [g, h, o, d]
  ), t.useEffect(g);
  const y = /* @__PURE__ */ t.createElement(
    "div",
    {
      ref: l,
      className: he(
        "k-current-time",
        {
          "k-current-time-arrow-right": !e.vertical && u !== "rtl",
          "k-current-time-arrow-left": !e.vertical && u === "rtl",
          "k-current-time-arrow-down": e.vertical
        }
      ),
      style: {
        transform: e.vertical ? u === "rtl" ? "translateX(50%)" : "translateX(-50%)" : "translateY(-50%)",
        visibility: n ? void 0 : "hidden"
      }
    }
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, e.attachArrow && e.attachArrow.current ? wn.createPortal(y, e.attachArrow.current) : y, /* @__PURE__ */ t.createElement(
    "div",
    {
      className: "k-current-time",
      ref: s,
      style: {
        transform: e.vertical ? "translateX(-50%)" : "translateY(-50%)",
        [e.vertical ? "width" : "height"]: "1px",
        visibility: n ? void 0 : "hidden"
      }
    }
  ));
}, di = {
  updateInterval: 6e4
}, In = t.forwardRef((e, n) => {
  const {
    as: r = Hn.as,
    ...o
  } = e, a = t.useRef(null), c = t.useRef(null), l = $e(), s = t.useMemo(
    () => he("k-scheduler-cell k-heading-cell", e.className),
    [e.className]
  );
  return t.useImperativeHandle(c, () => ({
    element: a.current && a.current.element ? a.current.element : a.current,
    props: e
  })), t.useImperativeHandle(n, () => c.current), /* @__PURE__ */ t.createElement(
    r,
    {
      ref: r !== Hn.as ? void 0 : a,
      ...o,
      className: s
    },
    /* @__PURE__ */ t.createElement("span", { className: "k-link k-nav-day" }, l.formatDate(
      e.date,
      e.format ? e.format : Hn.format
    ))
  );
}), Hn = {
  as: t.forwardRef(({ as: e, format: n, start: r, end: o, ...a }, c) => /* @__PURE__ */ t.createElement("div", { ...a, ref: c })),
  format: "d"
};
In.displayName = "KendoReactSchedulerDateHeaderCell";
const fn = 0, gn = 1, ui = /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-side-cell" }), on = (e) => {
  const {
    group: n,
    timezone: r,
    resources: o
  } = qe(), a = $e(), c = e.editItem || Rn, l = e.editSlot || an, s = e.showWorkHours, d = e.numberOfDays || Qe.numberOfDays, i = e.slotDivisions || Qe.slotDivisions, u = e.slotDuration || Qe.slotDuration, m = e.workWeekStart || Qe.workWeekStart, g = e.workWeekEnd || Qe.workWeekEnd, h = a.parseDate(e.workDayStart || e.isWorkDayStart || Qe.isWorkDayStart), y = a.parseDate(e.workDayEnd || e.isWorkDayEnd || Qe.isWorkDayEnd), D = a.parseDate(e.startTime || Qe.startTime), C = a.parseDate(e.endTime || Qe.endTime), [z] = Lt(), x = Mt(), R = Ur(), L = Pe(), _ = vt(), O = t.useMemo(
    () => s ? h : D,
    [
      s,
      h,
      D
    ]
  ), f = t.useMemo(
    () => s ? y : C,
    [
      s,
      y,
      C
    ]
  ), I = t.useMemo(
    () => Qt(
      _,
      { step: Ge * d, timezone: r }
    ).map((E) => ({ ...E, isAllDay: !0 })),
    [
      _.start.getTime(),
      _.end.getTime(),
      d
    ]
  ), b = t.useMemo(
    () => Qt(
      _,
      { step: Ge, timezone: r }
    ).map((E) => ({ ...E, isAllDay: !1 })),
    [
      _.start.getTime(),
      _.end.getTime(),
      r
    ]
  ), A = t.useMemo(
    () => jt(
      _,
      { step: Ge },
      { groups: x, ranges: I }
    ),
    [
      _.start.getTime(),
      _.end.getTime(),
      r,
      I,
      x
    ]
  ), N = t.useMemo(
    () => jt(
      _,
      { step: u * $n / i },
      { groups: x, ranges: b }
    ).filter((E) => f.getTime() === O.getTime() || Ve(E.zonedStart, O, f)),
    [
      _.start.getTime(),
      _.end.getTime(),
      u,
      i,
      O.getTime(),
      f.getTime(),
      x,
      b
    ]
  ), X = t.useMemo(
    () => Pt(z, { dateRange: _, fields: L, timezone: r }),
    [z, _.start.getTime(), _.end.getTime(), L, r]
  ), F = t.useMemo(
    () => X.filter((E) => E.isAllDay),
    [X]
  ), V = t.useMemo(
    () => X.filter((E) => !E.isAllDay),
    [X]
  ), p = t.useMemo(
    () => xt(F, { timezone: r }, { groups: x, ranges: I }),
    [X, r, x, I]
  ), P = t.useMemo(
    () => xt(V, { timezone: r }, { groups: x, ranges: b }).filter(
      (E) => O.getTime() === f.getTime() || Ve(E.zonedStart, O, f) || Ve(E.zonedEnd, O, f) || Ve(
        new Date(E.zonedEnd.getTime() - (E.zonedEnd.getTime() - E.zonedStart.getTime()) / 2),
        O,
        f
      )
    ),
    [X, r, x, b, O.getTime(), f.getTime()]
  );
  t.useMemo(() => Tt(p, A, !1), [p, A]), t.useMemo(() => $t(p, A, !1), [p, A]), t.useMemo(() => Tt(P, N, !1), [P, N]), t.useMemo(() => $t(P, N, !1), [P, N]);
  const S = /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: E }) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: E }, b.map((M, W) => /* @__PURE__ */ t.createElement(
    In,
    {
      as: e.dateHeaderCell,
      key: W,
      date: te.fromLocalDate(
        new Date(M.zonedEnd.getTime() - (M.zonedEnd.getTime() - M.zonedStart.getTime()) / 2),
        r
      ),
      start: M.start,
      end: M.end,
      format: { skeleton: "MEd" }
    }
  )))), U = /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: E }) => /* @__PURE__ */ t.createElement("div", { key: E, className: "k-scheduler-row" }, I.map((M, W) => A.filter((J) => J.group.index === E && J.range.index === W).map((J, ne, B) => /* @__PURE__ */ t.createElement(
    l,
    {
      ...J,
      onDataAction: e.onDataAction,
      form: e.form,
      slot: e.slot,
      viewSlot: e.viewSlot,
      key: `${J.start.getTime()}:${J.group.index}`,
      row: 0,
      col: R === "horizontal" ? B.length * (E || 0) + ne : ne,
      isWorkDay: 0 <= J.zonedStart.getDay() + (d - m) && (J.zonedStart.getDay() + (d - m)) % d <= g + (d - m),
      expandable: !0
    }
  ))))), k = t.useMemo(
    () => he(
      "k-scheduler-day-view",
      e.className
    ),
    [e.className]
  );
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    rn,
    {
      id: e.id,
      props: e,
      style: e.style,
      className: k,
      ranges: [...I, ...b],
      slots: [...A, ...N]
    },
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-head" }, R === "horizontal" ? /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      ft,
      {
        nested: !0,
        group: n,
        resources: o,
        rowContent: Ma,
        childRowContent: Ma
      },
      S
    ), /* @__PURE__ */ t.createElement(
      ft,
      {
        group: n,
        resources: o,
        rowContent: Pn,
        childRowContent: Pn
      },
      U
    ), p.map(
      (E) => /* @__PURE__ */ t.createElement(
        c,
        {
          key: E.isRecurring ? `${E.uid}:${E.group.index}:${E.range.index}:${E.originalStart}` : `${E.uid}:${E.group.index}:${E.range.index}`,
          ...E,
          form: e.form,
          onDataAction: e.onDataAction,
          item: e.item,
          viewItem: e.viewItem,
          editable: e.editable,
          vertical: !1
        }
      )
    )) : /* @__PURE__ */ t.createElement(
      ct,
      {
        group: n,
        resources: o,
        cellContent: ui
      },
      S
    )),
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-body" }, R === "horizontal" ? /* @__PURE__ */ t.createElement(t.Fragment, null, N.filter((E) => E.group.index === fn && E.range.index === fn).map((E, M) => /* @__PURE__ */ t.createElement(t.Fragment, { key: E.index }, /* @__PURE__ */ t.createElement(
      ft,
      {
        nested: !1,
        group: n,
        resources: o,
        rowContent: za,
        rowContentProps: {
          timeHeaderCell: e.timeHeaderCell,
          isMaster: M % i === 0,
          isLast: (M + 1) % i === 0,
          slot: E
        }
      },
      /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: W }) => /* @__PURE__ */ t.createElement(
        "div",
        {
          className: he(
            "k-scheduler-row",
            {
              "k-middle-row": (M + 1) % i !== 0
            }
          )
        },
        b.map((J, ne) => N.filter((B) => B.index === E.index && B.range.index === ne && B.group.index === W).map((B) => /* @__PURE__ */ t.createElement(
          l,
          {
            key: `${B.start.getTime()}:${B.group.index}`,
            ...B,
            onDataAction: e.onDataAction,
            slot: e.slot,
            viewSlot: e.viewSlot,
            form: e.form,
            row: M + gn,
            col: b.length * (W || 0) + ne,
            isWorkHour: Ve(B.zonedStart, h, y),
            isWorkDay: ja(B.zonedEnd.getDay(), m, g),
            editable: e.editable
          }
        )))
      ))
    ))), e.currentTimeMarker && Oe(Et(b).start, Ut(b).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ t.createElement(Dn, null)) : /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
      ct,
      {
        nested: !0,
        group: n,
        resources: o
      },
      /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: E }) => /* @__PURE__ */ t.createElement(t.Fragment, { key: E }, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, /* @__PURE__ */ t.createElement(Pn, { groupIndex: E }, I.map((M, W) => {
        const J = N.filter((ne) => ne.group.index === E && ne.range.index === fn).length;
        return A.filter((ne) => ne.group.index === E && ne.range.index === W).map((ne, B) => /* @__PURE__ */ t.createElement(
          l,
          {
            slot: e.slot,
            viewSlot: e.viewSlot,
            form: e.form,
            ...ne,
            onDataAction: e.onDataAction,
            key: `${ne.start.getTime()}:${ne.group.index}`,
            className: "k-scheduler-alldays-slot",
            row: J * (E || 0) + (E || 0) * gn,
            col: B,
            expandable: !0
          }
        ));
      }))), N.filter((M) => M.group.index === E && M.range.index === fn).map((M, W, J) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: M.index }, /* @__PURE__ */ t.createElement(
        za,
        {
          slot: M,
          isMaster: W % i === 0,
          isLast: (W + 1) % i === 0,
          timeHeaderCell: e.timeHeaderCell
        },
        b.map(
          (ne, B) => N.filter((re) => re.index === M.index && re.group.index === E && re.range.index === B).map((re) => /* @__PURE__ */ t.createElement(
            l,
            {
              slot: e.slot,
              viewSlot: e.viewSlot,
              form: e.form,
              onDataAction: e.onDataAction,
              ...re,
              key: `${re.start.getTime()}:${re.group.index}`,
              row: J.length * (E || 0) + W + (E || 0) * gn + gn,
              col: B,
              editable: e.editable,
              isWorkHour: Ve(re.zonedStart, h, y),
              isWorkDay: 0 <= re.zonedStart.getDay() + (d - m) && (re.zonedStart.getDay() + (d - m)) % d <= g + (d - m)
            }
          ))
        )
      ))), e.currentTimeMarker && Oe(Et(b).start, Ut(b).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ t.createElement(Dn, { groupIndex: E })))
    ), p.map((E) => /* @__PURE__ */ t.createElement(
      c,
      {
        key: E.isRecurring ? `${E.uid}:${E.group.index}:${E.range.index}:${E.originalStart}` : `${E.uid}:${E.group.index}:${E.range.index}`,
        ...E,
        onDataAction: e.onDataAction,
        viewItem: e.viewItem,
        item: e.item,
        form: e.form,
        editable: e.editable,
        vertical: !1
      }
    ))), P.map((E) => /* @__PURE__ */ t.createElement(
      c,
      {
        key: E.isRecurring ? `${E.uid}:${E.group.index}:${E.range.index}:${E.originalStart}` : `${E.uid}:${E.group.index}:${E.range.index}`,
        ...E,
        format: "t",
        onDataAction: e.onDataAction,
        viewItem: e.viewItem,
        item: e.item,
        form: e.form,
        editable: e.editable,
        vertical: !0
      }
    )))
  ));
}, mi = ({ date: e, numberOfDays: n = 1, timezone: r }) => {
  const o = te.fromLocalDate(e, r), a = Ye(o), c = gt(a, n), l = te.fromUTCDate(Ne(a), r), s = te.fromUTCDate(Ne(c), r), d = new Date(l.getTime()), i = new Date(s.getTime());
  return {
    start: d,
    end: i,
    zonedStart: l,
    zonedEnd: s
  };
}, Qe = {
  name: "multi-day",
  title: "Multi Day",
  currentTimeMarker: !0,
  dateRange: mi,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  numberOfDays: 1,
  startTime: "00:00",
  endTime: "23:59",
  isWorkDayStart: "08:00",
  isWorkDayEnd: "17:00",
  workWeekStart: lt.Monday,
  workWeekEnd: lt.Friday,
  step: 1,
  slotDivisions: 2,
  slotDuration: 60,
  showCurrentTime: !0,
  defaultShowWorkHours: !0
};
on.propTypes = {
  currentTimeMarker: Z.bool,
  name: Z.string,
  numberOfDays: Z.number,
  startTime: Z.string,
  endTime: Z.string,
  workDayStart: Z.string,
  workDayEnd: Z.string,
  workWeekStart: Z.number,
  workWeekEnd: Z.any,
  slotDivisions: Z.number,
  slotDuration: Z.number,
  showWorkHours: Z.bool,
  selectedDateFormat: Z.string,
  selectedShortDateFormat: Z.string
};
on.displayName = "KendoReactSchedulerMultiDayView";
const Sn = (e) => /* @__PURE__ */ t.createElement(on, { ...e }), hi = {
  ...Qe,
  name: "day",
  title: (e) => e.toLanguageString(jn, Q[jn]),
  step: 1,
  numberOfDays: 1,
  slotDuration: 60,
  slotDivisions: 2,
  selectedDateFormat: "{0:D}",
  selectedShortDateFormat: "{0:d}"
};
Sn.displayName = "KendoReactSchedulerDayView";
const Ha = {
  name: "@progress/kendo-react-scheduler",
  productName: "KendoReact",
  productCodes: ["KENDOUIREACT", "KENDOUICOMPLETE"],
  publishDate: 1702645189,
  version: "",
  licensingDocsUrl: "https://www.telerik.com/kendo-react-ui"
}, pl = t.forwardRef((e, n) => {
  const {
    _ref: r,
    onRemoveClick: o
  } = e, a = t.useRef(null), c = t.useRef(null);
  t.useImperativeHandle(a, () => ({ props: e, element: c.current })), t.useImperativeHandle(n, () => a.current), t.useImperativeHandle(r, () => a.current);
  const l = Ot(e.editable), d = Fe().toLanguageString(Gt, Q[Gt]), i = e.group.resources.find((h) => !!(h.colorField && h[h.colorField] !== void 0)), u = i && i.colorField && i[i.colorField], m = t.useCallback(
    (h) => {
      o && o.call(void 0, {
        syntheticEvent: h,
        target: a.current
      });
    },
    [o, a]
  ), g = t.useMemo(
    () => he("k-task", e.className),
    [e.className]
  );
  return /* @__PURE__ */ t.createElement(
    "div",
    {
      id: e.id,
      ref: c,
      style: e.style,
      className: g,
      tabIndex: e.tabIndex || void 0
    },
    u && /* @__PURE__ */ t.createElement(
      "span",
      {
        className: "k-scheduler-mark",
        style: { color: u, backgroundColor: u }
      }
    ),
    e.isRecurring && /* @__PURE__ */ t.createElement(Me, { name: "arrow-rotate-cw", icon: zr }),
    e.isException && /* @__PURE__ */ t.createElement(Me, { name: "arrows-no-repeat", icon: Ga }),
    e.title,
    l.remove && /* @__PURE__ */ t.createElement(
      "a",
      {
        className: "k-link k-event-delete",
        title: d,
        "aria-label": d,
        onClick: m
      },
      /* @__PURE__ */ t.createElement(Me, { name: "x", icon: Ba })
    )
  );
});
pl.displayName = "KendoReactSchedulerTask";
const Wl = t.forwardRef((e, n) => {
  const { task: r, _ref: o, ...a } = e, c = t.useRef(null), l = t.useRef(null);
  t.useImperativeHandle(l, () => ({ props: e, element: c.current && c.current.element })), t.useImperativeHandle(o, () => c.current), t.useImperativeHandle(n, () => l.current);
  const s = r || fi.task;
  return /* @__PURE__ */ t.createElement(s, { ...a, _ref: c });
}), fi = {
  task: pl
};
Wl.displayName = "KendoReactSchedulerViewTask";
const Hl = t.forwardRef((e, n) => {
  const {
    _ref: r,
    onDataAction: o,
    viewTask: a,
    removeDialog: c,
    removeItem: l,
    onRemoveItemChange: s,
    occurrenceDialog: d,
    showOccurrenceDialog: i,
    onShowOccurrenceDialogChange: u,
    showRemoveDialog: m,
    onShowRemoveDialogChange: g,
    ...h
  } = e, y = t.useRef(null);
  t.useImperativeHandle(y, () => ({ props: e, element: y.current && y.current.element })), t.useImperativeHandle(r, () => y.current), t.useImperativeHandle(n, () => y.current);
  const D = a || Vn.viewTask, C = d || Vn.occurrenceDialog, z = c || Vn.removeDialog, x = Ot(e.editable), R = Pe(), [L, _] = Lt(), [O, f] = t.useState(null), [I, b] = Ae(null, l, s), [A, N] = Ae(!1, m, g), [X, F] = Ae(!1, i, u), V = t.useCallback(
    (W) => {
      x.remove && (b(e.dataItem, W), e.isRecurring ? F(!0, W) : N(!0, W));
    },
    [
      b,
      e.dataItem,
      e.isRecurring,
      F,
      N
    ]
  ), p = t.useCallback(
    (W) => {
      f(null), b(null, W), N(!1, W), F(!1, W);
    },
    [
      f,
      b,
      N,
      F
    ]
  ), P = t.useCallback(
    (W) => {
      o && I && o.call(void 0, {
        type: ze.remove,
        series: O,
        dataItem: I
      }), b(null, W), N(!1, W);
    },
    [
      I,
      _,
      N
    ]
  ), S = t.useCallback(
    (W, J) => {
      b && b(W, J);
    },
    [b]
  ), U = t.useCallback(
    (W, J) => {
      N && N(W, J);
    },
    [N]
  ), k = t.useCallback(
    (W, J) => {
      F && F(W, J);
    },
    [F]
  ), E = t.useCallback(
    (W) => {
      I && (f(!1), b(e.dataItem, W), N(!0, W)), F(!1, W);
    },
    [
      f,
      e.dataItem,
      I,
      b,
      N
    ]
  ), M = t.useCallback(
    (W) => {
      if (I) {
        f(!0);
        const J = ht(I, R, L);
        b(J, W), N(!0, W);
      }
      F(!1, W);
    },
    [
      R,
      I,
      f,
      b,
      N,
      F
    ]
  );
  return /* @__PURE__ */ t.createElement(
    Bc,
    {
      remove: [I, S],
      showRemoveDialog: [A, U],
      showOccurrenceDialog: [X, k]
    },
    /* @__PURE__ */ t.createElement(
      D,
      {
        _ref: y,
        ...h,
        onRemoveClick: V
      }
    ),
    X && /* @__PURE__ */ t.createElement(
      C,
      {
        dataItem: I,
        isRemove: I !== null,
        onClose: p,
        onOccurrenceClick: E,
        onSeriesClick: M
      }
    ),
    A && /* @__PURE__ */ t.createElement(
      z,
      {
        dataItem: I,
        onClose: p,
        onCancel: p,
        onConfirm: P
      }
    )
  );
}), Vn = {
  viewTask: Wl,
  occurrenceDialog: Ea,
  removeDialog: ya
};
Hl.displayName = "KendoReactSchedulerEditTask";
const va = (e) => {
  const {
    group: n,
    timezone: r,
    resources: o
  } = qe(), a = e.editTask || Hl, c = e.editSlot || an, l = t.useRef(null), s = en(l), d = $e(), i = Fe(), [u] = Lt(), m = Mt(), g = Pe(), h = vt(), y = t.useMemo(
    () => Qt(
      h,
      { step: Ge, timezone: r }
    ),
    [
      h.start.getTime(),
      h.end.getTime(),
      r
    ]
  ), D = t.useMemo(
    () => jt(
      h,
      { step: Ge },
      { groups: m, ranges: y }
    ),
    [
      h.start.getTime(),
      h.end.getTime(),
      r,
      m,
      y
    ]
  ), C = t.useMemo(
    () => Pt(u, { dateRange: h, fields: g, timezone: r }),
    [u, h.start.getTime(), h.end.getTime(), g, r]
  ), z = t.useMemo(
    () => xt(C, { timezone: r }, { groups: m, ranges: y }),
    [C, r, m, y]
  ), x = t.useMemo(
    () => he(
      "k-scheduler-agendaview",
      e.className
    ),
    [e.className]
  );
  return Zt({ element: l, selector: ".k-scheduler-datecolumn", explicitDepth: !1 }), Zt({ element: l, selector: ".k-scheduler-timecolumn", explicitDepth: !1 }), t.useMemo(() => Tt(z, D, !0), [z, D]), t.useMemo(() => $t(z, D, !0), [z, D]), /* @__PURE__ */ t.createElement(
    rn,
    {
      ref: l,
      id: e.id,
      style: e.style,
      className: x,
      props: e,
      slots: z,
      ranges: y
    },
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-head" }, /* @__PURE__ */ t.createElement(ct, { resources: o, group: n }, /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: R }) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: R }, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-datecolumn" }, i.toLanguageString(vr, Q[vr])), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell k-scheduler-timecolumn" }, i.toLanguageString(kr, Q[kr])), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-scheduler-eventcolumn" }, i.toLanguageString(Dr, Q[Dr])))))),
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-body" }, /* @__PURE__ */ t.createElement(ct, { resources: o, group: n, nested: !0 }, /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: R }) => D.filter((L) => L.group.index === (R || 0)).map((L, _, O) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row  k-scheduler-content", key: `${R}:${_}` }, /* @__PURE__ */ t.createElement(
      c,
      {
        ...L,
        editable: e.editable,
        row: O.length * (R || 0) + _,
        col: 0,
        slot: e.slot,
        viewSlot: e.viewSlot,
        className: "k-scheduler-datecolumn k-group-cell"
      },
      /* @__PURE__ */ t.createElement("div", null, /* @__PURE__ */ t.createElement("strong", { className: "k-scheduler-agendaday" }, d.formatDate(L.zonedStart, "dd")), /* @__PURE__ */ t.createElement("em", { className: "k-scheduler-agendaweek" }, d.formatDate(L.zonedStart, "EEEE")), /* @__PURE__ */ t.createElement("span", { className: "k-scheduler-agendadate" }, d.formatDate(L.zonedStart, "y")))
    ), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-group-content" }, L.items.length ? L.items.map((f, I) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: I }, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-scheduler-timecolumn" }, /* @__PURE__ */ t.createElement("div", null, f.tail && /* @__PURE__ */ t.createElement(
      Me,
      {
        name: s === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: s === "rtl" ? It : Rt
      }
    ), f.isAllDay ? i.toLanguageString(Bt, Q[Bt]) : gi(d, f), f.head && /* @__PURE__ */ t.createElement(
      Me,
      {
        name: s === "rtl" ? "caret-alt-left" : "caret-alt-right",
        icon: s === "rtl" ? Rt : It
      }
    ))), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell" }, /* @__PURE__ */ t.createElement(
      a,
      {
        key: `${_}:${I}`,
        ...f,
        onDataAction: e.onDataAction,
        task: e.task,
        viewTask: e.viewTask,
        editable: e.editable
      }
    )))) : /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-group-cell" }, i.toLanguageString(Cr, Q[Cr]))))))))
  );
}, gi = (e, n) => {
  let r = "{0:t}-{1:t}";
  return n.head ? r = "{0:t}" : n.tail && (r = "{1:t}"), e.format(r, n.zonedStart, n.zonedEnd);
}, Va = (e) => Ye(e), Ei = (e, n) => Ye(gt(e, n || 1)), yi = ({ intl: e, date: n, numberOfDays: r = 1, timezone: o }) => {
  const a = te.fromLocalDate(n, o), c = Va(r === tt ? En(a, e.firstDay()) : a), l = Ei(c, r), s = te.fromUTCDate(Ne(c), o), d = te.fromUTCDate(Ne(l), o), i = new Date(s.getTime()), u = new Date(d.getTime());
  return {
    start: i,
    end: u,
    zonedStart: s,
    zonedEnd: d
  };
}, vi = {
  name: "agenda",
  title: (e) => e.toLanguageString(Xn, Q[Xn]),
  dateRange: yi,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  slotDuration: 60 * 24,
  slotDivision: 1,
  step: tt,
  numberOfDays: tt
}, ki = {
  title: Z.any
};
va.propTypes = ki;
va.displayName = "KendoReactSchedulerAgendaView";
const Vl = t.forwardRef((e, n) => {
  const r = t.useRef(null), o = t.useRef(null), a = Fe();
  t.useImperativeHandle(r, () => ({
    element: o.current && o.current.element,
    ...e
  })), t.useImperativeHandle(n, () => r.current);
  const c = t.useCallback(
    (s) => {
      !e.onClick || !r.current || e.onClick.call(void 0, {
        target: r.current,
        syntheticEvent: s
      });
    },
    [
      r,
      e.slot,
      e.onClick
    ]
  ), l = a.toLanguageString(br, Q[br]);
  return /* @__PURE__ */ t.createElement(
    Re,
    {
      ref: o,
      tabIndex: -1,
      className: "k-more-events",
      onClick: c,
      "aria-label": l,
      icon: "more-horizontal",
      svgIcon: Yo
    }
  );
});
Vl.displayName = "KendoReactSchedulerShowMoreItemsButton";
const Di = { skeleton: "dd" }, ka = (e) => {
  const {
    group: n,
    timezone: r,
    resources: o
  } = qe(), a = e.editItem || Rn, c = e.editSlot || an, [l] = Lt(), [, s] = nl(), [, d] = Yr(), i = tl(), u = Mt(), m = Ur(), g = vt(), h = $e(), y = Pe(), D = e.itemsPerSlot || Kl.itemsPerSlot, C = t.useMemo(
    () => Qt(
      g,
      { step: Ge * tt, timezone: r }
    ),
    [g.start.getTime(), g.end.getTime(), r]
  ), z = t.useMemo(
    () => jt(
      g,
      { step: Ge },
      { groups: u, ranges: C }
    ),
    [
      g.start.getTime(),
      g.end.getTime(),
      u,
      C
    ]
  ), x = t.useMemo(
    () => Pt(l, { dateRange: g, fields: y, timezone: r }),
    [l, g.start.getTime(), g.end.getTime(), y, r]
  ), R = t.useMemo(
    () => xt(x, { timezone: r }, { groups: u, ranges: C }),
    [x, r, u, C]
  ), L = t.useCallback(
    (f) => {
      const I = i.find((b) => b.props.name === "day");
      !d || !I || !I.props.name || !f.target.slot || (d(I.props.name, f), s(f.target.slot.start, f));
    },
    [
      d,
      i
    ]
  );
  t.useMemo(() => Tt(R, z, !0), [R, z]), t.useMemo(() => $t(R, z, !0), [R, z]);
  const _ = /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: f }) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: f }, z.filter((I) => I.group.index === f && I.range.index === 0).map((I, b) => /* @__PURE__ */ t.createElement(
    In,
    {
      as: e.dateHeaderCell,
      key: b,
      "data-dayslot-index": b,
      date: te.fromLocalDate(
        new Date(I.zonedEnd.getTime() - (I.zonedEnd.getTime() - I.zonedStart.getTime()) / 2),
        r
      ),
      start: I.start,
      end: I.end,
      format: { skeleton: "EEEE" }
    }
  )))), O = /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: f }) => C.map((I, b) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", key: b }, z.filter((A) => A.group.index === f && A.range.index === b).map((A, N, X) => /* @__PURE__ */ t.createElement(
    c,
    {
      slot: e.slot,
      viewSlot: e.viewSlot,
      key: N,
      form: e.form,
      ...A,
      expandable: { offsetTop: 30, offsetBottom: D < A.items.length ? 15 : 0 },
      onDataAction: e.onDataAction,
      col: m === "horizontal" ? X.length * (f || 0) + N : N,
      row: m === "horizontal" ? b : C.length * (f || 0) + b,
      editable: e.editable
    },
    /* @__PURE__ */ t.createElement("span", { className: "k-link k-nav-day" }, h.formatDate(
      new Date(A.end.getTime() - (A.end.getTime() - A.start.getTime()) / 2),
      Di
    )),
    D < A.items.length && /* @__PURE__ */ t.createElement(Vl, { slot: A, onClick: L })
  )))));
  return /* @__PURE__ */ t.createElement(
    rn,
    {
      props: e,
      slots: z,
      ranges: C,
      className: he("k-scheduler-monthview", e.className)
    },
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-head" }, m === "horizontal" ? /* @__PURE__ */ t.createElement(ft, { nested: !0, resources: o, group: n }, _) : /* @__PURE__ */ t.createElement(ct, { resources: o, group: n }, _)),
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-body" }, m === "horizontal" ? /* @__PURE__ */ t.createElement(ft, { resources: o, group: n }, O) : /* @__PURE__ */ t.createElement(ct, { nested: !0, resources: o, group: n }, O), R.filter((f) => f.order === null || f.order < D).sort(el).map((f) => /* @__PURE__ */ t.createElement(
      a,
      {
        item: e.item,
        viewItem: e.viewItem,
        form: e.form,
        key: f.isRecurring ? `${f.uid}:${f.group.index}:${f.range.index}:${f.originalStart}` : `${f.uid}:${f.group.index}:${f.range.index}`,
        ...f,
        onDataAction: e.onDataAction,
        style: { transform: "translateY(30px)" },
        vertical: !1,
        editable: e.editable,
        ignoreIsAllDay: !0
      }
    )))
  );
}, Si = ({ intl: e, date: n, timezone: r }) => {
  const o = En(xo(Ye(n)), e.firstDay()), a = gt(En(Mo(Ye(n)), e.firstDay()), tt), c = te.fromUTCDate(Ne(o), r), l = te.fromUTCDate(Ne(a), r), s = new Date(c.getTime()), d = new Date(l.getTime());
  return {
    start: s,
    end: d,
    zonedStart: c,
    zonedEnd: l
  };
}, Kl = {
  name: "month",
  dateRange: Si,
  slotDuration: 24 * 60,
  slotDivision: 1,
  itemsPerSlot: 2,
  numberOfDays: 31,
  title: (e) => e.toLanguageString(Qn, Q[Qn]),
  selectedDateFormat: "{0:Y}",
  selectedShortDateFormat: "{0:Y}"
}, wi = {
  itemsPerSlot: Z.number
};
ka.propTypes = wi;
ka.displayName = "KendoReactSchedulerMonthView";
const Ul = (e) => /* @__PURE__ */ t.createElement(
  on,
  {
    ...e,
    step: tt,
    numberOfDays: e.numberOfDays
  }
), Ci = (e) => Ye(e), bi = (e, n) => Ye(gt(e, n || 1)), Ri = ({ intl: e, date: n, timezone: r }) => {
  const o = te.fromLocalDate(n, r), a = Ci(En(o, e.firstDay())), c = bi(a, tt), l = te.fromUTCDate(Ne(a), r), s = te.fromUTCDate(Ne(c), r), d = new Date(l.getTime()), i = new Date(s.getTime());
  return {
    start: d,
    end: i,
    zonedStart: l,
    zonedEnd: s
  };
}, Ii = {
  name: "week",
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: tt,
  dateRange: Ri,
  title: (e) => e.toLanguageString(qn, Q[qn]),
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}"
};
Ul.displayName = "KendoReactSchedulerWeekView";
const $l = (e) => {
  const n = vt(), r = Math.round((n.end.getTime() - n.start.getTime()) / Ge);
  return /* @__PURE__ */ t.createElement(
    on,
    {
      ...e,
      step: tt,
      numberOfDays: r
    }
  );
}, Ti = (e, n = lt.Sunday) => {
  let r = e.clone();
  for (; r.getDay() !== n; )
    r = r.addDays(-1);
  return r;
}, xi = ({ intl: e, date: n, timezone: r, ...o }) => {
  const a = te.fromLocalDate(n, r), c = o.workWeekStart !== void 0 ? o.workWeekStart : lt.Monday, l = o.workWeekEnd !== void 0 ? o.workWeekEnd : lt.Friday, s = l < c ? tt + l - c + 1 : l - c + 1, d = Ye(Ti(a, c)), i = gt(d, s), u = te.fromUTCDate(Ne(d), r), m = te.fromUTCDate(Ne(i), r), g = new Date(u.getTime()), h = new Date(m.getTime());
  return {
    start: g,
    end: h,
    zonedStart: u,
    zonedEnd: m
  };
}, Mi = {
  name: "work-week",
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: 7,
  dateRange: xi,
  title: (e) => e.toLanguageString(Zn, Q[Zn]),
  workWeekStart: lt.Monday,
  workWeekEnd: lt.Friday,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}"
};
$l.displayName = "KendoReactSchedulerWorkWeekView";
const zi = /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-side-cell" }), Ai = (e) => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-sticky-cell" }, zi), e.children), Ni = (e) => {
  const n = Fe();
  return /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-sticky-cell" }, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-cell k-heading-cell k-side-cell k-scheduler-times-all-day", "data-range-index": 0 }, n.toLanguageString(Bn, Q[Bn]))), e.children);
}, Fi = "t", _i = 0, Li = (e) => {
  const {
    group: n,
    timezone: r,
    resources: o
  } = qe(), a = t.useRef(null), c = t.useRef(null), l = e.editItem || Rn, s = e.editSlot || an, d = t.useRef(null), [i] = Lt(), u = Ur(), m = Mt(), g = vt(), h = Pe(), y = $e(), D = e.showWorkHours, C = e.slotDivisions || Je.slotDivisions, z = e.slotDuration || Je.slotDuration, x = e.workWeekStart || Je.workWeekStart, R = e.workWeekEnd || Je.workWeekEnd, L = y.parseDate(e.workDayStart || e.isWorkDayStart || Je.isWorkDayStart), _ = y.parseDate(e.workDayEnd || e.isWorkDayEnd || Je.isWorkDayEnd), O = y.parseDate(e.startTime || Je.startTime), f = y.parseDate(e.endTime || Je.endTime), I = t.useMemo(
    () => D ? L : O,
    [
      D,
      L,
      O
    ]
  ), b = t.useMemo(
    () => D ? _ : f,
    [
      D,
      _,
      f
    ]
  ), A = t.useMemo(
    () => Qt(
      g,
      { step: Ge, timezone: r }
    ),
    [
      g.start.getTime(),
      g.end.getTime(),
      r
    ]
  ), N = t.useMemo(
    () => jt(
      g,
      { step: z / C * zo },
      { groups: m, ranges: A }
    ).filter((k) => Ve(k.zonedStart, I, b) || I.getTime() === b.getTime()),
    [
      m,
      A,
      g.start.getTime(),
      g.end.getTime(),
      r,
      z,
      C,
      I.getTime(),
      b.getTime()
    ]
  ), X = t.useMemo(
    () => Pt(i, { dateRange: g, fields: h, timezone: r }),
    [i, g.start.getTime(), g.end.getTime(), h, r]
  ), F = t.useMemo(
    () => xt(X, { timezone: r }, { groups: m, ranges: A }).filter(
      (k) => I.getTime() === b.getTime() || Ve(k.zonedStart, I, b) || Ve(k.zonedEnd, I, b) || Ve(
        new Date(k.zonedEnd.getTime() - (k.zonedEnd.getTime() - k.zonedStart.getTime()) / 2),
        I,
        b
      )
    ),
    [X, r, m, A, I.getTime(), b.getTime()]
  );
  t.useMemo(() => Tt(F, N, !0), [F, N]), t.useMemo(() => $t(F, N, !0), [F, N]);
  const V = (u === "horizontal" ? N.length : N.length / m.length) * ((e.columnWidth || Je.columnWidth) + be), p = /* @__PURE__ */ t.createElement(xe.Consumer, null, () => /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, A.map((k, E) => /* @__PURE__ */ t.createElement(
    In,
    {
      as: e.dateHeaderCell,
      key: E,
      date: k.zonedStart,
      start: k.start,
      end: k.end,
      format: "m"
    }
  ))), /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row", ref: a }, A.map((k, E) => N.filter((M) => M.group.index === _i && M.range.index === E).map(
    (M) => M.zonedStart.getMinutes() % z === 0 ? /* @__PURE__ */ t.createElement(
      fa,
      {
        key: M.index,
        as: e.timeHeaderCell,
        format: Fi,
        date: M.zonedStart,
        start: M.zonedStart,
        end: M.zonedEnd
      }
    ) : null
  ))))), P = /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: k }) => /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-row" }, A.map((E, M) => N.filter((W) => W.group.index === k && W.range.index === M).map((W, J, ne) => {
    const B = te.fromUTCDate(Ne(W.zonedStart), r), re = ja(B.getDay(), x, R);
    return /* @__PURE__ */ t.createElement(
      s,
      {
        key: `${W.start.getTime()}:${W.group.index}`,
        slot: e.slot,
        viewSlot: e.viewSlot,
        ...W,
        form: e.form,
        onDataAction: e.onDataAction,
        isWorkHour: Ve(W.zonedStart, L, _),
        isWorkDay: re,
        col: u === "horizontal" ? M * ne.length + J + ne.length * A.length * (k || 0) : M * ne.length + J,
        row: u === "horizontal" ? 0 : k || 0,
        expandable: !0,
        editable: e.editable
      }
    );
  })))), S = t.useMemo(
    () => he(
      "k-scheduler-timeline-view",
      e.className
    ),
    [e.className]
  );
  Zt({
    element: d,
    selector: ".k-resource-cell",
    attribute: "data-depth-index",
    explicitDepth: !0
  });
  const U = d.current ? d.current.closest(".k-scheduler-layout") : null;
  return xl({
    element: U,
    selector: ".k-resource-row",
    horizontalAttribute: "data-depth-index",
    verticalAttribute: "data-resource-index",
    applyTo: ".k-resource-cell",
    syncHeight: F && !F.length
  }), /* @__PURE__ */ t.createElement(t.Fragment, null, /* @__PURE__ */ t.createElement(
    rn,
    {
      ref: d,
      id: e.id,
      style: { ...e.style },
      className: S,
      props: e,
      slots: N,
      ranges: A
    },
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-head", style: { width: V } }, u === "horizontal" ? /* @__PURE__ */ t.createElement(
      ft,
      {
        nested: !0,
        group: n,
        resources: o,
        rowContent: Ai
      },
      p
    ) : /* @__PURE__ */ t.createElement(
      ct,
      {
        wrapGroup: !0,
        group: n,
        resources: o
      },
      p
    )),
    /* @__PURE__ */ t.createElement("div", { className: "k-scheduler-body", style: { width: V }, ref: c }, u === "horizontal" ? /* @__PURE__ */ t.createElement(
      ft,
      {
        group: n,
        resources: o,
        rowContent: Ni
      },
      P,
      /* @__PURE__ */ t.createElement(xe.Consumer, null, ({ groupIndex: k }) => e.currentTimeMarker && Oe(Et(A).start, Ut(A).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ t.createElement(
        Dn,
        {
          groupIndex: k,
          attachArrow: a,
          vertical: !0
        }
      ))
    ) : /* @__PURE__ */ t.createElement(
      ct,
      {
        nested: !0,
        wrapGroup: !0,
        group: n,
        resources: o
      },
      P
    ), u === "vertical" && e.currentTimeMarker && Oe(Et(A).start, Ut(A).end, /* @__PURE__ */ new Date(), /* @__PURE__ */ new Date(), !0) && /* @__PURE__ */ t.createElement(
      Dn,
      {
        attachArrow: a,
        vertical: !0
      }
    ), F.sort(el).map((k, E) => /* @__PURE__ */ t.createElement(
      l,
      {
        key: k.isRecurring ? `${k.uid}:${k.group.index}:${k.range.index}:${k.originalStart}` : `${k.uid}:${k.group.index}:${k.range.index}`,
        ...k,
        format: "t",
        form: e.form,
        onDataAction: e.onDataAction,
        item: e.item,
        viewItem: e.viewItem,
        editable: e.editable,
        ignoreIsAllDay: !0,
        vertical: !1,
        isLast: E === F.length - 1
      }
    )))
  ));
}, Oi = ({ date: e, numberOfDays: n = 1, timezone: r }) => {
  const o = te.fromLocalDate(e, r), a = Ye(o), c = gt(a, n), l = te.fromUTCDate(Ne(a), r), s = te.fromUTCDate(Ne(c), r), d = new Date(l.getTime()), i = new Date(s.getTime());
  return {
    start: d,
    end: i,
    zonedStart: l,
    zonedEnd: s
  };
}, Je = {
  name: "multi-day-timeline",
  title: "Multi Day Timeline",
  currentTimeMarker: !0,
  dateRange: Oi,
  selectedDateFormat: "{0:D} - {1:D}",
  selectedShortDateFormat: "{0:d} - {1:d}",
  step: 1,
  numberOfDays: 1,
  startTime: "00:00",
  endTime: "00:00",
  isWorkDayStart: "8:00",
  isWorkDayEnd: "17:00",
  workWeekStart: lt.Monday,
  workWeekEnd: lt.Friday,
  slotDivisions: 2,
  slotDuration: 60,
  // showCurrentTime: true // TODO: Phase 2
  defaultShowWorkHours: !0,
  columnWidth: 100
}, Bl = (e) => /* @__PURE__ */ t.createElement(Li, { ...e }), Pi = {
  ...Je,
  name: "timeline",
  title: (e) => e.toLanguageString(Yn, Q[Yn]),
  step: 1,
  slotDuration: 60,
  slotDivisions: 2,
  numberOfDays: 1,
  selectedDateFormat: "{0:D}",
  selectedShortDateFormat: "{0:d}"
};
Bl.displayName = "KendoReactSchedulerTimelineView";
const pi = "{0:D}", Wi = "{0:d}", Hi = "application", yt = /* @__PURE__ */ new Map();
yt.set(va, vi);
yt.set(Sn, hi);
yt.set(ka, Kl);
yt.set(Ul, Ii);
yt.set($l, Mi);
yt.set(Bl, Pi);
const Gl = t.forwardRef((e, n) => {
  _o(Ha);
  const r = Lo(Ha), {
    timezone: o,
    onDataChange: a
  } = e, c = t.useRef(null), l = t.useRef(null);
  t.useImperativeHandle(l, () => ({ props: e, element: c.current })), t.useImperativeHandle(n, () => l.current);
  const s = Oo(c), d = $e(), i = Fe(), { fields: u } = t.useMemo(() => uc(e.modelFields), [e.modelFields]), [
    m,
    g
  ] = Ae(e.defaultDate || je.defaultDate, e.date, e.onDateChange), h = t.Children.toArray(e.children || []).map((H) => t.isValidElement(H) ? t.cloneElement(H, { ...yt.get(H.type), ...H.props }) : H), y = t.cloneElement(/* @__PURE__ */ t.createElement(Sn, null), yt.get(Sn)), [
    D,
    C
  ] = Ae(e.defaultView || h[0] && h[0].props.name || "day", e.view, e.onViewChange), [
    z,
    x
  ] = Ae(!0), R = h.find((H) => H.props.name === D) || h[0] || y, L = (e.data ?? je.data) || je.data, _ = mc(e.group, e.resources), O = e.group && e.group.orientation ? e.group.orientation : "horizontal", f = R.props.selectedDateFormat || pi, I = R.props.selectedShortDateFormat || Wi, b = R.props.slotDuration, A = R.props.dateRange !== void 0 ? typeof R.props.dateRange == "function" ? R.props.dateRange.call(void 0, {
    intl: d,
    date: m,
    timezone: o,
    numberOfDays: R.props.numberOfDays,
    workWeekStart: R.props.workWeekStart || d.firstDay(),
    workWeekEnd: R.props.workWeekEnd || (d.firstDay() + R.props.numberOfDays) % 6
  }) : R.props.dateRange : { start: je.defaultDate, end: je.defaultDate }, N = t.useCallback(
    ({ created: H = [], updated: $ = [], deleted: ie = [] }) => {
      if (a) {
        const le = {
          created: H,
          updated: $,
          deleted: ie
        };
        a.call(void 0, le);
      }
    },
    [a]
  ), X = t.useCallback(
    (H) => {
      const $ = [H.dataItem];
      N({ created: $ });
    },
    [N]
  ), F = t.useCallback(
    (H) => {
      const $ = [], ie = [];
      if (H.series)
        if (Array.isArray(H.dataItem))
          H.dataItem.map((le) => {
            const se = ce(ht(H.dataItem, u, L)), Se = ce(le);
            j(Se, u.originalStart, q(se, u.originalStart)), j(Se, u.recurrenceId, q(se, u.recurrenceId)), j(Se, u.recurrenceExceptions, q(se, u.recurrenceExceptions)), ie.push(Se);
          });
        else {
          const le = ce(ht(H.dataItem, u, L)), se = ce(H.dataItem);
          j(se, u.originalStart, q(le, u.originalStart)), j(se, u.recurrenceId, q(le, u.recurrenceId)), j(se, u.recurrenceExceptions, q(le, u.recurrenceExceptions)), ie.push(se);
        }
      else if (Array.isArray(H.dataItem))
        H.dataItem.map((le) => {
          const se = q(le, u.recurrenceRule) !== null && q(le, u.recurrenceRule) !== void 0;
          if (q(le, u.recurrenceId) !== null && q(le, u.recurrenceId) !== void 0 && se) {
            const we = ce(ht(le, u, L)), Ze = q(le, u.originalStart), it = q(we, u.recurrenceExceptions) || [];
            j(we, u.recurrenceExceptions, [...it, Ze]), j(le, u.recurrenceRule, null), ie.push(we), $.push(le);
          } else
            ie.push(le);
        });
      else {
        const le = q(H.dataItem, u.recurrenceRule) !== null && q(H.dataItem, u.recurrenceRule) !== void 0;
        if (q(H.dataItem, u.recurrenceId) !== null && q(H.dataItem, u.recurrenceId) !== void 0 && le) {
          const Se = ce(ht(H.dataItem, u, L)), we = q(H.dataItem, u.originalStart), Ze = q(Se, u.recurrenceExceptions) || [];
          j(Se, u.recurrenceExceptions, [...Ze, we]), j(H.dataItem, u.recurrenceRule, null), ie.push(Se), $.push(H.dataItem);
        } else
          ie.push(H.dataItem);
      }
      N({ updated: ie, created: $ });
    },
    [N, u, L]
  ), V = t.useCallback(
    (H) => {
      const $ = [], ie = [];
      if (H.series) {
        const le = ce(ht(H.dataItem, u, L)), se = ce(H.dataItem);
        j(se, u.originalStart, q(le, u.originalStart)), j(se, u.recurrenceId, q(le, u.recurrenceId)), j(se, u.recurrenceRule, q(le, u.recurrenceRule)), j(se, u.recurrenceExceptions, q(le, u.recurrenceExceptions)), ie.push(se);
      } else if (!(q(H.dataItem, u.recurrenceRule) !== null && q(H.dataItem, u.recurrenceRule) !== void 0))
        ie.push(H.dataItem);
      else {
        const se = ce(ht(H.dataItem, u, L)), Se = q(H.dataItem, u.originalStart), we = q(se, u.recurrenceExceptions) || [];
        j(se, u.recurrenceExceptions, [...we, Se]), j(H.dataItem, u.recurrenceRule, null), $.push(se);
      }
      N({ updated: $, deleted: ie });
    },
    [N, u, L]
  ), p = t.useCallback(
    (H) => {
      switch (H.type) {
        case ze.create:
          X(H);
          break;
        case ze.update:
          F(H);
          break;
        case ze.remove:
          V(H);
          break;
      }
    },
    [X, V, F]
  ), P = t.useCallback(
    (H, $) => {
      C(H, {
        ...$,
        target: l.current
      });
    },
    [
      C,
      l
    ]
  ), S = t.useCallback(
    (H, $) => {
      g(H, {
        ...$,
        target: l.current
      });
    },
    [
      g,
      l
    ]
  ), U = t.useCallback(
    (H) => {
      H.value && g(H.value, {
        ...H,
        target: l.current,
        nativeEvent: H.nativeEvent
      });
    },
    [
      g,
      l
    ]
  ), k = t.useCallback(
    (H) => {
      H.preventDefault();
      const $ = R.props.numberOfDays || 1, le = $ > 27 ? Ca(m, Math.round($ / 27)) : gt(m, $);
      g(le, event);
    },
    [m, g, R.props.numberOfDays]
  ), E = t.useCallback(
    (H) => {
      H.preventDefault();
      const $ = R.props.numberOfDays || 1, le = $ > 27 ? Ca(m, -Math.round($ / 27)) : gt(m, -$);
      g(le, event);
    },
    [m, g, R.props.numberOfDays]
  ), M = t.useCallback(
    (H) => {
      H.preventDefault();
      const $ = dc();
      g($, event);
    },
    [g]
  ), W = t.useCallback(
    () => {
      x(!z);
    },
    [x, z]
  ), J = t.useCallback(
    () => {
      c.current && (c.current.style.boxShadow = "0 0.5px 0.5px 0.5px rgba(0, 0, 0, .12)");
    },
    [c]
  ), ne = t.useCallback(
    () => {
      c.current && (c.current.style.boxShadow = "");
    },
    [c]
  ), B = t.useMemo(
    () => ({ ...e.style, height: e.height ?? je.height }),
    [e.height, e.style]
  ), re = t.useMemo(
    () => he(
      { "k-rtl": e.rtl !== void 0 ? e.rtl : s === "rtl" },
      "k-widget k-scheduler k-floatwrap k-pos-relative",
      e.className
    ),
    [e.className, e.rtl, s]
  ), de = i.toLanguageString(Gn, Q[Gn]), fe = i.toLanguageString(Jn, Q[Jn]), ae = i.toLanguageString(er, Q[er]), Ie = R.props.header || e.header || je.header, ge = R.props.footer || e.footer || je.footer, De = Zr, [Ee, pe] = t.useState(null);
  return /* @__PURE__ */ t.createElement(
    yc,
    {
      element: c,
      props: e,
      views: h,
      fields: u,
      groups: _,
      dateRange: A,
      orientation: O,
      dateFormat: { dateFormat: f, shortDateFormat: I },
      date: [m, S],
      activeView: [D, P],
      selection: [Ee, pe],
      data: [L, p]
    },
    /* @__PURE__ */ t.createElement(
      "div",
      {
        ref: c,
        id: e.id,
        style: B,
        className: re,
        tabIndex: e.tabIndex ?? je.tabIndex,
        dir: s,
        role: e.role || Hi,
        "aria-label": e.ariaLabel,
        "aria-labelledby": e.ariaLabelledby,
        "aria-activedescendant": Ee && Ee.props.id || void 0,
        onFocus: J,
        onBlur: ne
      },
      /* @__PURE__ */ t.createElement(Ie, null, /* @__PURE__ */ t.createElement(De, null, /* @__PURE__ */ t.createElement(Mr, { className: "k-scheduler-navigation" }, /* @__PURE__ */ t.createElement(
        Re,
        {
          role: "button",
          tabIndex: -1,
          title: de,
          "aria-label": de,
          onClick: M
        },
        de
      ), /* @__PURE__ */ t.createElement(
        Re,
        {
          role: "button",
          tabIndex: -1,
          icon: s === "rtl" ? "caret-alt-right" : "caret-alt-left",
          svgIcon: s === "rtl" ? It : Rt,
          title: fe,
          "aria-label": fe,
          onClick: E
        }
      ), /* @__PURE__ */ t.createElement(
        Re,
        {
          role: "button",
          tabIndex: -1,
          icon: s === "rtl" ? "caret-alt-left" : "caret-alt-right",
          svgIcon: s === "rtl" ? Rt : It,
          title: ae,
          "aria-label": ae,
          onClick: k
        }
      ))), /* @__PURE__ */ t.createElement(
        Cl,
        {
          value: m,
          onChange: U
        }
      ), /* @__PURE__ */ t.createElement(Ho, null), /* @__PURE__ */ t.createElement(Tl, null)),
      R && /* @__PURE__ */ t.createElement(
        R.type,
        {
          editable: e.editable ?? je.editable,
          key: R.props.name,
          item: e.item,
          viewItem: e.viewItem,
          editItem: e.editItem,
          task: e.task,
          viewTask: e.viewTask,
          editTask: e.viewTask,
          slot: e.slot,
          viewSlot: e.viewSlot,
          editSlot: e.editSlot,
          form: e.form,
          onDataAction: p,
          showWorkHours: z,
          ...R.props
        }
      ),
      /* @__PURE__ */ t.createElement(ge, null, b && b < 24 * 60 && /* @__PURE__ */ t.createElement(Xc, null, /* @__PURE__ */ t.createElement(
        Re,
        {
          tabIndex: -1,
          onClick: W,
          icon: "clock",
          svgIcon: qo
        },
        i.toLanguageString(
          z ? tr : nr,
          Q[z ? tr : nr]
        )
      ))),
      r && /* @__PURE__ */ t.createElement(Po, null)
    )
  );
}), je = {
  data: [],
  height: 600,
  tabIndex: -1,
  editable: !1,
  defaultDate: /* @__PURE__ */ new Date(),
  header: rl,
  footer: vc,
  navigation: Zr,
  viewSelector: al
};
Gl.propTypes = {
  data: Z.array,
  editable: Z.oneOfType([
    Z.bool,
    Z.shape({
      add: Z.bool,
      drag: Z.bool,
      edit: Z.bool,
      remove: Z.bool,
      resize: Z.bool
    })
  ]),
  view: Z.string,
  defaultView: Z.string,
  date: Z.any,
  defaultDate: Z.any,
  rtl: Z.bool,
  height: Z.oneOfType([Z.number, Z.string]),
  children: Z.any,
  timezone: Z.string,
  group: Z.any,
  resources: Z.any,
  modelFields: Z.shape({
    id: Z.string,
    start: Z.string,
    startTimezone: Z.string,
    end: Z.string,
    endTimezone: Z.string,
    isAllDay: Z.string,
    title: Z.string,
    description: Z.string,
    recurrenceRule: Z.string,
    recurrenceId: Z.string,
    recurrenceException: Z.string
  })
};
Gl.displayName = "KendoReactScheduler";
const Vi = 1, Ki = t.forwardRef((e, n) => {
  const { item: r, _ref: o, itemRef: a, ...c } = e, l = t.useRef(), s = t.useRef(null), d = t.useRef(null), i = t.useRef(null);
  t.useImperativeHandle(d, () => ({ props: e, element: s.current && s.current.element })), t.useImperativeHandle(n, () => d.current), t.useImperativeHandle(o, () => s.current), t.useImperativeHandle(a, () => s.current);
  const u = r || Ui.item, m = $e(), [g] = nn(), [h] = zt(), y = tn(), [D, C] = t.useState(!0), [z, x] = t.useState(!1), [R, L] = t.useState(0), _ = en(y), O = t.useMemo(
    () => e.isAllDay ? m.toString(e.zonedStart, "t") : m.format("{0:t} - {1:t}", e.zonedStart, e.zonedEnd),
    [m, e.isAllDay, e.zonedEnd, e.zonedStart]
  ), f = t.useMemo(() => `(${O}): ${e.title}`, [O, e.title]), I = (V, p) => {
    let P = 1;
    return V.forEach((S) => {
      const U = p.filter((k) => A(S.current.props, k.props));
      U.length > P && (P = U.length);
    }), P;
  }, b = (V, p) => V.map((S) => p.filter((U) => A(S.current.props, U.props))), A = (V, p) => Oe(V.start, V.end, p.start, p.end) && V.group.index === p.group.index && V.range.index === p.range.index && (e.ignoreIsAllDay || V.isAllDay === p.isAllDay), N = () => {
    const V = (h || []).filter((S) => S.current && A(S.current.props, e));
    if (V.length === 0) {
      C(!1);
      return;
    }
    const p = Et(V);
    if (!p.current || !s.current)
      return;
    const P = Ke(p.current.element);
    _t(s.current.element, P);
  }, X = () => {
    const V = (h || []).filter((ge) => ge.current && A(ge.current.props, e)), p = s.current && s.current.element;
    if (!p || !V.length)
      return;
    const P = Et(V), S = Ut(V);
    if (!P.current || !s.current || !S.current)
      return;
    const U = [], k = [], E = [], M = Ke(P.current.element), W = (e.vertical ? M.height : M.width) / (P.current.props.end.getTime() - P.current.props.start.getTime()), J = (e.start.getTime() - P.current.props.start.getTime()) * W, ne = (Math.min(e.end.getTime(), S.current.props.end.getTime()) - Math.max(e.start.getTime(), P.current.props.start.getTime())) * W;
    (g || []).forEach((ge) => {
      ge.current && (ge.current.props.dragHint ? k.push(ge.current) : ge.current.props.resizeHint ? E.push(ge.current) : U.push(ge.current));
    });
    const B = e.dragHint || e.resizeHint ? Ja(s.current, e.dragHint ? k : E, V, e.ignoreIsAllDay) : e.order || 0;
    let re = e.dragHint || e.resizeHint ? I(V, e.dragHint ? k : E) : I(V, U);
    const de = b(V, U);
    let fe = 0;
    const ae = Ke(p);
    if (de.forEach((ge) => {
      let De = 0;
      ge.forEach((Ee) => {
        Oe(Ee.props.start, Ee.props.end, e.start, e.end) && !(e.dragHint || e.resizeHint) && Ee.props._maxSiblingsPerSlot && Ee.props._maxSiblingsPerSlot > re && Ee.element !== p && (re = Ee.props._maxSiblingsPerSlot);
        const pe = Ke(Ee.element);
        Ee.props.order !== null && Ee.props.order < B && (De = pe.top + pe.height - ae.top - be * B + Vi);
      }), De > fe && (fe = De);
    }), V.length === 0) {
      C(!1);
      return;
    }
    const Ie = 20;
    ae.width = e.vertical ? ae.width / re - be - Ie / re : ne + be, ae.height = e.vertical ? ne - be : (e.resizeHint || e.dragHint) && re <= 1 ? ae.height : e.style && e.style.height ? e.style.height : 25, ae.left = e.vertical ? ae.left + B * ae.width + be * B : ae.left + (J < 0 ? 0 : J), ae.top = e.vertical ? ae.top + (J < 0 ? 0 : J) : ae.top + fe + be * B, L(re), _t(p, ae), x(!0), C(!0);
  }, F = t.useCallback(
    (V) => {
      const p = V && V[0], P = i.current;
      l.current !== void 0 && window.cancelAnimationFrame(l.current), P && p && (P.width !== p.contentRect.width || P.height !== p.contentRect.height) && (l.current = window.requestAnimationFrame(() => {
        N(), X();
      })), i.current = { width: p.contentRect.width, height: p.contentRect.height };
    },
    [N, X]
  );
  return t.useEffect(N), t.useEffect(X), t.useEffect(
    () => {
      if (!y.current)
        return;
      const V = window.ResizeObserver, p = V && new V(F);
      return p && p.observe(y.current), () => {
        p && p.disconnect();
      };
    },
    [F, y]
  ), /* @__PURE__ */ t.createElement(
    u,
    {
      ...c,
      _ref: s,
      _maxSiblingsPerSlot: R,
      itemRef: s,
      style: {
        visibility: z ? void 0 : "hidden",
        display: D ? void 0 : "none",
        ...e.style
      }
    },
    !e.resizeHint && /* @__PURE__ */ t.createElement("span", { className: "k-event-actions" }, e.tail && /* @__PURE__ */ t.createElement(
      Me,
      {
        name: _ === "rtl" ? "caret-alt-right" : "caret-alt-left",
        icon: _ === "rtl" ? It : Rt
      }
    ), e.isRecurring && !e.isException && /* @__PURE__ */ t.createElement(Me, { name: "reload", icon: zr }), !e.isRecurring && e.isException && /* @__PURE__ */ t.createElement(Me, { name: "non-recurrence", icon: Zo })),
    !e.resizeHint && /* @__PURE__ */ t.createElement("div", { title: f }, !e.isAllDay && /* @__PURE__ */ t.createElement(kn, { className: "k-event-template k-event-time " }, f), /* @__PURE__ */ t.createElement(kn, { className: "k-event-template" }, e.title))
  );
}), Ui = {
  item: ln
};
Ki.displayName = "KendoReactSchedulerProportionalViewItem";
export {
  va as AgendaView,
  ze as DATA_ACTION,
  ke as DRAG_ITEM_ACTION,
  In as DateHeaderCell,
  Sn as DayView,
  Xt as ITEMS_FOCUS_ACTION,
  _e as ITEMS_SELECT_ACTION,
  ka as MonthView,
  rt as REMOVE_ITEM_ACTION,
  me as RESIZE_ITEM_ACTION,
  at as SERIES_ACTION,
  ye as SHOW_OCCURRENCE_DIALOG_ACTION,
  et as SHOW_REMOVE_DIALOG_ACTION,
  Le as SLOTS_FOCUS_ACTION,
  ha as SLOTS_SELECT_ACTION,
  Gl as Scheduler,
  Gr as SchedulerActiveViewContext,
  Br as SchedulerDataContext,
  $r as SchedulerDateContext,
  Vr as SchedulerDateRangeContext,
  Ol as SchedulerDrag,
  Rn as SchedulerEditItem,
  Qr as SchedulerEditItemDragItemContext,
  jr as SchedulerEditItemFormItemContext,
  Xr as SchedulerEditItemPropsContext,
  ea as SchedulerEditItemRemoveItemContext,
  Jr as SchedulerEditItemResizeItemContext,
  na as SchedulerEditItemShowOccurrenceDialogContext,
  ta as SchedulerEditItemShowRemoveDialogContext,
  an as SchedulerEditSlot,
  aa as SchedulerEditSlotFormItemContext,
  ra as SchedulerEditSlotPropsContext,
  Hl as SchedulerEditTask,
  pr as SchedulerFieldsContext,
  vc as SchedulerFooter,
  ga as SchedulerForm,
  Fl as SchedulerFormEditor,
  Hr as SchedulerGroupsContext,
  rl as SchedulerHeader,
  ln as SchedulerItem,
  kn as SchedulerItemContent,
  Ea as SchedulerOccurrenceDialog,
  Kr as SchedulerOrientationContext,
  Ki as SchedulerProportionalViewItem,
  Cn as SchedulerPropsContext,
  ya as SchedulerRemoveDialog,
  Pl as SchedulerResize,
  _l as SchedulerSlot,
  pl as SchedulerTask,
  bn as SchedulerViewItem,
  Ll as SchedulerViewSlot,
  Wl as SchedulerViewTask,
  Pr as SchedulerViewsContext,
  fa as TimeHeaderCell,
  Bl as TimelineView,
  Ul as WeekView,
  $l as WorkWeekView,
  Yr as useSchedulerActiveViewContext,
  Lt as useSchedulerDataContext,
  nl as useSchedulerDateContext,
  vt as useSchedulerDateRangeContext,
  cd as useSchedulerEditItemDragItemContext,
  od as useSchedulerEditItemFormItemContext,
  ld as useSchedulerEditItemPropsContext,
  id as useSchedulerEditItemRemoveItemContext,
  sd as useSchedulerEditItemResizeItemContext,
  ud as useSchedulerEditItemShowOccurrenceDialogContext,
  dd as useSchedulerEditItemShowRemoveDialogContext,
  hd as useSchedulerEditSlotFormItemContext,
  md as useSchedulerEditSlotPropsContext,
  Pe as useSchedulerFieldsContext,
  Mt as useSchedulerGroupsContext,
  Ur as useSchedulerOrientationContext,
  qe as useSchedulerPropsContext,
  tl as useSchedulerViewsContext
};
